{
  "admin.roles.title": "Berechtigungen & Rollen",
  "settings.sectionAccessManagement": "Zugriffsverwaltung",
  "admin.access.intro": "Wer darf was? Berechtigungen legen fest, welche Aktionen möglich sind. Rollen bündeln diese Berechtigungen. Erst eine Zuordnung macht sie für Personen wirksam.",
  "admin.access.permissionTitle": "Berechtigung · Was ist erlaubt?",
  "admin.access.permissionBody": "Eine vom System definierte Aktion, zum Beispiel Personen lesen oder bearbeiten. Hier verwendest du den vorhandenen Berechtigungskatalog.",
  "admin.access.roleTitle": "Rolle · Was gehört zusammen?",
  "admin.access.roleBody": "Ein benanntes Bündel von Berechtigungen. Du kannst eigene Rollen zusammenstellen. Eine neue Rolle allein gibt noch niemandem zusätzliche Rechte.",
  "admin.access.assignmentTitle": "Rollenzuordnung · Für wen und wo?",
  "admin.access.assignmentBody": "Eine Rolle wird mit einem Geltungsbereich einem Personenkreis (Segment) zugeordnet. Darüber erhalten dessen Mitglieder die enthaltenen Berechtigungen im jeweiligen Geltungsbereich.",
  "admin.access.rolesBody": "Sieh dir bestehende Rollen und ihre Berechtigungen an oder erstelle eine eigene Rolle. Noch nicht verwendete eigene Rollen kannst du bearbeiten und löschen. Systemrollen und bereits verwendete Rollen sind geschützt.",
  "admin.access.openRoles": "Berechtigungen & Rollen öffnen",
  "admin.access.assignmentOutlook": "Rollenzuordnungen folgen als nächster Bereich. Bestehende Zuordnungen kannst du bereits an der jeweiligen Rolle ansehen, hier aber noch nicht ändern.",
  "admin.access.featureBoundary": "Bereiche und Funktionen in Spark blendest du weiterhin über die Feature-Freigabeliste ein oder aus. Die Freigabe eines einzelnen Inhalts wird am Inhalt verwaltet.",
  "admin.roles.new": "Neue Rolle erstellen",
  "admin.roles.systemRoles": "Systemrollen",
  "admin.roles.customRoles": "Eigene Rollen",
  "admin.roles.permissions": "Berechtigungen",
  "admin.roles.listTitle": "Rollen",
  "admin.roles.addRole": "+ Neue Rolle",
  "admin.roles.resumeDraft": "Entwurf fortsetzen",
  "admin.roles.details": "Rollendetails",
  "admin.roles.readOnly": "Nur Ansicht",
  "admin.roles.edit": "Rolle bearbeiten",
  "admin.roles.delete": "Rolle löschen",
  "admin.roles.deleting": "Wird gelöscht …",
  "admin.roles.deleteConfirm": "„{name}“ unwiderruflich löschen? Die Rolle ist keinem Grant zugeordnet. Die Berechtigungen im Katalog bleiben erhalten.",
  "admin.roles.systemProtected": "Diese Rolle wird vom System bereitgestellt. Name und Berechtigungen sind festgelegt; sie kann hier nicht bearbeitet oder gelöscht werden.",
  "admin.roles.inUseProtected": "Diese Rolle wird bereits in einem Grant verwendet. Bearbeiten und Löschen sind deshalb derzeit gesperrt, damit bestehende Zugänge unverändert bleiben.",
  "admin.roles.assignments": "Zuordnungen",
  "admin.roles.membersIn": "Personen in {name}",
  "admin.roles.membersLoading": "Personen werden geladen …",
  "admin.roles.noMembers": "Keine gespeicherten Mitglieder vorhanden.",
  "admin.roles.unnamedPerson": "Person ohne Namen",
  "admin.roles.retry": "Erneut versuchen",
  "admin.roles.peopleCount": "{count, plural, one {# Person} other {# Personen}}",
  "admin.roles.noAssignments": "Noch keinem Personenkreis zugeordnet.",
  "admin.roles.noSegment": "Kein Personenkreis zugeordnet",
  "admin.roles.grantOnly": "Grant vorbereitet",
  "admin.roles.scope": "Geltungsbereich: {name}",
  "admin.roles.assignmentsHint": "Die Rolle gilt über diese Personenkreise. Die Gesamtzahl zählt gespeicherte Mitglieder jeweils einmal. Zuordnungen lassen sich hier noch nicht ändern.",
  "admin.roles.shown": "{shown} von {total} Berechtigungen",
  "admin.roles.noRoleResults": "Keine Berechtigungen für diese Ansicht gefunden.",
  "admin.roles.descriptionPlaceholder": "Wofür ist diese Rolle gedacht?",
  "admin.roles.noResults": "Keine passende Berechtigung gefunden. Deine Auswahl bleibt erhalten.",
  "admin.roles.clearSearch": "Suche zurücksetzen",
  "admin.roles.intro": "Eine Rolle bündelt Berechtigungen für eine Aufgabe. Hier siehst du vorhandene Rollen und kannst eigene Rollen zusammenstellen.",
  "admin.roles.name": "Rollenname",
  "admin.roles.namePlaceholder": "z. B. HR-Profilpflege",
  "admin.roles.description": "Beschreibung (optional)",
  "admin.roles.assignPermissions": "Was darf diese Rolle?",
  "admin.roles.search": "Berechtigungen durchsuchen",
  "admin.roles.selected": "{count, plural, one {# Berechtigung ausgewählt} other {# Berechtigungen ausgewählt}}",
  "admin.roles.unassigned": "Die Rolle ist zunächst niemandem zugewiesen. Personenkreis und Geltungsbereich werden später festgelegt.",
  "admin.roles.invalidFields": "Gib einen Rollennamen mit höchstens 120 Zeichen ein. Die Beschreibung darf höchstens 2.000 Zeichen enthalten.",
  "admin.roles.permissionsRequired": "Wähle vor dem Speichern mindestens eine verfügbare Berechtigung aus.",
  "admin.roles.loading": "Rollen und Berechtigungen werden geladen…",
  "admin.roles.created": "Rolle erstellt. Die zugewiesenen Berechtigungen sind gespeichert.",
  "admin.roles.existing": "Vorhandene Rollen",
  "admin.roles.empty": "Noch keine Rollen vorhanden. Erstelle eine Rolle mit den benötigten Berechtigungen.",
  "account.label": "Konto",
  "admin.accessConfig.audienceAnonymousBody": "Jede unregistrierte Person. Aktuell theoretisch: spark verlangt Login, bevor überhaupt jemand eine gesperrte Route erreicht.",
  "admin.accessConfig.audienceExternalBody": "Registrierte, aber nicht interne Personen, zum Beispiel externe Bewerber:innen.",
  "admin.accessConfig.audienceInfoLabel": "Wer ist {audience}?",
  "admin.accessConfig.audienceInternalBody": "Angemeldete Mitarbeitende deines Unternehmens.",
  "admin.accessConfig.belowFloorHint": "Unterhalb der Mindest-Sichtbarkeit dieses Features, wird vom Server abgelehnt.",
  "admin.accessConfig.belowFloorLabel": "{label} (unterhalb der Mindest-Sichtbarkeit des Features)",
  "admin.accessConfig.collapseGroupLabel": "{feature} einklappen",
  "admin.accessConfig.expandGroupLabel": "{feature} ausklappen",
  "admin.accessConfig.feature": "Feature",
  "admin.accessConfig.featureLabel.powersSource": "Powers Quelle",
  "admin.accessConfig.featuresIntro": "Welche Zielgruppen welches Feature erreichen. Nur additiv: eine leere Zeile blendet das Feature für alle aus.",
  "admin.accessConfig.featuresTitle": "Feature-Freigabeliste",
  "admin.accessConfig.requiresParentHint": "Setzt voraus, dass {parent} für diese Zielgruppe aktiviert ist.",
  "admin.accessConfig.requiresParentLabel": "{label} (setzt voraus, dass {parent} für diese Zielgruppe aktiviert ist)",
  "admin.accessConfig.toggleLabel": "{feature} für {audience}",
  "admin.accessConfig.uiOnlyBadgeHint": "Für dieses Feature existiert kein serverseitiger Schutz. Der Schalter hier blendet nur den Navigationseintrag in spark ein oder aus, genesis verweigert die dahinterliegenden Daten nicht. Übergangslösung, bis dieses Feature einen eigenen serverseitigen Schutz bekommt.",
  "admin.accessConfig.uiOnlyBadgeLabel": "spark-seitig",
  "admin.addAnswer": "Antwort",
  "admin.addQuestion": "Frage hinzufügen",
  "admin.addToGroupLabel": "Fragebogen hinzufügen",
  "admin.addToGroupPlaceholder": "Fragebogen wählen",
  "admin.answerPlaceholder": "Antwortoption",
  "admin.applyPosition": "Übernehmen",
  "admin.assignmentImmediateHint": "Änderungen hier wirken sofort, unabhängig vom Speichern.",
  "admin.changesSaved": "Änderungen gespeichert.",
  "admin.collapseList": "Liste einklappen",
  "admin.confirmDeleteQ": "Fragebogen löschen?",
  "admin.confirmRemoveFromGroup": "Aus der Gruppe entfernen? Er verliert seine Position, und seine Antworten zählen nicht mehr in die Auswertung dieser Gruppe.",
  "admin.defaultPowerLabel": "Standard-Power (optional)",
  "admin.deleteGroup": "Gruppe löschen",
  "admin.deleteGroupMessage": "Löscht nur die Gruppe. {count, plural, =0 {Sie enthält keine Fragebögen.} one {Ihr # Fragebogen bleibt erhalten und verliert Gruppe und Position.} other {Ihre # Fragebögen bleiben erhalten und verlieren Gruppe und Position.}} Bereits gegebene Antworten bleiben unberührt.",
  "admin.deleteGroupTitle": "„{name}“ löschen?",
  "admin.expandListNamed": "{title} anzeigen",
  "admin.groupAssignmentTitle": "Zuordnung",
  "admin.groupDescriptionDeLabel": "Beschreibung (Deutsch)",
  "admin.groupDescriptionEnLabel": "Beschreibung (Englisch)",
  "admin.groupDescriptionHint": "Steht in Grow auf der Kachel und über der Gruppe. Die Kachel schneidet den Text ab, ziele also auf etwa {max} Zeichen.",
  "admin.groupImageAlt": "Kachelbild der Gruppe",
  "admin.groupImageDrop": "Bild hierher ziehen oder klicken",
  "admin.groupImageHint": "Etwa 16:10, flächiges Motiv, kein Text und keine feinen Details. Die Kachel zeigt es klein und scharf.",
  "admin.groupImageLabel": "Kachelbild",
  "admin.groupImageLimit": "Max. {max} MB, PNG, JPEG, GIF, BMP, TIFF oder WebP",
  "admin.groupImageRemove": "Bild entfernen",
  "admin.groupImageRemoveConfirm": "Bild entfernen? Die Kachel fällt auf die generierte Grafik zurück.",
  "admin.groupImageReplace": "Ersetzen",
  "admin.groupImageTooLarge": "Zu groß (max. {max} MB): {name}",
  "admin.groupImageUnsupported": "Dateityp nicht unterstützt: {name}",
  "admin.groupItemCount": "{count, plural, one {# Frage} other {# Fragen}}",
  "admin.groupLabel": "Gruppe",
  "admin.groupMembersTitle": "Fragebögen in dieser Gruppe",
  "admin.groupNameDeLabel": "Name (Deutsch)",
  "admin.groupNameEnLabel": "Name (Englisch)",
  "admin.groupNamePlaceholder": "z.B. Power Quiz",
  "admin.groupNoMembers": "Noch kein Fragebogen zugeordnet.",
  "admin.groupPositionHint": "Wo die Gruppe selbst in Grow · Play steht.",
  "admin.groupPositionLabel": "Position in Grow · Play",
  "admin.groupValidationHint": "Ein Name auf Deutsch und Englisch ist erforderlich.",
  "admin.inGroupOption": "{name} (in {group})",
  "admin.instructionsLabel": "Instruktionen (optional)",
  "admin.instructionsPlaceholder": "Hinweis für die ausfüllende Person",
  "admin.memberPositionLabel": "Position in der Gruppe",
  "admin.moveDown": "Nach unten",
  "admin.moveUp": "Nach oben",
  "admin.nameLabel": "Name",
  "admin.namePlaceholder": "z.B. Empathie-Check",
  "admin.newGroup": "+ Neue Gruppe",
  "admin.newGroupTitle": "Neue Gruppe",
  "admin.newQuestionnaire": "+ Neuer Fragebogen",
  "admin.noQuestionnaires": "Noch keine Fragebögen.",
  "admin.nonePlaceholder": "Keine",
  "admin.notVisibleInGrow": "Nicht im Grow-Play-Katalog.",
  "admin.publishAnyway": "Trotzdem veröffentlichen",
  "admin.publishEmptyMessage": "Diese Gruppe hat keinen aktiven Fragebogen. Auch nach dem Veröffentlichen hat der Katalog keine Kachel zu zeigen.",
  "admin.publishEmptyTitle": "Ohne aktiven Fragebogen veröffentlichen?",
  "admin.publishGroup": "Veröffentlichen",
  "admin.qTitle": "Fragebögen",
  "admin.questionPlaceholder": "Frage / Aussage",
  "admin.referenceData.saveFailed": "Der Eintrag konnte nicht gespeichert werden.",
  "admin.rehomeConfirm": "Umhängen",
  "admin.rehomeFromMessage": "„{name}“ wandert aus „{from}“ nach „{to}“, ans Ende der Reihenfolge. Bereits gegebene Antworten wandern mit und zählen ab sofort in die Auswertung von „{to}“.",
  "admin.rehomeMessage": "„{name}“ wird ans Ende von „{to}“ gestellt. Bereits gegebene Antworten zählen ab sofort in die Auswertung von „{to}“.",
  "admin.rehomeTitle": "„{name}“ umhängen?",
  "admin.removeAnswer": "Antwort entfernen",
  "admin.removeQuestion": "Frage entfernen",
  "admin.selectOrCreate": "Wähle links eine Gruppe oder einen Fragebogen oder lege etwas Neues an.",
  "admin.selectPower": "Power wählen",
  "admin.selectionGone": "Dieser Eintrag existiert nicht mehr. Wähle links einen anderen.",
  "admin.statusActive": "Aktiv",
  "admin.statusDeleted": "Gelöscht",
  "admin.statusDraft": "Entwurf",
  "admin.statusInactive": "Inaktiv",
  "admin.statusLabel": "Status",
  "admin.statusPublished": "Veröffentlicht",
  "admin.toggleGroupCollapsed": "{state, select, collapsed {{name} ausklappen} other {{name} einklappen}}",
  "admin.ungroupMessage": "„{name}“ verlässt „{from}“ und verliert seine Position. Seine Antworten zählen nicht mehr in die Auswertung von „{from}“.",
  "admin.ungroupTitle": "„{name}“ aus der Gruppe entfernen?",
  "admin.ungrouped": "Ohne Gruppe",
  "admin.unpublishGroup": "Zurückziehen",
  "admin.unpublishMessage": "Die Gruppe verschwindet aus dem Grow-Play-Katalog. Bereits gegebene Antworten bleiben erhalten und zählen weiter in die Auswertung.",
  "admin.unpublishTitle": "„{name}“ zurückziehen?",
  "admin.validationHint": "Name, je Frage Text + Power und je Antwort Text erforderlich.",
  "admin.weightLabel": "Gewicht",
  "admin.yesDelete": "Ja, löschen",
  "admin.yesRemove": "Ja, entfernen",
  "adminSettings.appearance.accentHint": "Accent · Buttons, Highlights",
  "adminSettings.appearance.accentLabel": "Signalfarbe",
  "adminSettings.appearance.bgHint": "Basis · Page",
  "adminSettings.appearance.bgLabel": "Hintergrund",
  "adminSettings.appearance.openPicker": "Color-Picker öffnen",
  "adminSettings.appearance.presetsFor": "Presets für {label}",
  "adminSettings.appearance.reset": "↺ Auf Default zurücksetzen",
  "adminSettings.appearance.sub": "Hintergrund, Boxen und Signalfarbe steuern die App. Text wird automatisch schwarz oder weiß gesetzt.",
  "adminSettings.appearance.surfaceHint": "Karten · Surfaces",
  "adminSettings.appearance.surfaceLabel": "Boxen",
  "adminSettings.appearance.title": "Palette",
  "adminSettings.branding.appName": "App-Name",
  "adminSettings.branding.appNameHint": "Wird oben links angezeigt. Leer fällt auf „smycles“ zurück.",
  "adminSettings.branding.appNamePlaceholder": "smycles",
  "adminSettings.branding.linkPicker.displayText": "Anzeigetext",
  "adminSettings.branding.linkPicker.insert": "Einfügen",
  "adminSettings.branding.linkPicker.page.growPlay": "Grow · Play",
  "adminSettings.branding.linkPicker.page.home": "Home",
  "adminSettings.branding.linkPicker.page.match": "Match",
  "adminSettings.branding.linkPicker.page.share": "Share",
  "adminSettings.branding.linkPicker.searchPlaceholder": "Nach Name suchen …",
  "adminSettings.branding.linkPicker.shareItem": "Bestimmtes Share-Item …",
  "adminSettings.branding.linkPicker.trigger": "Link einfügen",
  "adminSettings.branding.linkPicker.unnamedShareItem": "Unbenanntes Share-Item",
  "adminSettings.branding.paletteNote": "Die Palette unten wird live übernommen; ungespeicherte Änderungen erscheinen im Speichern-Balken und werden beim Speichern plattformweit übernommen.",
  "adminSettings.branding.sub": "App-Name und Farbpalette. Gilt plattformweit.",
  "adminSettings.branding.title": "Branding",
  "adminSettings.emailTemplates.body": "Inhalt",
  "adminSettings.emailTemplates.defaultActive": "Aktuell ist der Standard aktiv.",
  "adminSettings.emailTemplates.empty": "Es sind keine E-Mail-Vorlagen verfügbar.",
  "adminSettings.emailTemplates.kind.INVITATION": "Einladung",
  "adminSettings.emailTemplates.loading": "Wird geladen…",
  "adminSettings.emailTemplates.placeholderRequired": "{token} (erforderlich)",
  "adminSettings.emailTemplates.placeholders": "Verfügbare Platzhalter: {tokens}",
  "adminSettings.emailTemplates.previewApproximationHint": "Diese Vorschau ist eine Annäherung. Das endgültige Erscheinungsbild bestimmen Keycloak und das E-Mail-Programm des Empfängers.",
  "adminSettings.emailTemplates.previewEmptyBody": "Kein Inhalt.",
  "adminSettings.emailTemplates.previewEmptySubject": "Kein Betreff.",
  "adminSettings.emailTemplates.previewLabel": "E-Mail-Vorschau",
  "adminSettings.emailTemplates.previewLink": "Individueller Einladungslink",
  "adminSettings.emailTemplates.realmWideHint": "Dieser Text gilt für alle Keycloak-Aktionsmails im Realm, auch für Zurücksetzungen von Zugangsdaten aus der Admin Console.",
  "adminSettings.emailTemplates.reset": "Standard verwenden",
  "adminSettings.emailTemplates.storageDisabled": "Die Bearbeitung von E-Mail-Vorlagen ist auf diesem Server nicht aktiviert. Die Vorlage wird nur angezeigt.",
  "adminSettings.emailTemplates.storageUnavailable": "Der Vorlagenspeicher ist derzeit nicht erreichbar. Die Vorlage wird nur angezeigt, gespeicherte Änderungen sind möglicherweise nicht sichtbar.",
  "adminSettings.emailTemplates.sub": "Betreff und Inhalt für die nächste System-Mail.",
  "adminSettings.emailTemplates.subject": "Betreff",
  "adminSettings.emailTemplates.title": "E-Mail-Vorlagen",
  "adminSettings.emailTemplates.validation.applicationNameSingleLine": "Der App-Name muss aus genau einer Zeile bestehen. Ändere ihn in den Systemeinstellungen.",
  "adminSettings.emailTemplates.validation.bodyTooLong": "Der Inhalt darf nach dem Einsetzen des App-Namens höchstens {max} Zeichen enthalten.",
  "adminSettings.emailTemplates.validation.linkInSubject": "Der Platzhalter {token} ist im Betreff nicht erlaubt.",
  "adminSettings.emailTemplates.validation.requiredPlaceholder": "Der Inhalt muss den erforderlichen Platzhalter {token} enthalten.",
  "adminSettings.emailTemplates.validation.reservedSequence": "Die Vorlage enthält eine nicht unterstützte Steuersequenz.",
  "adminSettings.emailTemplates.validation.subjectSingleLine": "Der Betreff muss aus genau einer Zeile bestehen.",
  "adminSettings.emailTemplates.validation.subjectTooLong": "Der Betreff darf nach dem Einsetzen des App-Namens höchstens {max} Zeichen enthalten.",
  "adminSettings.emailTemplates.validation.unknownPlaceholder": "Der Platzhalter {token} wird nicht unterstützt.",
  "adminSettings.emailTemplates.viewEditor": "Editor",
  "adminSettings.emailTemplates.viewLabel": "Vorlagenansicht",
  "adminSettings.emailTemplates.viewPreview": "Vorschau",
  "adminSettings.branding.welcomeMessage": "Welcome-Hinweis",
  "adminSettings.branding.welcomeMessageHint": "Unterstützt Links: [Text](/pfad). Alles andere wird als reiner Text angezeigt.",
  "adminSettings.branding.welcomeMessagePlaceholder": "Wird als schließbarer Hinweis auf der Home-Seite angezeigt.",
  "adminSettings.hrPrompt.defaultActive": "Aktuell ist der Genesis-Standard aktiv.",
  "adminSettings.hrPrompt.hint": "Der Platzhalter '{{responseLanguage}}' wird automatisch ersetzt. Eine Match-Ergänzung steht im kombinierten Prompt zuletzt und hat bei Konflikten Vorrang.",
  "adminSettings.hrPrompt.label": "Globaler HR-Basis-Prompt",
  "adminSettings.hrPrompt.reset": "Genesis-Standard verwenden",
  "adminSettings.hrPrompt.sub": "Zentrale Recruiter-Anweisung für alle Prüf-Matches. Match-spezifische Ergänzungen werden danach angefügt.",
  "adminSettings.hrPrompt.title": "HR-Prompt",
  "agent.back": "Zurück zu Chats",
  "agent.chatsEmpty": "Noch keine Chats. Starte oben einen neuen.",
  "agent.chatsError": "Chats konnten nicht geladen werden.",
  "agent.chatsLoading": "Lädt…",
  "agent.close": "Schließen",
  "agent.closeImage": "Bild schließen",
  "agent.contextBreak": "Neues Kontextfenster",
  "agent.deleteChat": "Chat löschen",
  "agent.deleteMessage": "Diese Unterhaltung wird dauerhaft gelöscht.",
  "agent.deleteTitle": "Chat löschen?",
  "agent.empty": "Frag den Assistenten zu Personen, Profilen und mehr.",
  "agent.attach.button": "Dokument anhängen",
  "agent.attach.cancel": "Abbrechen",
  "agent.attach.drop": "Zum Anhängen an diesen Chat ablegen",
  "agent.attach.prompt": "„{name}“ anhängen?",
  "agent.attach.remove": "Anhang entfernen",
  "agent.attach.status.error": "Upload fehlgeschlagen",
  "agent.attach.status.failed": "fehlgeschlagen",
  "agent.attach.status.pending": "in Warteschlange",
  "agent.attach.status.processing": "wird verarbeitet…",
  "agent.attach.status.ready": "bereit",
  "agent.attach.status.uploading": "wird hochgeladen…",
  "agent.attach.textOnly": "Hochladen (nur Text)",
  "agent.attach.unavailable": "Für das aktuelle Modell nicht verfügbar",
  "agent.attach.unavailableHint": "Nicht für das aktive Modell eingebettet. Entfernen und erneut hochladen, um es zu nutzen.",
  "agent.attach.withImages": "Mit Bildern hochladen",
  "agent.attach.withoutImages": "Ohne Bilder hochladen",
  "agent.error": "Assistent nicht erreichbar. Bitte erneut versuchen.",
  "agent.expandImage": "In voller Größe anzeigen",
  "agent.input": "Assistenten-Eingabe",
  "agent.jumpToLatest": "Zum Neuesten springen",
  "agent.newChat": "Neuer Chat",
  "agent.personInfo.heading": "Profil",
  "agent.personInfo.label": "Vollständiges Profil laden",
  "agent.placeholder": "Frag den Assistenten…",
  "agent.send": "Senden",
  "agent.starters.growth.0": "Welche Fähigkeiten sollte ich als Nächstes entwickeln?",
  "agent.starters.growth.1": "Welche Rollen passen zu meiner Erfahrung?",
  "agent.starters.growth.2": "Wohin kann ich mich von hier entwickeln?",
  "agent.starters.growth.3": "Welche Erfahrung fehlt mir für Senior-Rollen?",
  "agent.starters.growth.4": "Schlage mir einen Lernpfad vor",
  "agent.starters.growth.5": "Welche Fähigkeiten sind am gefragtesten?",
  "agent.starters.growth.6": "Auf welche Stärken kann ich aufbauen?",
  "agent.starters.growth.7": "Vergleiche mein Profil mit einer Zielrolle",
  "agent.starters.growth.8": "Welche Lücken halten mich zurück?",
  "agent.starters.growth.9": "Empfiehl nächste Schritte für meine Karriere",
  "agent.starters.match.0": "Zeig meine letzten Matches",
  "agent.starters.match.1": "Welche Suchoptionen gibt es?",
  "agent.starters.match.2": "Zeig Details meines neuesten Matches",
  "agent.starters.match.3": "Zähle meine Matches",
  "agent.starters.match.4": "Finde ein Match nach Namen",
  "agent.starters.match.5": "Welches Match habe ich zuletzt aktualisiert?",
  "agent.starters.match.6": "Suche nach einer Person",
  "agent.starters.match.7": "Zeig die Kandidaten meines neuesten Matches",
  "agent.starters.match.8": "Wonach kann ich suchen?",
  "agent.starters.match.9": "Liste Matches aus diesem Monat auf",
  "agent.starters.save.0": "Zeig mein Profil",
  "agent.starters.save.1": "Welche Fähigkeiten stehen in meinem Profil?",
  "agent.starters.save.2": "Welche Sprachen habe ich?",
  "agent.starters.save.3": "Welche Erfahrung steht in meinem Profil?",
  "agent.starters.save.4": "Fasse mein Profil zusammen",
  "agent.starters.save.5": "Was ist meine aktuelle Position?",
  "agent.starters.save.6": "Liste meine Ausbildung auf",
  "agent.starters.save.7": "Bei welchen Unternehmen habe ich gearbeitet?",
  "agent.starters.save.8": "Was ist mein stärkster Kompetenzbereich?",
  "agent.starters.save.9": "Zeig meine Kontaktdaten",
  "agent.starters.share.0": "Liste meine geteilten Inhalte auf",
  "agent.starters.share.1": "Zeig meinen neuesten Share",
  "agent.starters.share.2": "Fasse meine geteilten Projekte zusammen",
  "agent.starters.share.3": "Zeig meine öffentlichen Shares",
  "agent.starters.share.4": "Zeig meine privaten Shares",
  "agent.starters.share.5": "Liste auf, was ich diesen Monat geteilt habe",
  "agent.starters.share.6": "Zeig Details meines neuesten Shares",
  "agent.starters.share.7": "Finde einen geteilten Inhalt nach Namen",
  "agent.starters.share.8": "Liste mit dem Team geteilte Inhalte auf",
  "agent.starters.share.9": "Liste meine geteilten Projekte auf",
  "agent.title": "Assistent",
  "agent.tour.back": "Zurück",
  "agent.tour.buttonHint.back": "Zurück: zeigt den vorherigen Schritt noch einmal.",
  "agent.tour.buttonHint.next": "Weiter: springt sofort zum nächsten Schritt.",
  "agent.tour.buttonHint.pause": "Pause: hält die Tour an, Fragen sind willkommen.",
  "agent.tour.buttonHint.skipSection": "Bereich überspringen: wechselt zum nächsten Bereich.",
  "agent.tour.buttonHint.stop": "Tour beenden oder Esc: beendet die Tour.",
  "agent.tour.chipHome": "Hauptseite",
  "agent.tour.continue": "Fortsetzen",
  "agent.tour.escHint": "_Nutze die Buttons unter dem Chat: zurück, Pause, weiter und Bereich überspringen. Drücke jederzeit **Esc** oder den Stopp-Button, um die Tour zu beenden._",
  "agent.tour.finished": "Das war das Ende der Tour. Frag mich gern alles zu dem, was du gesehen hast!",
  "agent.tour.mobileNotice": "Touren heben Elemente auf der Seite neben dem Chat hervor und brauchen dafür einen größeren Bildschirm. Probiere es bitte in einem Desktop-Fenster.",
  "agent.tour.modeActive": "Tour-Modus",
  "agent.tour.modeFinished": "Tour beendet. Klicke einen Abschnitt oder gehe zurück zum Ansehen; Stopp beendet.",
  "agent.tour.modePaused": "Tour pausiert. Du kannst jetzt Fragen stellen.",
  "agent.tour.next": "Weiter",
  "agent.tour.next.heading": "Jetzt probiere es selbst aus:",
  "agent.tour.next.linkedin": "Importiere deine Daten über LinkedIn",
  "agent.tour.next.match": "Erstelle ein Match",
  "agent.tour.next.profile": "Fülle dein Profil aus",
  "agent.tour.next.project": "Erstelle ein Projekt",
  "agent.tour.next.quiz": "Mache ein Power-Quiz",
  "agent.tour.noTour": "Für diese Seite gibt es noch keine Tour.",
  "agent.tour.pause": "Pause",
  "agent.tour.pillar.grow": "GROW ist dein Power-Spielplatz: Schätze deine 30 Powers ein, schau Lerninhalte und spiele dich zu einem schärferen Profil.",
  "agent.tour.pillar.home": "Das Smycles-Logo bringt dich immer zur Hauptseite: deinem Dashboard mit den aktuellen Zahlen aus allen Bereichen.",
  "agent.tour.pillar.match": "MATCH baut Teams: Du definierst die Anforderungen, der Solver findet die passenden Leute.",
  "agent.tour.pillar.save": "SAVE ist dein persönlicher Datentresor: dein Profil, deine Lebenslauf-Einträge, Dokumente, Kontakte und deine Pinnwand.",
  "agent.tour.pillar.share": "SHARE ist der Community-Feed: Veröffentliche Projekte und Beiträge, gewinne Interessierte und sammle Feedback.",
  "agent.tour.questionContinue": "Alles zeigen",
  "agent.tour.questionFinish": "Tour beenden",
  "agent.tour.sectionQuestion": "Soll ich dir zuerst einen Bereich zeigen? Wähle ihn unter dem Chat aus, sonst stelle ich die Hauptseite und jeden Bereich der Reihe nach vor.",
  "agent.tour.sectionQuestionNext": "Dieser Bereich ist fertig. Soll ich dir noch einen zeigen? Wähle ihn unter dem Chat aus, sonst endet die Tour hier.",
  "agent.tour.sectionsIntro": "Ich zeige dir kurz die Bereiche, bevor wir ins Detail gehen.",
  "agent.tour.skipSection": "Bereich überspringen",
  "agent.tour.starterChip": "Zeig mir diese Seite",
  "agent.tour.starterChipAll": "Zeig mir die App",
  "agent.tour.stop": "Tour beenden",
  "agent.tour.topbar.assistant": "Der KI-Assistent: Dieser Button öffnet und schließt den Chat, den du gerade liest.",
  "agent.tour.topbar.chat": "Nachrichten: Direkte Chats mit deinen Kontakten.",
  "agent.tour.topbar.notifications": "Benachrichtigungen: Einladungen, Updates und Aktivität rund um dich landen hier.",
  "agent.tour.topbar.search": "Die globale Suche: Finde Personen, Projekte und Beiträge von überall in der App.",
  "agent.tour.topbar.user": "Dein Konto: Klick auf deinen Namen für Profilmenü, Einstellungen und Logout.",
  "agent.tour.welcome": "Willkommen im Smycles System. Diese Tour stellt die wichtigen Funktionalitäten vor. Die Knöpfe unter dem Chat steuern die Tour. Du kannst auch jeden Chat-Schnipsel anklicken, um zu seiner Stelle zurückzuspringen.",
  "agent.untitled": "Unbenannter Chat",
  "auth.redirecting": "Weiterleitung zum Login…",
  "auth.sessionExpired.body": "Sie wurden abgemeldet, weil die Sitzung ihr Zeitlimit erreicht hat. Änderungen werden nicht mehr gespeichert. Melden Sie sich erneut an, um dort weiterzumachen, wo Sie aufgehört haben.",
  "auth.sessionExpired.bodyTokensLost": "Sie wurden abgemeldet. Änderungen werden nicht mehr gespeichert. Melden Sie sich erneut an, um dort weiterzumachen, wo Sie aufgehört haben.",
  "auth.sessionExpired.signIn": "Erneut anmelden",
  "auth.sessionExpired.title": "Sitzung beendet",
  "chat.closeChat": "Chat schließen",
  "chat.deleteChat": "Chat löschen",
  "chat.deleteChatConfirm": "Diese Unterhaltung wirklich löschen?",
  "chat.liveUpdatesUnavailable": "Live-Updates nicht verfügbar",
  "chat.messageInput": "Nachrichteneingabe",
  "chat.messages": "Nachrichten",
  "chat.minimize": "Minimieren",
  "chat.more": "Mehr",
  "chat.newConversation": "Neue Unterhaltung",
  "chat.noConversationsYet": "Noch keine Unterhaltungen",
  "chat.online": "Online",
  "chat.openMessages": "Nachrichten",
  "chat.searchChats": "Chats durchsuchen…",
  "chat.searchEnd": "{count} Ergebnisse",
  "chat.searchHint": "Mindestens {n} Zeichen eingeben",
  "chat.searchPeople": "Personen suchen…",
  "chat.seen": "Gesehen",
  "chat.sendMessage": "Nachricht senden",
  "chat.typing": "tippt…",
  "chat.unreadMessages": "{count} ungelesen",
  "chat.writeMessage": "Nachricht schreiben…",
  "chat.you": "Du",
  "cockpit.dismiss": "Verwerfen",
  "cockpit.dismissAll": "Alle verwerfen",
  "cockpit.dismissAllMessage": "Das leert deine Benachrichtigungen und kann nicht rückgängig gemacht werden. Benachrichtigungen, die noch auf deine Antwort warten, bleiben erhalten.",
  "cockpit.dismissAllTitle": "Alle Benachrichtigungen verwerfen?",
  "cockpit.jobActive": "Aktiv",
  "cockpit.noNotifications": "Keine Benachrichtigungen",
  "cockpit.notifications": "Benachrichtigungen",
  "cockpit.showMoreDocuments": "{count} weitere anzeigen",
  "cockpit.unread": "ungelesen",
  "comments.delete.body": "Der Kommentar wird endgültig entfernt. Das lässt sich nicht rückgängig machen.",
  "comments.delete.title": "Kommentar löschen?",
  "comments.discard.body": "Die ungespeicherten Änderungen an diesem Kommentar verwerfen?",
  "common.add": "Hinzufügen",
  "common.back": "Zurück",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.comingSoon": "Demnächst verfügbar",
  "common.confirm": "Bestätigen",
  "common.create": "Erstellen",
  "common.delete": "Löschen",
  "common.deleteFailed": "Löschen fehlgeschlagen.",
  "common.discard": "Verwerfen",
  "common.duplicateName": "Es existiert bereits ein Eintrag mit diesem Namen. Bitte einen anderen Namen wählen.",
  "common.edit": "Bearbeiten",
  "common.errorWithMessage": "Fehler: {message}",
  "common.fileDrop.overlay": "Zum Hochladen ablegen …",
  "common.fileDrop.zone": "Datei hier ablegen oder klicken",
  "common.loadMore": "Mehr laden",
  "common.loading": "Laden…",
  "common.loadingMore": "Lädt…",
  "common.next": "Weiter",
  "common.nextPage": "Weiter",
  "common.noBackend": "Kein Backend-Endpunkt",
  "common.noResults": "Keine Ergebnisse gefunden",
  "common.notFound": "Nicht gefunden",
  "common.notFoundBody": "Die gesuchte Seite existiert nicht.",
  "common.pageOf": "Seite {page} von {total}",
  "common.prevPage": "Zurück",
  "common.remove": "Entfernen",
  "common.reset": "Zurücksetzen",
  "common.save": "Speichern",
  "common.saveFailed": "Speichern fehlgeschlagen.",
  "common.saving": "Speichern…",
  "common.serverError": "Etwas ist schiefgelaufen. Bitte versuch es erneut.",
  "common.serverErrorWithCode": "Etwas ist schiefgelaufen. Bitte versuch es erneut. (Fehlercode {code})",
  "common.share.ariaActive": "Teilen aktiv",
  "common.share.ariaAllOff": "Alle privat",
  "common.share.ariaAllOn": "Alle teilen",
  "common.share.ariaInactive": "Nicht teilen",
  "common.share.off": "Privat",
  "common.share.on": "Teilen",
  "common.tryAgain": "Erneut versuchen",
  "common.undo": "Rückgängig",
  "common.unsavedChanges": "Nicht gespeicherte Änderungen",
  "community.tour.contacts.desc": "{count} Kontakte in der aktuellen Ansicht. Klicke eine Karte, um das Profil zu öffnen, nutze „+ Hinzufügen“, um sie in Communities einzuordnen, oder ziehe sie links auf eine Community.",
  "community.tour.contacts.title": "Deine Kontakte",
  "community.tour.controls.desc": "Suche Kontakte nach Namen, ändere die Sortierung oder filtere auf Kontakte, die noch in keiner Community sind.",
  "community.tour.controls.title": "Suchen & Sortieren",
  "community.tour.groups.desc": "{count} Communities, um deine Kontakte zu gruppieren. Klicke eine an, um ihre Mitglieder zu sehen, lege neue über „+ Community“ an und ziehe eine Kontaktkarte auf eine Community, um sie hinzuzufügen.",
  "community.tour.groups.title": "Deine Communities",
  "community.tour.label": "Save Community",
  "community.tour.summary": "Das ist deine Community-Seite: {contacts} Kontakte, organisiert in {groups} Communities.",
  "company.admin.competencies.blank": "Ein Fachwissen braucht einen Namen. Gib ihm einen oder entferne es.",
  "company.admin.competencies.duplicate": "Dieses Unternehmen listet das Fachwissen „{label}“ bereits.",
  "company.admin.competencies.label": "Fachwissen",
  "company.admin.competencies.labelPlaceholder": "z. B. Regulatory Affairs",
  "company.admin.competencies.listFull": "Dieses Unternehmen listet bereits {max, number} Fachwissen-Einträge; mehr sind nicht möglich. Entferne einen, um einen weiteren hinzuzufügen.",
  "company.admin.competencies.pendingAddNamed": "„{label}“ wird beim Speichern hinzugefügt.",
  "company.admin.competencies.pendingEditNamed": "„{label}“ wird beim Speichern neu geschrieben.",
  "company.admin.competencies.pendingRemoveNamed": "„{label}“ wird beim Speichern entfernt.",
  "company.admin.competencies.tooLong": "Fachwissen darf höchstens {max, number} Zeichen lang sein.",
  "company.admin.done": "Bearbeitung beenden",
  "company.admin.edit": "Unternehmen bearbeiten",
  "company.admin.error.alreadyMember": "Diese Person ist bereits bei diesem Unternehmen eingetragen.",
  "company.admin.error.cannotAdminister": "Das Konto dieser Person ist nicht aktiv, daher kann sie kein Unternehmen verwalten. Wähle jemanden mit einem aktiven Konto.",
  "company.admin.error.employeeCount": "Die Mitarbeitendenzahl muss eine ganze Zahl ab 0 sein.",
  "company.admin.error.expertiseAlreadyListed": "„{label}“ ist bereits gelistet und kann kein zweites Mal hinzugefügt werden. Entferne den vorhandenen Eintrag, wenn du ein anderes Niveau vergeben willst.",
  "company.admin.error.expertiseListFull": "Dieses Unternehmen listet bereits {max, number} Fachwissen-Einträge; mehr sind nicht möglich. Entferne einen, um einen weiteren hinzuzufügen.",
  "company.admin.error.expertiseTooLong": "Fachwissen darf höchstens {max, number} Zeichen lang sein. Kürze es und füge es erneut hinzu.",
  "company.admin.error.lastAdmin": "Ein Unternehmen braucht mindestens eine Administration. Mache zuerst jemand anderen zur Administration.",
  "company.admin.error.logoRefused": "Das Logo wurde abgelehnt. Es muss ein PNG-, JPEG-, GIF-, BMP-, TIFF- oder WebP-Bild von höchstens {max, number} MB sein.",
  "company.admin.error.nameRequired": "Ein Unternehmensname ist erforderlich.",
  "company.admin.error.nameTooLong": "Der Unternehmensname darf höchstens {max, number} Zeichen lang sein.",
  "company.admin.error.notAdmin": "Du verwaltest dieses Unternehmen nicht mehr. Lade die Seite neu, um zu sehen, was du noch tun kannst.",
  "company.admin.error.saveProfile": "Das Unternehmen konnte nicht gespeichert werden.",
  "company.admin.error.summaryTooLong": "Der Text unter Über uns darf höchstens {max, number} Zeichen lang sein.",
  "company.admin.error.tooManyContactPersons": "Ein Unternehmen kann höchstens {max, number} Ansprechpartner:innen haben. Jemand anderes hat gerade den letzten Platz belegt. Entferne eine Markierung, um diese Person zu markieren.",
  "company.admin.field.employeeCount": "Mitarbeitende",
  "company.admin.field.industry": "Branche",
  "company.admin.field.industryNoResults": "Keine Branche passt",
  "company.admin.field.industryPlaceholder": "Keine Branche",
  "company.admin.field.industrySearch": "Branchen suchen",
  "company.admin.field.name": "Name",
  "company.admin.field.summary": "Über uns",
  "company.admin.logo.change": "Unternehmenslogo ändern",
  "company.admin.logo.choose": "Unternehmenslogo hochladen",
  "company.admin.logo.saved": "Logo gespeichert.",
  "company.admin.logo.tooLarge": "{name} ist zu groß. Ein Logo darf höchstens {max, number} MB haben.",
  "company.admin.logo.tooManyPixels": "Dieses Bild ist zu groß zum Zuschneiden. Nutze eines unter {max} Megapixel.",
  "company.admin.logo.unreadable": "Diese Datei konnte nicht gelesen werden. Wähle sie noch einmal aus.",
  "company.admin.logo.unsupported": "{name} kann nicht als Logo verwendet werden. Wähle ein PNG-, JPEG-, GIF-, BMP-, TIFF- oder WebP-Bild.",
  "company.admin.members.add": "Zum Unternehmen hinzufügen",
  "company.admin.members.addHint": "Setzt eine bestehende Person auf die Liste. Sie wird nicht vorher gefragt, und gespeichert wird erst beim Speichern.",
  "company.admin.members.addTitle": "Person hinzufügen",
  "company.admin.members.contactPerson": "Ansprechpartner:in",
  "company.admin.members.contactPersonLimit": "Alle {max, number} Ansprechpartner:innen sind markiert. Entferne eine Markierung, um jemand anderen zu markieren.",
  "company.admin.members.noPeople": "Niemand passt, der nicht schon eingetragen ist.",
  "company.admin.members.pendingAdd": "Wird beim Speichern hinzugefügt.",
  "company.admin.members.pendingContact": "Die Markierung als Ansprechpartner:in gilt ab dem Speichern.",
  "company.admin.members.pendingRemove": "Wird beim Speichern entfernt.",
  "company.admin.members.pendingRole": "Die neue Rolle gilt ab dem Speichern.",
  "company.admin.members.remove": "Entfernen",
  "company.admin.members.roleAdmin": "Administration",
  "company.admin.members.roleMember": "Mitglied",
  "company.admin.members.searchPlaceholder": "Personen nach Namen suchen",
  "company.admin.members.searching": "Personen werden gesucht",
  "company.admin.members.soleAdmin": "Die einzige Administration. Mache zuerst jemand anderen zur Administration, um das zu ändern oder zu entfernen.",
  "company.admin.profile.saved": "Gespeichert.",
  "company.admin.status.confirm": "Beim Deaktivieren verschwindet dieses Unternehmen aus beiden Suchen, und seine Posts und Projekte werden eingefroren: sie lassen sich dann weder veröffentlichen noch bearbeiten oder löschen. Gelöscht wird nichts, und beim Reaktivieren ist alles wieder da.",
  "company.admin.status.deactivate": "Unternehmen deaktivieren",
  "company.admin.status.deactivateConfirm": "Deaktivieren",
  "company.admin.status.inactive": "Dieses Unternehmen ist deaktiviert. Es ist aus beiden Suchen verschwunden, und in seinem Namen lässt sich nichts veröffentlichen oder ändern.",
  "company.admin.status.label": "Status des Unternehmens",
  "company.admin.status.reactivate": "Unternehmen reaktivieren",
  "company.context.acting": "Du handelst als {name}.",
  "company.context.current": "Du handelst als dieses Unternehmen",
  "company.context.enter": "Als dieses Unternehmen handeln",
  "company.context.enterNamed": "Als {name} handeln",
  "company.context.landmark": "Unternehmenskontext",
  "company.context.leave": "Unternehmenskontext verlassen",
  "company.context.scopeAdmin": "Du kannst dieses Unternehmen ansehen und bearbeiten, seine Personen verwalten und in seinem Namen veröffentlichen.",
  "company.context.unsavedBody": "Beim Wechsel des Unternehmenskontexts wird alles auf dem Bildschirm neu geladen. Nicht gespeicherte Änderungen gehen verloren.",
  "company.create.failed": "Das Unternehmen konnte nicht angelegt werden.",
  "company.create.submit": "Unternehmen anlegen",
  "company.inactive.frozen": "Dieses Unternehmen ist inaktiv, seine Posts und Projekte sind deshalb eingefroren. Reaktiviere das Unternehmen, um in seinem Namen etwas zu veröffentlichen oder zu ändern.",
  "company.inactive.frozenReader": "Dieses Unternehmen ist inaktiv, seine Posts und Projekte sind deshalb eingefroren.",
  "company.mine.empty": "Du bist noch bei keinem Unternehmen eingetragen. Eine Administration eines Unternehmens kann dich hinzufügen.",
  "company.mine.emptyWithCreate": "Du bist noch bei keinem Unternehmen eingetragen. Lege eines an, um zu starten.",
  "company.mine.intro": "Die Unternehmen, bei denen du eingetragen bist. Öffne eines, um seine Seite zu sehen.",
  "company.mine.loading": "Deine Unternehmen werden geladen",
  "company.mine.new": "Neues Unternehmen",
  "company.mine.title": "Meine Unternehmen",
  "company.page.card.title": "Unternehmenskarte",
  "company.page.competencies.empty": "Noch kein Fachwissen erfasst.",
  "company.page.competencies.noCapability": "Keine Ausprägung",
  "company.page.competencies.title": "Fachwissen",
  "company.page.about.empty": "Dieses Unternehmen hat sich noch nicht beschrieben.",
  "company.page.about.title": "Über uns",
  "company.page.contacts.hint": "Die von diesem Unternehmen benannten Ansprechpartner:innen. Öffne ein Profil, um Kontakt aufzunehmen.",
  "company.page.contacts.title": "Ansprechpartner:innen",
  "company.page.employeeCount.unset": "Anzahl",
  "company.page.employeeCount.unit": "{count, plural, one {Mitarbeitende:r} other {Mitarbeitende}}",
  "company.page.industry.unset": "Branche nicht angegeben",
  "company.page.employeeCount": "{count, plural, one {# Mitarbeitende:r} other {# Mitarbeitende}}",
  "company.page.loading": "Unternehmen wird geladen",
  "company.page.members.count": "{count, plural, one {# Person} other {# Personen}}",
  "company.page.members.countPartial": "{shown} von {total} Personen angezeigt",
  "company.page.members.empty": "Noch niemand eingetragen.",
  "company.page.members.loadingMore": "Personen werden geladen",
  "company.page.members.showMore": "Weitere Personen anzeigen",
  "company.page.members.title": "Personen",
  "company.page.stopEditingUnsavedBody": "Beim Verlassen des Bearbeitungsmodus geht alles verloren, was noch nicht gespeichert ist: das Profil, das Logo und alle hinzugefügten oder entfernten Personen und Fachwissen-Einträge.",
  "company.page.work.title": "Beiträge und Projekte",
  "company.page.notFound": "Unternehmen nicht gefunden",
  "company.page.notFoundHint": "Dieses Unternehmen existiert nicht oder ist für dich nicht sichtbar.",
  "company.validation.alreadyExists": "{field} ist bereits vergeben. Wähle einen anderen Wert.",
  "company.validation.formatError": "{field} hat einen unerwarteten Wert. Prüfe die Eingabe und speichere erneut.",
  "company.validation.isMandatory": "{field} ist erforderlich.",
  "cv.color": "Farbe",
  "cv.createFailed": "CV-Anlage fehlgeschlagen.",
  "cv.createTitle": "Lebenslauf erstellen",
  "cv.download": "Download",
  "cv.downloadFailed": "Download fehlgeschlagen.",
  "cv.editTitle": "Lebenslauf bearbeiten",
  "cv.error.nameRequired": "Ein Name ist erforderlich.",
  "cv.field.address": "Ort",
  "cv.field.birthDate": "Geburtstag",
  "cv.field.drivingLicence": "Führerschein",
  "cv.field.email": "E-Mail",
  "cv.field.nationality": "Nationalität",
  "cv.field.phone": "Telefon",
  "cv.field.web": "Web",
  "cv.generator": "CV-Generator",
  "cv.name": "Name",
  "cv.notSignedIn": "Nicht angemeldet?",
  "cv.personal.born": "geb. {date}",
  "cv.personal.licence": "Führerschein {value}",
  "cv.previewTitle": "CV-Vorschau",
  "cv.reallyDelete": "Wirklich löschen",
  "cv.saveCv": "CV Speichern",
  "cv.section.certifications": "Zertifikate",
  "cv.section.education": "Ausbildung",
  "cv.section.experience": "Berufserfahrung",
  "cv.section.expertise": "Fachwissen",
  "cv.section.languages": "Sprachen",
  "cv.section.summary": "Profil",
  "cv.sectionCertifications": "Zertifikate",
  "cv.sectionEducation": "Ausbildung",
  "cv.sectionExperience": "Berufserfahrung",
  "cv.sectionExpertise": "Fachwissen",
  "cv.sectionLanguages": "Sprachen",
  "cv.sectionProfile": "Profil",
  "cv.sections": "Sektionen",
  "cv.sidebarContact": "Kontakt",
  "cv.sliderHeadingSize": "Überschriftgröße",
  "cv.sliderIndentation": "Einrückung",
  "cv.sliderSectionMargin": "Sektionsrand",
  "cv.sliderSpacing": "Abstand",
  "cv.sliderTextSize": "Textgröße",
  "cv.template": "Template",
  "cv.template.comic.tagline": "DER BESTE LEBENSLAUF ALLER ZEITEN!!!",
  "cv.template.contact": "Kontakt",
  "cv.updateFailed": "CV-Update fehlgeschlagen.",
  "cv.variant": "Variante {n}",
  "design.addEntry": "Eintrag hinzufügen",
  "design.apply": "Übernehmen",
  "design.booleanYes": "Ja",
  "design.cardComments": "Kommentare",
  "design.cardRating": "Bewertung",
  "design.cardViews": "Aufrufe",
  "design.chipCommented": "Kommentiert",
  "design.chipCreated": "Erstellt",
  "design.chipInterested": "Interessent",
  "design.chipRated": "Bewertet",
  "design.chipWatched": "Beobachtet",
  "design.chooseLevel": "Stufe wählen.",
  "design.clearValue": "Wert löschen",
  "design.copied": "Kopiert",
  "design.copy": "Kopieren",
  "design.cropPhoto": "Foto zuschneiden",
  "design.filterPlaceholder": "Tippen zum Filtern …",
  "design.monthPlaceholder": "Monat",
  "design.numberStepperDecrease": "{noun} verringern",
  "design.numberStepperFallbackNoun": "Wert",
  "design.numberStepperIncrease": "{noun} erhöhen",
  "design.removeTask": "Aufgabe entfernen",
  "design.requiredField": "Pflichtfeld",
  "design.selectPlaceholder": "Auswählen …",
  "design.selfAssessmentDone": "Selbstbewertung abgeschlossen",
  "design.shareLink": "Link teilen",
  "design.shareTitle": "Teilen",
  "design.shareWithArrow": "↗ Teilen",
  "design.stillFillIn": "Bitte noch ausfüllen: {fields}",
  "design.yearPlaceholder": "Jahr",
  "design.zoom": "Zoom",
  "documents.nameTooLong": "Der Dokumentname darf höchstens 255 Zeichen lang sein.",
  "error.route.body": "Etwas in dieser Ansicht konnte nicht gelesen werden. Deine Daten sind unverändert. Du kannst zurückgehen und eine andere Seite öffnen.",
  "error.route.reload": "Seite neu laden",
  "error.route.title": "Diese Seite konnte nicht angezeigt werden",
  "grow.assessment.allAnswered": "Alle Fragen beantwortet",
  "grow.assessment.askAria": "Den Assistenten zu dieser Aussage fragen",
  "grow.assessment.boxAriaLabel": "Zu Frage {index}",
  "grow.assessment.boxTitle": "Frage {index}",
  "grow.assessment.boxTitleAnswered": "Frage {index} · beantwortet",
  "grow.assessment.enterToContinue": "Enter für weiter",
  "grow.assessment.keyboardHint": "Tasten 1–{max} oder ←/→ zum Auswählen",
  "grow.assessment.progress": "Frage {index} / {total} · {answered} beantwortet",
  "grow.assessment.saveFailed": "Konnte nicht speichern.",
  "grow.assessment.skip": "Überspringen",
  "grow.assessment.zoneHint": "↑/↓ wechselt die Zeile (Fragen · Bewertung · Navigation)",
  "grow.assessmentSubtitle": "Bewerte, wie stark jede Aussage auf dich zutrifft.",
  "grow.elementAssessment.askIntro.0": "Ich bewerte gerade die Selbsteinschätzungs-Aussage: „{statement}“. Hilf mir zu verstehen, was sie bedeutet und wie ich sie für mich einschätzen soll.",
  "grow.elementAssessment.askIntro.1": "Hilf mir, diese Selbsteinschätzungs-Aussage zu verstehen: „{statement}“. Was bedeutet sie und wie soll ich sie bewerten?",
  "grow.elementAssessment.askIntro.2": "Ich bin unsicher, wie ich „{statement}“ bewerten soll. Kannst du mir helfen, sie zu deuten und einzuschätzen?",
  "grow.elementAssessment.askIntro.3": "Worauf zielt die Aussage „{statement}“ eigentlich ab, und wie beurteile ich sie für mich?",
  "grow.elementAssessment.askIntro.4": "Führe mich durch die Aussage „{statement}“, damit ich sie ehrlich bewerten kann.",
  "grow.elementAssessment.askIntro.5": "Hilf mir, über „{statement}“ nachzudenken – was bedeutet sie und wie schätze ich sie ein?",
  "grow.elementAssessment.askIntro.6": "Wie sollte ich über die Aussage „{statement}“ nachdenken, wenn ich mich selbst bewerte?",
  "grow.elementAssessment.askIntro.7": "Erläutere „{statement}“ und hilf mir zu entscheiden, wie sehr sie auf mich zutrifft.",
  "grow.elementAssessment.askIntro.8": "Ich bewerte „{statement}“. Was bedeutet sie, und was sollte ich vor der Bewertung bedenken?",
  "grow.elementAssessment.askIntro.9": "Erkläre „{statement}“ und hilf mir herauszufinden, wo ich dabei stehe.",
  "grow.elementAssessment.notSaved": "nicht gespeichert",
  "grow.elementAssessment.savedStatus": "gespeichert",
  "grow.elementAssessment.savingStatus": "speichert…",
  "grow.elementAssessment.statementLabel": "Aussage {index}",
  "grow.elementAssessment.toEvaluation": "Zur Auswertung",
  "grow.elementResult.answeredCount": "{answered}/{total} beantwortet",
  "grow.elementResult.askButton": "Ergebnis besprechen",
  "grow.elementResult.askIntro.0": "Ich habe bei {name} {score} erreicht. Hilf mir zu verstehen, was das bedeutet und wie ich mich verbessern kann.",
  "grow.elementResult.askIntro.1": "Deute mein {name}-Ergebnis ({score}) anhand des Referenzmaterials und schlag vor, wie ich es steigern kann.",
  "grow.elementResult.askIntro.2": "Was sagt ein {name}-Wert von {score} über mich aus, und was kann ich tun?",
  "grow.elementResult.askIntro.3": "Hilf mir, mein {name}-Ergebnis ({score}) einzuordnen und wie es weitergeht.",
  "grow.elementResult.askIntro.4": "Ich habe {score} bei {name}. Wie kann ich diese Power laut Referenzmaterial entwickeln?",
  "grow.elementResult.askIntro.5": "Schlüssele mein {name}-Ergebnis ({score}) auf und gib mir konkrete nächste Schritte.",
  "grow.elementResult.askIntro.6": "Wie sollte ich einen {name}-Wert von {score} lesen? Wie sähe Verbesserung aus?",
  "grow.elementResult.askIntro.7": "Gib mir auf dem Referenzmaterial basierende Tipps, um {name} zu verbessern – bei meinem Wert von {score}.",
  "grow.elementResult.askIntro.8": "Mein {name} liegt bei {score}. Wie kann ich es konkret stärken?",
  "grow.elementResult.askIntro.9": "Deute mein {name}-Ergebnis ({score}) und coache mich bei der Verbesserung.",
  "grow.elementResult.evaluation": "Auswertung",
  "grow.elementResult.fullyAnswered": "Vollständig beantwortet",
  "grow.elementResult.lastEvaluatedOn": "Zuletzt ausgewertet: {date}",
  "grow.elementResult.reassess": "Nochmal bewerten",
  "grow.elementResult.selfAssessmentCompleted": "Selbsteinschätzung abgeschlossen",
  "grow.elementResult.toPower": "Zur Power",
  "grow.elementResult.toPowerMap": "Zur Power Map",
  "grow.elementResult.unknownElement": "Unbekanntes Element",
  "grow.elementResult.yourScore": "Dein Score",
  "grow.landing.progressHint": "Beantworte alle Fragen zu den Powers, um deinen Profilfortschritt zu erhöhen.",
  "grow.mediaKind.podcast": "Podcast",
  "grow.mediaKind.script": "Script",
  "grow.mediaKind.video": "Video",
  "grow.noQuestions": "Für dieses Element sind keine Fragen verfügbar.",
  "grow.play.allGames": "Alle Spiele",
  "grow.play.featured": "Featured",
  "grow.play.group.duration": "ca. {minutes} Min",
  "grow.play.group.kind": "Fragebogen",
  "grow.play.group.missing": "Dieser Fragebogen ist auf dieser Umgebung nicht verfügbar.",
  "grow.play.headerCount": "{count, plural, one {# Spiel} other {# Spiele}}",
  "grow.play.intro": "Spielerische Übungen und Quizzes, die deine Powers in Bewegung bringen.",
  "grow.play.personSingular": "Person",
  "grow.play.quiz.continue": "Weiter mit Teil {index}",
  "grow.play.quiz.eyebrow": "Grow · Play",
  "grow.play.quiz.missing": "Auf dieser Umgebung sind noch keine Fragebögen eingerichtet.",
  "grow.play.quiz.partAnswered": "beantwortet",
  "grow.play.quiz.partLabel": "Teil {index}",
  "grow.play.quiz.partOpen": "offen",
  "grow.play.quiz.partsProgress": "{answered} von {total} Teilen beantwortet",
  "grow.play.quiz.result.backToParts": "Zurück zu den Teilen",
  "grow.play.quiz.result.empty": "Noch keine Powers vorhanden.",
  "grow.play.quiz.result.error": "Das Ergebnis konnte nicht geladen werden: {message}",
  "grow.play.quiz.result.firstValue": "erster Selbstbewertungs-Wert",
  "grow.play.quiz.result.locked": "Das Ergebnis öffnet sich, sobald alle Teile beantwortet sind.",
  "grow.play.quiz.result.noQuizItems": "vom Quiz nicht abgedeckt",
  "grow.play.quiz.result.openPower": "Diese Power öffnen",
  "grow.play.quiz.result.quizAlone": "Quiz allein: {score}{band, select, none {} other { · {band}}}{items, select, none {} other {, aus {answered} von {total} Items}}.",
  "grow.play.quiz.result.quizOnlySource": "Allein aus dem Quiz{items, select, none {} other {, {answered} von {total} Items}}.",
  "grow.play.quiz.result.subtitle": "Wie die beantworteten Teile deine Powers verschoben haben. Sie zählen in deine Selbstbewertung, gewichtet nach der Anzahl ihrer Items.",
  "grow.play.quiz.result.title": "Dein Ergebnis",
  "grow.play.quiz.result.unchanged": "unverändert",
  "grow.play.quiz.showResult": "Ergebnis anzeigen",
  "grow.play.quiz.start": "Quiz starten",
  "grow.play.start": "Starten ↗",
  "grow.play.title": "Play",
  "grow.play.tour.featured.desc": "{name} steht ganz oben im Katalog: {caption} Er dauert {duration} und wird allein beantwortet. Klicke hier, um zu starten.",
  "grow.play.tour.featured.title": "Der hervorgehobene Fragebogen",
  "grow.play.tour.grid.desc": "Der Rest des Katalogs umfasst {count, plural, one {ein weiteres Spiel} other {# weitere Spiele}}. Klicke auf eine Karte, um zu starten.",
  "grow.play.tour.grid.title": "Alle Spiele",
  "grow.play.tour.label": "Grow Play",
  "grow.play.tour.summary": "{count, plural, one {Das ist die Play-Arcade: ein Spiel, das deine Powers in Bewegung bringt.} other {Das ist die Play-Arcade: # Spiele, die deine Powers in Bewegung bringen.}}",
  "grow.powerDetail.answeredCount": "{answered}/{total} beantwortet",
  "grow.powerDetail.askButton": "{name} verstehen",
  "grow.powerDetail.askImprove.0": "Wie kann ich mein {name} verbessern? Gib mir praktische, auf dem Referenzmaterial basierende Schritte.",
  "grow.powerDetail.askImprove.1": "Was sind laut Referenzmaterial konkrete Wege, um {name} zu entwickeln?",
  "grow.powerDetail.askImprove.2": "Coache mich beim Stärken von {name} – wo fange ich an?",
  "grow.powerDetail.askImprove.3": "Gib mir Übungen oder Gewohnheiten aus dem Referenzmaterial, um {name} zu fördern.",
  "grow.powerDetail.askImprove.4": "Was empfiehlt das Referenzmaterial, um {name} zu verbessern?",
  "grow.powerDetail.askImprove.5": "Hilf mir, einen einfachen Plan zu erstellen, um {name} zu verbessern.",
  "grow.powerDetail.askImprove.6": "Was sind die besten ersten Schritte, um {name} zu stärken?",
  "grow.powerDetail.askImprove.7": "Wie entwickelt man {name} üblicherweise? Nutze das Referenzmaterial.",
  "grow.powerDetail.askImprove.8": "Gib mir ein paar praktische Wege, um an {name} zu arbeiten.",
  "grow.powerDetail.askImprove.9": "Ich möchte besser in {name} werden. Was sollte ich laut Referenzmaterial tun?",
  "grow.powerDetail.askImproveButton": "Wie verbessere ich {name}?",
  "grow.powerDetail.askIntro.0": "Gib mir anhand des Referenzmaterials eine Einführung zu {name} und erzähl mir mehr darüber.",
  "grow.powerDetail.askIntro.1": "Stell mir {name} anhand des Referenzmaterials vor – worum geht es dabei?",
  "grow.powerDetail.askIntro.2": "Erkläre mir {name} auf Basis des Referenzmaterials.",
  "grow.powerDetail.askIntro.3": "Was sagt das Referenzmaterial über {name}? Gib mir einen Überblick.",
  "grow.powerDetail.askIntro.4": "Gib mir eine leicht verständliche Einführung zu {name}, gestützt auf das Referenzmaterial.",
  "grow.powerDetail.askIntro.5": "Führe mich anhand des Referenzmaterials durch {name}.",
  "grow.powerDetail.askIntro.6": "Fasse aus dem Referenzmaterial zusammen, was {name} ist und warum es wichtig ist.",
  "grow.powerDetail.askIntro.7": "Hilf mir, {name} zu verstehen – nutze das Referenzmaterial für eine Einführung.",
  "grow.powerDetail.askIntro.8": "Erkläre mir {name} aus dem Referenzmaterial, als wäre ich neu darin.",
  "grow.powerDetail.askIntro.9": "Was sollte ich laut Referenzmaterial über {name} wissen?",
  "grow.powerDetail.confidence": "Konfidenz: {percent}%",
  "grow.powerDetail.continueSelfAssessment": "Selbstbewertung fortsetzen",
  "grow.powerDetail.evidence": "Nachweis ({count})",
  "grow.powerDetail.eyebrow": "Power · {abbr}",
  "grow.powerDetail.noEvidence": "Keine Belege vorhanden. Lade Dokumente in die {link}, um Nachweise zu sammeln.",
  "grow.powerDetail.noPodcasts": "Noch keine Podcasts zu „{name}\" hinterlegt.",
  "grow.powerDetail.noScripts": "Noch keine Scripts zu „{name}\" hinterlegt.",
  "grow.powerDetail.noSmartAnalysis": "Noch keine Smart-Analyse für diese Power.",
  "grow.powerDetail.noVideos": "Noch keine Videos zu „{name}\" hinterlegt.",
  "grow.powerDetail.openDocument": "Dokument öffnen",
  "grow.powerDetail.openDocumentNamed": "Dokument {name} öffnen",
  "grow.powerDetail.page": "Seite {number}",
  "grow.powerDetail.podcasts": "Podcasts",
  "grow.powerDetail.powerAnalysis": "Power-Analyse",
  "grow.powerDetail.powerDetails": "Power-Details",
  "grow.powerDetail.questionnaires": "Fragebögen",
  "grow.powerDetail.rationale": "Begründung",
  "grow.powerDetail.repeatSelfAssessment": "Selbstbewertung wiederholen",
  "grow.powerDetail.revealPower": "„{name}\" aufdecken",
  "grow.powerDetail.scripts": "Scripts",
  "grow.powerDetail.selfAssessment": "Selbstbewertung",
  "grow.powerDetail.selfEvaluation": "Selbsteinschätzung",
  "grow.powerDetail.selfEvaluationIntro": "Beantworte die Aussagen zu „{name}\". Dein Ergebnis fließt in den Selbstbewertungs-Score; bei vollständiger Beantwortung erhältst du die Medaille.",
  "grow.powerDetail.smartAnalysis": "Smart Analyse",
  "grow.powerDetail.stanceContra": "Contra",
  "grow.powerDetail.stancePro": "Pro",
  "grow.powerDetail.startSelfAssessment": "Selbstbewertung starten",
  "grow.powerDetail.tour.artwork.desc": "Das Artwork ist nur so scharf, wie deine Selbsteinschätzung vollständig ist. Bisher hast du {answered} von {total} Aussagen beantwortet. Beantworte mehr, um es ganz freizulegen.",
  "grow.powerDetail.tour.artwork.title": "Das Artwork",
  "grow.powerDetail.tour.description.desc": "Lies, wofür „{name}“ steht und zu welchem Cluster es gehört. Das ist eine gute Grundlage, bevor du dich selbst einschätzt.",
  "grow.powerDetail.tour.description.title": "Was diese Power bedeutet",
  "grow.powerDetail.tour.label": "Grow Power",
  "grow.powerDetail.tour.selfEvaluation.desc": "Beantworte hier die Aussagen zu „{name}“; {answered} von {total} sind geschafft. Wenn du alle beantwortest, gibt es die Medaille und das Artwork wird scharf.",
  "grow.powerDetail.tour.selfEvaluation.doneDesc": "Alle {total} Aussagen beantwortet. Dein Selbsteinschätzungs-Score ist {score}. Du kannst die Einschätzung jederzeit wiederholen und aktualisieren.",
  "grow.powerDetail.tour.selfEvaluation.title": "Selbsteinschätzung",
  "grow.powerDetail.tour.summary": "Auf dieser Seite dreht sich alles um die Power „{name}“ ({abbr}). {status}",
  "grow.powerDetail.tour.summaryStatus": "Du hast {answered} von {total} Selbsteinschätzungs-Aussagen beantwortet.",
  "grow.powerDetail.tour.summaryStatusNone": "Du hast sie noch nicht selbst eingeschätzt.",
  "grow.powerDetail.videos": "Videos",
  "grow.powerLibrary.all": "Alle",
  "grow.powerLibrary.askButton": "Meine Powers verstehen",
  "grow.powerLibrary.askIntro.0": "Lies meine Power Map – wo liegen meine Stärken und Lücken, und worauf sollte ich mich konzentrieren?",
  "grow.powerLibrary.askIntro.1": "Gib mir einen Überblick über meine Powers: was stark ist, was schwach, und wo ich wachsen kann.",
  "grow.powerLibrary.askIntro.2": "Deute mein Power-Profil – die Höhen, die Tiefen und einen Fokusvorschlag.",
  "grow.powerLibrary.askIntro.3": "Welche Muster siehst du auf Basis meiner Powers und des Referenzmaterials?",
  "grow.powerLibrary.askIntro.4": "Hilf mir, mein gesamtes Power-Profil zu verstehen und wo ich investieren sollte.",
  "grow.powerLibrary.askIntro.5": "Was sagen meine stärksten und schwächsten Powers über mich aus?",
  "grow.powerLibrary.askIntro.6": "Fasse meine Power-Landschaft zusammen und empfiehl einen Wachstumsfokus.",
  "grow.powerLibrary.askIntro.7": "Wo liegen meine größten Chancen über alle Powers hinweg?",
  "grow.powerLibrary.askIntro.8": "Führe mich durch meine Power Map und schlag vor, woran ich zuerst arbeite.",
  "grow.powerLibrary.askIntro.9": "Gib mir einen Gesamtüberblick über meine Powers und einen Startpunkt.",
  "grow.powerLibrary.clearSearch": "Suche leeren",
  "grow.powerLibrary.eyebrow": "Power Map",
  "grow.powerLibrary.heading": "{count} Powers",
  "grow.powerLibrary.noResults": "Keine Power gefunden für „{query}\".",
  "grow.powerLibrary.onlyUnrated": "Unbewertete",
  "grow.powerLibrary.openPower": "{name} öffnen",
  "grow.powerLibrary.powerScore": "Power Score",
  "grow.powerLibrary.profileProgress": "Profilfortschritt",
  "grow.powerLibrary.profileProgressTooltip": "Beantworte alle Fragen zu den Powers, um deinen Profilfortschritt zu erhöhen.",
  "grow.powerLibrary.searchPlaceholder": "Suchen nach Name oder Kürzel",
  "grow.powerLibrary.sourceCombined": "Kombiniert",
  "grow.powerLibrary.sourceSelf": "Selbstbewertung",
  "grow.powerLibrary.sourceSmart": "Smart Analyse",
  "grow.powerLibrary.subheading": "Das vollständige Vokabular: {clusters} Cluster, {powers} Powers.",
  "grow.powerLibrary.tour.filters.desc": "Suche Powers nach Name oder Kürzel, oder tippe auf Unbewertet, um nur die {unrated} Powers zu sehen, deren Selbsteinschätzung noch offen ist.",
  "grow.powerLibrary.tour.filters.title": "Suchen & Filtern",
  "grow.powerLibrary.tour.grid.desc": "Alle {total} Powers, gruppiert in {clusters} Cluster. Klicke eine Kachel, um die Power zu öffnen. Medaille und Artwork erscheinen, sobald ihre Selbsteinschätzung vollständig ist; {completed} bisher geschafft.",
  "grow.powerLibrary.tour.grid.title": "Die Power-Kacheln",
  "grow.powerLibrary.tour.label": "Grow Map",
  "grow.powerLibrary.tour.scoreSource.desc": "Stelle um, welche Bewertung die Zahlen auf allen Kacheln zeigen. Wähle Selbsteinschätzung, um die Werte aus deinen eigenen Bewertungen zu sehen.",
  "grow.powerLibrary.tour.scoreSource.title": "Bewertungsquelle",
  "grow.powerLibrary.tour.summary": "Das ist die Power Map: alle {total} Powers im Periodensystem-Stil. {completed} von {total} hast du bisher vollständig selbst eingeschätzt.",
  "grow.powerQuestionnaires.answer": "Beantworten",
  "grow.powerQuestionnaires.completed": "abgeschlossen",
  "grow.powerQuestionnaires.empty": "Noch keine Fragebögen zu „{powerName}“ hinterlegt.",
  "grow.powerQuestionnaires.heading": "Fragebögen",
  "grow.powerQuestionnaires.loading": "lädt…",
  "grow.powerQuestionnaires.repeat": "Wiederholen",
  "grow.questionnaire.eyebrow": "Grow · Fragebogen",
  "grow.questionnaire.fallbackName": "Fragebogen",
  "grow.questionnaire.noQuestions": "Keine Fragen in diesem Fragebogen.",
  "grow.questionnaire.questionLabel": "Frage {position}",
  "grow.questionnaire.submit": "Absenden",
  "grow.questionnaire.unknownElement": "Unbekanntes Element",
  "grow.title": "Wachsen",
  "grow.unknownElement": "Unbekanntes Element",
  "grow.watch.contentCount": "{count} Inhalte",
  "grow.watch.emptyContent": "Noch keine Inhalte hinterlegt. Sobald Videos, Podcasts oder Scripts vorliegen, erscheinen sie hier.",
  "grow.watch.filterAll": "Alle",
  "grow.watch.intro": "Inhalte zum Konsumieren rund um deine Powers: Videos, Podcasts und Scripts. Setze dich hin, schau zu, hör rein und lies nach.",
  "grow.watch.loadingContent": "Inhalte werden geladen …",
  "grow.watch.title": "Watch",
  "grow.watch.tour.content.desc": "{count} Inhalte, jeweils mit Power und Cluster markiert. Klicke eine Karte, um den Inhalt anzusehen.",
  "grow.watch.tour.content.emptyDesc": "Noch sind keine Inhalte verfügbar. Sobald es Videos, Podcasts oder Skripte gibt, erscheinen sie hier als Karten zum Öffnen.",
  "grow.watch.tour.content.title": "Der Katalog",
  "grow.watch.tour.emptySummary": "Das ist Watch: Lerninhalte rund um deine Powers als Videos, Podcasts und Skripte. Im Moment ist hier noch nichts.",
  "grow.watch.tour.filters.desc": "Grenze den Katalog nach Format ein (Videos, Podcasts oder Skripte), oder wähle Alle für alles.",
  "grow.watch.tour.filters.title": "Inhalts-Filter",
  "grow.watch.tour.label": "Grow Watch",
  "grow.watch.tour.summary": "Das ist Watch: Lerninhalte rund um deine Powers als Videos, Podcasts und Skripte. Im Moment gibt es hier {count} Inhalte.",
  "home.allMatches": "Alle Matches ↗",
  "home.candidatesCount": "{count, plural, one {# Kandidat} other {# Kandidaten}}",
  "home.carouselSlide": "Folie {number}",
  "home.certificate": "Zertifikat",
  "home.communitiesSub": "{count, plural, one {# Community} other {# Communities}}",
  "home.community": "Community",
  "home.contacts": "Kontakte",
  "home.documents": "Dokumente",
  "home.education": "Bildung",
  "home.entries": "Einträge",
  "home.greeting": "Schön, dass du da bist.",
  "home.inComparison": "Im Vergleich · Community",
  "home.myPosts": "Meine Beiträge ↗",
  "home.noCommunity": "Noch keine Community.",
  "home.noContacts": "noch keine Kontakte",
  "home.noMatches": "Keine Matches",
  "home.noOwnPosts": "Noch keine eigenen Beiträge",
  "home.noOwnPostsHint": "erstelle ein Projekt oder einen Post",
  "home.noPins": "noch nichts gepinnt",
  "home.viewCommunities": "Communities ansehen",
  "home.viewPins": "Pins ansehen",
  "home.profileVisitors": "Profilbesucher",
  "home.lastVisitor": "zuletzt: {name}",
  "home.noVisitsYet": "noch keine Besuche",
  "home.notRatedYet": "noch nicht bewertet",
  "home.notStarted": "noch nicht gestartet",
  "home.upNext": "Als Nächstes",
  "home.upNextFirst": "als nächstes: {name}",
  "home.allAssessmentsDone": "alle Selbsteinschätzungen abgeschlossen",
  "home.strengths": "Stärken",
  "home.roomToGrow": "Ausbaufähig",
  "home.viewStrengths": "Stärken ansehen",
  "home.viewRoomToGrow": "Ausbaufähig ansehen",
  "home.openProfileOf": "{name} öffnen",
  "home.personsCount": "{count, plural, one {# Person} other {# Personen}}",
  "home.pins": "Pins",
  "home.postsCount": "{count, plural, one {# Post} other {# Posts}}",
  "home.profile": "Profil",
  "home.profileEmpty": "noch nichts erfasst",
  "home.profileFallback": "Profil",
  "home.profileProgress": "Profilfortschritt",
  "home.projectsCount": "{count, plural, one {# Projekt} other {# Projekte}}",
  "home.service": "Dokumente",
  "home.serviceEmpty": "noch nichts abgelegt",
  "home.tour.grow.desc": "Dein Profil-Fortschritt, deine stärksten Powers und offene Selbsteinschätzungen.",
  "home.tour.grow.title": "Grow",
  "home.tour.label": "Hauptseite",
  "home.tour.match.desc": "Deine Matches. Klicke eines an, um dort weiterzumachen, wo du warst.",
  "home.tour.match.title": "Match",
  "home.tour.save.desc": "Deine Profil-Einträge, Dokumente, Kontakte und Pins, mit Schnellaktionen zum Anlegen.",
  "home.tour.save.title": "Save",
  "home.tour.share.desc": "Deine Beiträge und Projekte und was rund um sie passiert.",
  "home.tour.share.title": "Share",
  "home.tour.summary": "Das ist die Hauptseite: die wichtigsten Zahlen aus allen Bereichen auf einen Blick. Jede Kachel führt zu ihrer Stelle in der App.",
  "home.unnamedMatch": "Unbenanntes Match",
  "home.uploadFile": "Datei hochladen",
  "home.viewAll": "Alle ansehen ↗",
  "home.viewPowerMap": "Power Map anzeigen",
  "home.viewResult": "Ergebnis ansehen",
  "home.welcomeHint.dismiss": "Schließen",
  "home.workExperience": "Berufserfahrung",
  "invite.conflict": "Diese Adresse hat bereits Zugang, es wurde keine Einladung gesendet.",
  "invite.created": "Einladung gesendet.",
  "invite.emailLabel": "E-Mail-Adresse",
  "invite.emailPlaceholder": "name@partner.example",
  "invite.eyebrow": "Zugang · Einladung",
  "invite.heading": "Externe Person einladen",
  "invite.intro": "Sie erhält einen Zugangslink, der 72 Stunden gültig ist, und setzt dort ihr eigenes Passwort. Der Link funktioniert einmalig und nur für diese Adresse.",
  "invite.invalidEmail": "Bitte gib eine gültige E-Mail-Adresse ein.",
  "invite.resent": "Diese Person war bereits eingeladen. Der Zugangslink wurde erneut gesendet.",
  "invite.sending": "Wird gesendet…",
  "invite.submit": "Einladung senden",
  "likert.1": "Trifft nicht zu",
  "likert.2": "Trifft eher nicht zu",
  "likert.3": "Teils / teils",
  "likert.4": "Trifft eher zu",
  "likert.5": "Trifft voll zu",
  "linkedin.error.authorize_denied": "Die LinkedIn-Autorisierung wurde abgebrochen.",
  "linkedin.error.cancelled": "Du hast die LinkedIn-Verbindung abgebrochen. Du kannst dich jederzeit erneut verbinden.",
  "linkedin.error.import_failed": "Der Import ist fehlgeschlagen. Bitte versuche es später erneut.",
  "linkedin.error.invalid_callback": "Die Antwort von LinkedIn war unvollständig. Bitte versuche es erneut.",
  "linkedin.error.invalid_state": "Die LinkedIn-Sitzung ist abgelaufen. Bitte versuche es erneut.",
  "linkedin.error.not_configured": "Der LinkedIn-Import ist nicht konfiguriert. Bitte wende dich an deine Administration.",
  "linkedin.error.reconnect": "Deine LinkedIn-Sitzung ist abgelaufen oder der Zugriff war unvollständig. Bitte verbinde dich erneut.",
  "linkedin.error.snapshotNotReady": "LinkedIn hat noch keine Daten geliefert. Wahrscheinlich ist dein Datenexport noch nicht fertig: Wir haben ihn gerade über den LinkedIn-Import angefragt, LinkedIn braucht dafür bis zu 10 Minuten. Versuche es gleich erneut oder komm später wieder.",
  "linkedin.error.stillImporting": "Der Import dauert länger als erwartet. Er läuft weiter – aktualisiere die Seite gleich, um das Ergebnis zu sehen.",
  "linkedin.error.temporary": "LinkedIn hat nicht rechtzeitig geantwortet. Bitte versuche es gleich noch einmal.",
  "linkedin.error.token_exchange": "Verbindung zu LinkedIn fehlgeschlagen. Bitte versuche es später erneut.",
  "linkedin.error.unavailable": "Der LinkedIn-Import ist derzeit nicht verfügbar. Bitte wende dich an deine Administration.",
  "linkedin.error.unexpected": "Beim Import ist etwas schiefgelaufen. Bitte versuche es später erneut.",
  "linkedin.import.abort": "Import abbrechen",
  "linkedin.import.abortTip": "Der Import läuft noch – du kannst weiter warten oder ihn abbrechen und von vorne neu starten. Gespeichert wurde noch nichts.",
  "linkedin.import.alreadyUpToDate": "Alles, was LinkedIn ergänzen könnte, ist bereits in deinem Profil vorhanden.",
  "linkedin.import.close": "Schließen",
  "linkedin.import.comeBackLater": "Später wiederkommen",
  "linkedin.import.connect": "Mit LinkedIn verbinden",
  "linkedin.import.dialogTitle": "LinkedIn-Import",
  "linkedin.import.elapsed": "Verstrichene Zeit: {time}",
  "linkedin.import.field.bio": "Bio",
  "linkedin.import.field.currentEmployer": "Arbeitgeber",
  "linkedin.import.field.dateOfBirth": "Geburtstag",
  "linkedin.import.field.degree": "Abschluss",
  "linkedin.import.field.description": "Beschreibung",
  "linkedin.import.field.email": "E-Mail",
  "linkedin.import.field.employer": "Arbeitgeber",
  "linkedin.import.field.endDate": "Ende",
  "linkedin.import.field.fieldOfStudy": "Studienfach",
  "linkedin.import.field.institution": "Institution",
  "linkedin.import.field.issued": "Ausgestellt",
  "linkedin.import.field.jobTitle": "Jobtitel",
  "linkedin.import.field.language": "Sprache",
  "linkedin.import.field.level": "Niveau",
  "linkedin.import.field.location": "Ort",
  "linkedin.import.field.name": "Name",
  "linkedin.import.field.period": "Zeitraum",
  "linkedin.import.field.phone": "Telefon",
  "linkedin.import.field.profession": "Beruf",
  "linkedin.import.field.skill": "Skill",
  "linkedin.import.field.startDate": "Beginn",
  "linkedin.import.field.street": "Straße",
  "linkedin.import.field.title": "Position",
  "linkedin.import.field.zipCode": "PLZ",
  "linkedin.import.importing": "Deine LinkedIn-Daten werden importiert – das kann bis zu einer Minute dauern …",
  "linkedin.import.intro": "Verbinde dein LinkedIn-Konto, um Profil, Positionen und Fähigkeiten zu importieren. Vor dem Speichern prüfst du, was übernommen oder ersetzt wird.",
  "linkedin.import.loadingResult": "Import wird abgeschlossen…",
  "match.result.facts.aiMark": "KI",
  "match.result.powersColWeight": "Gewichtung",
  "match.result.powersColPower": "Power",
  "match.result.powersColStrongInfo": "Wie viele im Team bei dieser Power über {threshold} liegen.",
  "match.result.powersColStrong": "stark >{threshold}",
  "match.result.powersListHeader": "Top Powers",
  "match.result.powersSortScore": "Nach Team-Score",
  "match.result.powersSortWish": "Nach Gewichtung",
  "match.result.ranking.actualInline": "Nachweis:",
  "match.result.ranking.assessment.interviewQuestions": "Fragen fürs Gespräch",
  "match.result.ranking.assessment.ratingVeryHigh": "Sehr geeignet",
  "match.result.ranking.assessment.ratingHigh": "Geeignet",
  "match.result.ranking.assessment.ratingMedium": "Bedingt geeignet",
  "match.result.ranking.assessment.ratingLow": "Eher ungeeignet",
  "match.result.ranking.assessment.ratingVeryLow": "Ungeeignet",
  "match.result.ranking.fulfilledTab": "Erfüllt ({count})",
  "match.result.ranking.unfulfilledTab": "Nicht erfüllt ({count})",
  "match.result.suitability.basis": "AI-Gesamteinschätzung",
  "match.result.suitability.empty": "Noch keine AI-Eignungsscores vorhanden. Bitte den Match erneut ausführen.",
  "match.result.suitability.header": "Top 5 – beste Eignung",
  "match.result.suitability.openProfile": "{name} – Profil öffnen",
  "match.result.suitability.rankLabel": "Rang {rank}",
  "match.result.suitability.scoreLabel": "AI-Eignung {score} %",
  "match.weightInput.label": "Gewicht für {power}",
  "nav.myCompanies": "Meine Unternehmen",
  "nav.newCompany": "Neues Unternehmen",
  "profile.merge.save": "Änderungen speichern",
  "profile.merge.saving": "Wird gespeichert…",
  "profile.merge.saveFailed": "Diese Änderung konnte nicht gespeichert werden.",
  "profile.merge.savePartial": "{count, plural, one {# Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.} other {# Änderungen konnten nicht gespeichert werden. Bitte erneut versuchen.}}",
  "profile.merge.dateBlocked": "Einige Daten müssen vor dem Speichern korrigiert werden.",
  "profile.merge.fieldBlocked": "Einige Werte müssen vor dem Speichern korrigiert werden.",
  "profile.merge.languageBlocked": "Bitte eine echte Sprache für den importierten Eintrag wählen oder ihn überspringen.",
  "profile.merge.language.unknown": "„{value}“ ist keine erkennbare Sprache. Bitte die richtige wählen oder den Eintrag überspringen.",
  "profile.merge.reviewBlocked": "Prüfe jede Änderung vor dem Speichern.",
  "profile.merge.date.future": "Dieses Datum darf nicht in der Zukunft liegen.",
  "profile.merge.date.format": "Verwende ein Datum wie JJJJ, JJJJ-MM oder JJJJ-MM-TT.",
  "profile.merge.date.range": "Das Enddatum muss am oder nach dem Startdatum liegen.",
  "profile.merge.date.beforeBirth": "Dieses Datum liegt vor dem Geburtsdatum.",
  "profile.merge.field.tooLong": "Bitte auf höchstens {max} Zeichen kürzen.",
  "profile.merge.field.invalidEmail": "Bitte eine gültige E-Mail-Adresse eingeben.",
  "profile.merge.field.invalidUrl": "Bitte eine gültige Webadresse eingeben.",
  "profile.merge.field.invalidPhone": "Bitte eine gültige Telefonnummer eingeben.",
  "profile.merge.field.childCountNegative": "Die Anzahl der Kinder darf nicht negativ sein.",
  "profile.merge.field.childCountMax": "Die Anzahl der Kinder darf {max} nicht überschreiten.",
  "profile.merge.bar.aria": "Importänderungen",
  "profile.merge.bar.open": "{count, plural, one {# Feld zu prüfen} other {# Felder zu prüfen}}",
  "profile.merge.bar.allReviewed": "Alle Änderungen geprüft",
  "profile.merge.bar.previous": "Zurück",
  "profile.merge.bar.next": "Weiter",
  "profile.merge.guide.step": "{current, number} von {total, number}",
  "profile.merge.guide.review": "Prüfen",
  "profile.merge.status.keep": "Dein Wert bleibt",
  "profile.merge.status.use": "Importierter Wert wird verwendet",
  "profile.merge.status.add": "Wird hinzugefügt",
  "profile.merge.status.skip": "Übersprungen",
  "profile.merge.keepAll": "Alle meine behalten",
  "profile.merge.useAll": "Alle importierten übernehmen",
  "profile.merge.skip": "Überspringen",
  "profile.merge.add": "Hinzufügen",
  "profile.merge.showMore": "Mehr anzeigen",
  "profile.merge.showLess": "Weniger anzeigen",
  "profile.merge.badge.new": "Neu",
  "profile.merge.badge.conflict": "Weicht ab",
  "profile.merge.incomingLabel": "Importiert",
  "profile.merge.keep": "Meine behalten",
  "profile.merge.use": "Übernehmen",
  "profile.merge.chooseAria": "Eigenen Wert behalten oder den importierten verwenden",
  "profile.merge.side.existing": "Dein Wert",
  "profile.merge.editAria.existing": "Deinen Wert bearbeiten",
  "profile.merge.editAria.incoming": "Importierten Wert bearbeiten",
  "profile.merge.reset.existing": "Auf deinen gespeicherten Wert zurücksetzen",
  "profile.merge.reset.incoming": "Auf den importierten Wert zurücksetzen",
  "profile.merge.replacesSaved": "Ersetzt deinen gespeicherten Wert",
  "profile.merge.replacesSavedRow": "Ersetzt deinen gespeicherten Eintrag",
  "profile.merge.skills.importAllAria": "Alle Kenntnisse importieren",
  "profile.merge.cefr.native": "Muttersprachler",
  "linkedin.import.openingReview": "Dein Profil wird geöffnet, um die Änderungen zu prüfen…",
  "linkedin.import.retry": "Erneut versuchen",
  "linkedin.import.retryIn": "Erneut versuchen ({time})",
  "linkedin.import.warning.certificateInvalidName": "Ein Zertifikat wurde übersprungen, weil sein Name ungültig war.",
  "linkedin.import.warning.certificateNameDefaulted": "Ein Zertifikat hatte keinen Namen und wurde mit einem Platzhalter importiert.",
  "linkedin.import.warning.educationInvalidStartDate": "Ein Bildungseintrag wurde übersprungen, weil sein Startdatum ungültig war.",
  "linkedin.import.warning.educationMissingFieldOfStudyAndDegree": "Ein Bildungseintrag wurde übersprungen, weil weder Fachrichtung noch Abschluss angegeben waren.",
  "linkedin.import.warning.educationStartDateDefaulted": "Ein Bildungseintrag hatte kein Startdatum und wurde auf den aktuellen Monat gesetzt.",
  "linkedin.import.warning.experienceInvalidJobTitle": "Eine Position wurde übersprungen, weil ihre Berufsbezeichnung ungültig war.",
  "linkedin.import.warning.experienceInvalidStartDate": "Eine Position wurde übersprungen, weil ihr Startdatum ungültig war.",
  "linkedin.import.warning.experienceJobTitleDefaulted": "Eine Position hatte keine Berufsbezeichnung und wurde mit einem Platzhalter importiert.",
  "linkedin.import.warning.experienceStartDateDefaulted": "Eine Position hatte kein Startdatum und wurde auf den aktuellen Monat gesetzt.",
  "linkedin.import.warning.languageMissingName": "Eine Sprache wurde übersprungen, weil sie keinen Namen hatte.",
  "linkedin.import.warning.languageTagTooLong": "Eine Sprache wurde übersprungen, weil ihr Name zu lang war.",
  "linkedin.import.warning.languageUnrecognizedName": "Eine Sprache wurde übersprungen, weil ihr Name nicht erkannt wurde.",
  "linkedin.import.warning.languageUnrecognizedProficiency": "Das Sprachniveau einer Sprache wurde nicht erkannt.",
  "match.addDocumentsAriaLabel": "Dokumente hinzufügen",
  "match.agenticAi": "Agentic AI",
  "match.agenticAiBoxDesc": "Halte fest, mit welchen KI-Agenten dieses Projekt arbeitet. Sie sind Kontext, kein Teammitglied: sie besetzen keinen Platz im Team, aber die Anforderungen passen sich an.",
  "match.agent.covers": "Deckt ab",
  "match.agent.tools": "Tools",
  "match.agent.mcp": "MCP",
  "match.agent.guardrails": "Leitplanken",
  "match.agent.remove": "{name} entfernen",
  "match.agent.none": "Noch keine Agenten hinterlegt.",
  "match.agent.recommend": "Agenten empfehlen",
  "match.agent.recommendHint": "Öffnet den Assistenten, der aus deiner Beschreibung passende Agenten vorschlägt.",
  "match.agent.recommendPrompt": "Welche KI-Agenten passen zu diesem Projekt?",
  "match.agent.recommendContext": "Beantworte die Frage anhand der folgenden Angaben. Nenne zwei bis vier Agenten, jeweils mit einem Satz Begründung, und sage dazu, welche Anforderungen an die menschlichen Teammitglieder dadurch anders aussehen. Agenten sind Projekt-Kontext und nie Teammitglieder. Du kannst die Auswahl nicht selbst hinterlegen und hast dafür auch kein Werkzeug: nenne die Agenten namentlich, hinterlegen tue ich sie.\n\nProjekt:\n{project}\n\nBereits hinterlegt: {selected}\n\nVerfügbare Agenten:\n{catalogue}",
  "match.agent.noneShort": "keine",
  "match.agent.browse": "Agenten auswählen",
  "match.agent.catalogueTitle": "Verfügbare Agenten",
  "match.agent.add": "Hinzufügen",
  "match.agent.added": "Hinzugefügt",
  "match.agenticAiOff": "Agentic AI aus",
  "match.agenticAiOn": "Agentic AI aktiv",
  "match.agenticAiQuestion": "Soll dieses Match mit Agentic AI unterstützt werden?",
  "match.challenge.aiAssist": "KI-Unterstützung",
  "match.challenge.aiAssistHint": "KI berücksichtigt das ganze Profil und beurteilt, ob Anforderungen auch ohne expliziten Nachweis erfüllt sind. Zusätzlich erstellt sie zu jeder Person eine Einschätzung mit Score.",
  "match.challenge.aiAssistHintReduced": "KI berücksichtigt das ganze Profil und beurteilt, ob Anforderungen auch ohne expliziten Nachweis erfüllt sind.",
  "match.challenge.aiDeriveHint": "Öffnet den Assistenten, der Anforderungen aus deiner Beschreibung vorschlägt.",
  "match.challenge.aiFillFirstHint": "Erst eine Beschreibung ausfüllen.",
  "match.challenge.describeProject": "Projekt beschreiben",
  "match.challenge.describeRole": "Rolle beschreiben",
  "match.challenge.enterTitle": "Titel eintragen",
  "match.challenge.generateRequirementsPrompt": "Schlag mir passende Anforderungen aus Titel, Kurz- und Detailbeschreibung vor.",
  "match.challenge.generateWithAi": "Für mich generieren",
  "match.challenge.interview.invite": "Unsicher, was rein soll? Lass dich vom Assistenten interviewen.",
  "match.challenge.interview.refine": "Mit einem Interview verfeinern",
  "match.challenge.interview.seed": "Interviewe mich zu diesem Projekt, damit wir eine gute Projektbeschreibung bekommen.",
  "match.challenge.linkBtn": "Verknüpfen",
  "match.challenge.linkProjectTitle": "Projekt mit existierendem Share-Item verknüpfen",
  "match.challenge.noFilesYet": "Noch keine Dateien.",
  "match.challenge.openLinkedShare": "Verknüpftes Share-Item öffnen",
  "match.challenge.projectTitleLabel": "Projekt-Titel",
  "match.challenge.roleTitleLabel": "Rollen-Titel",
  "match.challenge.publishBtn": "Veröffentlichen",
  "match.challenge.requirements": "Anforderungen",
  "match.challenge.requirementsSharedInfo": "Berücksichtigt werden nur Profilinformationen, die Kandidat:innen geteilt haben.",
  "match.challenge.unlink": "Verbindung lösen",
  "match.challenge.unlinkTitle": "Verbindung zum Share-Item lösen",
  "match.challenge.unnamedSharedItem": "Unbenanntes Share-Item",
  "match.charsCount": "{count} Zeichen",
  "match.detail.error": "Fehler: {message}",
  "match.detail.invalidUrl": "Ungültige Match-URL.",
  "match.detail.loading": "Lädt …",
  "match.detail.notFound": "Match nicht gefunden.",
  "match.detailedPlaceholder": "Kontext, Outcome, Constraints, Vorerfahrungen, alles was sonst relevant ist.",
  "match.docs.retry": "↻ Erneut versuchen",
  "match.docs.tooLarge": "Zu groß (max. {max} MB pro Datei): {names}",
  "match.docs.uploadFailed": "Upload fehlgeschlagen.",
  "match.docs.uploading": "Wird hochgeladen…",
  "match.documents": "Dokumente",
  "match.dropFiles": "Dateien <b>hierher ziehen</b> oder klicken",
  "match.editor.reset": "Zurücksetzen",
  "match.fieldDetailedDesc": "Detaillierte Beschreibung",
  "match.fieldShortDesc": "Kurzbeschreibung",
  "match.freitext.addJobTitle": "Jobtitel",
  "match.freitext.jobTitlePlaceholder": "z. B. Senior Designer, Lead Engineer",
  "match.freitext.title": "Berufserfahrung",
  "match.group.COMMUNICATION": "Kommunikationsfähigkeit",
  "match.group.FUTURE_ORIENTATION": "Zukunftsorientierung",
  "match.group.INVENTIVENESS": "Erfindungsstärke",
  "match.group.RESILIENCE": "Belastbarkeit",
  "match.group.RESULT_ORIENTATION": "Ergebnisorientierung",
  "match.group.TEAM_SPIRIT": "Teamfähigkeit",
  "match.labelLanguage": "Sprache",
  "match.landing.body": "Initiiere ein Match, definiere Anforderungen und lass den Solver Menschen und Agentic-AI zu einem optimalen Team komponieren – transparent, gewichtet, erklärbar.",
  "match.landing.candidatesCount": "{count} Kandidaten",
  "match.landing.error": "Fehler: {message}",
  "match.landing.loading": "lädt…",
  "match.landing.newMatch": "Neues Match erstellen ↗",
  "match.landing.noMatches": "Keine Matches",
  "match.landing.noMatchesHint": "… oder nicht angemeldet",
  "match.landing.resultsCount": "{count} Ergebnisse",
  "match.landing.subtitle": "Vom Teamgedanken{br}zum besten Team.",
  "match.landing.yourMatches": "Deine Matches",
  "match.matchNameLabel": "Match-Name",
  "match.new.accessLabel": "Zugriff",
  "match.new.create": "Erstellen",
  "match.new.creating": "Erstellt …",
  "match.new.defaultName": "Neues Match",
  "match.new.title": "Neues Match erstellen",
  "match.modal.accessCount": "Zugriff · {count}",
  "match.modal.addPersonPlaceholder": "+ Person hinzufügen – Name suchen …",
  "match.modal.chooseShareItem": "Share-Item wählen",
  "match.modal.fillTitle": "Projekt mit dem Share-Item füllen",
  "match.modal.link": "Verknüpfen",
  "match.modal.linkOnly": "Nur verknüpfen",
  "match.modal.linkOnlyTitle": "Verknüpfen, ohne Inhalte zu kopieren",
  "match.modal.linkWithShareItem": "Mit Share-Item verknüpfen",
  "match.modal.linking": "Verknüpft …",
  "match.modal.loadingEllipsis": "lädt …",
  "match.modal.matchNotes": "Notizen zum Match",
  "match.modal.matchNotesPlaceholder": "Interne Notizen, Kontext oder offene Fragen – nicht die Projektbeschreibung.",
  "match.modal.myShareItems": "Meine Share-Items",
  "match.modal.myShareItemsCount": "Meine Share-Items · {count}",
  "match.modal.nameNotesAccess": "Name, Notizen & Zugriff",
  "match.modal.noAccessYet": "Niemand hat Zugriff. Unten Person hinzufügen.",
  "match.modal.noHits": "Keine Treffer.",
  "match.modal.noWriteRights": "Du hast keine Schreibrechte auf diese Match-Einstellungen.",
  "match.modal.overwriteTitle": "Projekt-Inhalte mit dem Share-Item überschreiben",
  "match.modal.owner": "Eigentümer:in",
  "match.modal.ownerCreatedBy": "Eigentümer:in · erstellt von",
  "match.modal.publishEyebrow": "Veröffentlichen",
  "match.modal.publishHint": "Bild, Theme und Audience sind anschließend im Share-Editor zu ergänzen.",
  "match.modal.publishNow": "Jetzt veröffentlichen",
  "match.modal.publishOpenInEditor": "Im Editor öffnen",
  "match.modal.publishOpeningEditor": "Öffnet …",
  "match.modal.publishPublishing": "Veröffentlicht …",
  "match.modal.publishQuestion": "Wie willst du das Projekt als Share-Item veröffentlichen?",
  "match.modal.removeLink": "Verknüpfung entfernen?",
  "match.modal.roleAdmin": "Admin",
  "match.modal.roleEditor": "Bearbeiter:in",
  "match.modal.roleHintAdmin": "Alle Inhalte + Zugriff verwalten",
  "match.modal.roleHintEditor": "Inhalte bearbeiten",
  "match.modal.roleHintReader": "Nur ansehen",
  "match.modal.roleReader": "Leser:in",
  "match.modal.savingEllipsis": "Speichert …",
  "match.modal.searchByName": "Nach Name suchen …",
  "match.modal.searchingEllipsis": "sucht …",
  "match.modal.takeOver": "Übernehmen",
  "match.modal.unlinkAction": "Verbindung lösen",
  "match.modal.unlinkBody": "Die Verknüpfung zu <b>{name}</b> wird entfernt.",
  "match.modal.unlinkEyebrow": "Verbindung lösen",
  "match.modal.unlinkHint": "Die kopierten Inhalte (Titel, Beschreibung, Dokumente) bleiben erhalten – nur der Hinweis auf das Share-Item verschwindet.",
  "match.modal.unlinking": "Trennt …",
  "match.modal.unnamedShareItem": "Unbenanntes Share-Item",
  "match.modal.visibleToMe": "Sichtbar für mich",
  "match.modal.visibleToMeCount": "Sichtbar für mich · {count}",
  "match.modePicker.assessOutput": "Einschätzung + Lücken",
  "match.modePicker.assessSlogan": "Du hast bereits ein Team im Kopf und willst sehen, wie gut es passt und wo die Lücken sind.",
  "match.modePicker.assessTitle": "Team bewerten",
  "match.modePicker.optimizeTitle": "Team optimieren",
  "match.modePicker.rankTitle": "Kandidaten vergleichen",
  "match.modePicker.optimizeOutput": "ein Team",
  "match.modePicker.optimizeSlogan": "Du hast einen Pool an Personen und willst das beste Team für ein Projekt oder eine Aufgabe zusammenstellen.",
  "match.modePicker.outputLabel": "Ergebnis",
  "match.modePicker.rankOutput": "Rangliste",
  "match.modePicker.rankSlogan": "Du besetzt eine offene Stelle und willst Kandidaten danach sortieren, wer am besten passt.",
  "match.modePicker.title": "Welche Frage soll dieses Match beantworten?",
  "match.noMatchesEmpty": "Keine Matches",
  "match.noPeopleFound": "Keine Personen gefunden",
  "match.optChoose": "– wählen –",
  "match.people.addAll": "Alle hinzufügen ({count})",
  "match.people.addAllFromSet": "Alle {count} aus {name} hinzufügen",
  "match.people.addAllPinned": "Alle {count} Gepinnten hinzufügen",
  "match.people.addInterested": "Interessenten hinzufügen ({count})",
  "match.people.addUpTo": "Bis zu {count} passende hinzufügen",
  "match.people.added": "Hinzugefügt",
  "match.people.allPinned": "Alle Gepinnten",
  "match.people.evaluateLocked": "Dieses Team bewerten",
  "match.people.evaluateLockedTitle": "Dieses vollständig gesperrte Team bewerten",
  "match.people.emptyCandidates": "Noch keine Kandidaten – links über Suche oder Filter hinzufügen.",
  "match.people.finderTitle": "Personen finden",
  "match.people.interestedExplain": "Personen mit Interesse an diesem Projekt",
  "match.people.intro": "Suche und filtere Personen aus deinem Unternehmen und füge sie als Kandidaten hinzu.",
  "match.people.introLock": "Markiere einzelne als Fix im Team, wenn sie gesetzt sein sollen.",
  "match.people.lockAsFix": "Als Fix im Team markieren",
  "match.people.personGroups": "Gruppen",
  "match.people.pinGroups": "Pingruppen",
  "match.people.sampleNotice": "Der Kandidatenpool enthält die ersten {count} von {total} passenden Personen aus dem letzten Massen-Hinzufügen.",
  "match.people.sampleNoticeCapped": "Der Kandidatenpool enthält die ersten {count} passenden Personen; es gab mehr Treffer, als auf einmal hinzugefügt werden konnten.",
  "match.people.savedSetsPlaceholder": "Gruppen & Pins …",
  "match.people.searchPlaceholder": "Name, Jobtitel …",
  "match.people.selectedCandidates": "Ausgewählte Kandidaten",
  "match.people.unlock": "Sperrung aufheben",
  "match.placeholderCount": "Anzahl",
  "match.preSolve.assessTeam": "Team bewerten",
  "match.preSolve.assessing": "Bewerte Team…",
  "match.preSolve.rankCandidates": "Kandidaten ranken",
  "match.preSolve.ranking": "Ranke…",
  "match.preSolve.candidatesLoaded": "Kandidaten geladen",
  "match.preSolve.conditionsComplete": "Kriterien vollständig",
  "match.preSolve.conditionsIncompleteHint": "{n, plural, one {# Kriterium ohne Auswahl (z. B. Branche wählen) – ausfüllen oder entfernen} other {# Kriterien ohne Auswahl – ausfüllen oder entfernen}}",
  "match.preSolve.eyebrow": "Bereit zum Solven",
  "match.preSolve.eyebrowAssess": "Bereit zur Bewertung",
  "match.preSolve.eyebrowRank": "Bereit zum Ranking",
  "match.preSolve.headingAssess": "Bewerte, wie gut dein Team die Anforderungen erfüllt.",
  "match.preSolve.headingRank": "Sortiere deine Kandidaten nach Passung zum Anforderungsprofil.",
  "match.challenge.assessmentDetail": "Ausführlichkeit",
  "match.challenge.assessmentDetailBullets": "Stichpunkte",
  "match.challenge.assessmentDetailBulletsDescription": "Kompakte Punkte mit Zeilenumbrüchen.",
  "match.challenge.assessmentDetailInfo": "Ausführlichkeit erklären",
  "match.challenge.assessmentDetailLongText": "Langtext",
  "match.challenge.assessmentDetailLongTextDescription": "Ausführliche Begründung mit konkreten Belegen.",
  "match.challenge.assessmentDetailSentences": "Sätze",
  "match.challenge.assessmentDetailSentencesDescription": "Kurze, vollständige Sätze.",
  "match.challenge.assessmentOutcomeBalanced": "Ausgewogen",
  "match.challenge.assessmentOutcomeBalancedDescription": "Stärken, Risiken und offene Fragen werden im Gesamtergebnis gleich gewichtet.",
  "match.challenge.assessmentOutcomeFocus": "Ergebnisfokus",
  "match.challenge.assessmentOutcomeFocusInfo": "Ergebnisfokus erklären",
  "match.challenge.assessmentOutcomeOpportunities": "Stärken",
  "match.challenge.assessmentOutcomeOpportunitiesDescription": "Stärken, übertragbare Fähigkeiten und realistische Einsatzmöglichkeiten werden stärker gewichtet und zuerst dargestellt.",
  "match.challenge.assessmentOutcomeRisks": "Lücken",
  "match.challenge.assessmentOutcomeRisksDescription": "Risiken, fehlende Nachweise und offene Fragen werden stärker gewichtet und zuerst dargestellt.",
  "match.challenge.assessmentStrictness": "Bewertungsmaßstab",
  "match.challenge.assessmentStrictnessExtreme": "Sehr hoch",
  "match.challenge.assessmentStrictnessExtremeDescription": "Nur explizite, rollenrelevante Belege tragen stark zur Bewertung bei; Unsicherheiten begrenzen das Ergebnis deutlich.",
  "match.challenge.assessmentStrictnessInfo": "Bewertungsmaßstab erklären",
  "match.challenge.assessmentStrictnessNormal": "Normal",
  "match.challenge.assessmentStrictnessNormalDescription": "Die drei KI-Perspektiven bewerten Evidenz und Unsicherheiten mit normaler Strenge.",
  "match.challenge.assessmentStrictnessStrict": "Hoch",
  "match.challenge.assessmentStrictnessStrictDescription": "Unklare oder nur angedeutete Erfahrung wird innerhalb der Bewertungsbandbreite vorsichtiger eingestuft.",
  "match.challenge.hrPromptLabel": "Bewertungsstil",
  "match.challenge.requirementLeniency": "Anforderungsprüfung",
  "match.challenge.requirementLeniencyInfo": "Anforderungsprüfung erklären",
  "match.challenge.requirementLeniencyLenient": "Kulant",
  "match.challenge.requirementLeniencyLenientDescription": "Die geforderte Stufe ist ein Richtwert: vorhandenes Fachwissen genügt.",
  "match.challenge.requirementLeniencyMustStrict": "Kulant bei Kann",
  "match.challenge.requirementLeniencyMustStrictDescription": "Bei Muss-Kriterien muss die Stufe erreicht sein, bei Kann genügt Vorhandensein.",
  "match.challenge.requirementLeniencyStrict": "Beides streng",
  "match.challenge.requirementLeniencyStrictDescription": "Die geforderte Stufe muss bei Muss und Kann erreicht sein.",
  "match.preSolve.fulfillFirst": "Erfülle zuerst die Anforderungen oben.",
  "match.preSolve.fullyLockedHint": "Alle {teamSize} Plätze sind durch fixierte Mitglieder belegt. Der Solver bewertet dieses Team nur, er optimiert es nicht.",
  "match.preSolve.lockedExceedsHeading": "Es sind mehr Personen fixiert als Plätze vorhanden.",
  "match.preSolve.lockedExceedsBody": "{locked} Personen sind fixiert, aber das Team hat {teamSize} Plätze. Entsperre einige Mitglieder oder erhöhe die Team-Größe, bevor du solvest.",
  "match.preSolve.heading": "Aus deinem Kandidatenpool ein optimales Team komponieren.",
  "match.preSolve.intro": "Der Solver verteilt deine Kandidaten auf {teamSize} Plätze und optimiert auf dein Anforderungsprofil. Du kannst die Berechnung beliebig oft wiederholen.",
  "match.preSolve.noSizeYet": "noch keine Größe gewählt",
  "match.preSolve.personsCount": "{n} Personen",
  "match.preSolve.poolOnly": "{n} im Pool",
  "match.preSolve.poolWithLocked": "{n} im Pool · {locked} fix",
  "match.preSolve.solverRunning": "Solver läuft…",
  "match.preSolve.startSolver": "Solver starten",
  "match.preSolve.teamSizePlaceholder": "n",
  "match.preSolve.teamSizeSet": "Team-Größe gesetzt",
  "match.profilesLoadError": "Profile laden: {message}",
  "match.publishToShare": "Als Projekt in Share veröffentlichen",
  "match.readOnlyBanner": "Du kannst dieses Match nur ansehen. Bitte einen Admin oder Eigentümer:in um Schreibrechte.",
  "match.renameLabel": "Match umbenennen",
  "match.recruiting.addBranche": "Branche",
  "match.recruiting.addCertificate": "Zertifikat",
  "match.recruiting.addEducation": "Ausbildung",
  "match.recruiting.addSkillHere": "Fachwissen hier hinzufügen",
  "match.recruiting.branchePlaceholder": "Branche wählen",
  "match.recruiting.certificatePlaceholder": "z. B. AWS Solutions Architect",
  "match.recruiting.qualificationsTitle": "Ausbildung & Zertifikate",
  "match.recruiting.educationDegreePlaceholder": "Abschluss auswählen",
  "match.recruiting.educationDegreeLabel": "Benötigter Abschluss",
  "match.recruiting.educationLevelInfo.aria": "AI-Auswertung des Abschlusses erklären",
  "match.recruiting.educationLevelInfo.title": "Auswertung des Abschlusses",
  "match.recruiting.educationLevelInfo.body": "Ohne AI wird der ausgewählte Katalogeintrag direkt verglichen. Mit aktivierter AI erhält das Modell den Hinweis, zusätzlich gleichwertige oder eindeutig höherwertige formale Abschlüsse zu berücksichtigen.",
  "match.recruiting.experienceTitle": "Benötigte Berufserfahrung",
  "match.recruiting.expertiseTitle": "Benötigtes Fachwissen (mind.)",
  "match.recruiting.kann.tooltip": "Kann-Kriterium: zählt in den Passungs-Score. Klicken für Muss.",
  "match.recruiting.minYears": "mind.",
  "match.recruiting.must.tooltip": "Muss-Kriterium: wer es nicht erfüllt, ist unqualifiziert. Klicken für Kann.",
  "match.recruiting.personCountLabel": "Mindestanzahl Personen",
  "match.recruiting.skillPlaceholder": "z. B. Wundmanagement",
  "match.recruiting.unrated": "Vorhanden",
  "match.recruiting.years": "Jahre",
  "match.recruiting.yearsUnit": "Jahre",
  "match.removeAll": "Alle entfernen",
  "match.requirements.aria.cefrLevel": "Niveau",
  "match.requirements.aria.composition": "Composition",
  "match.requirements.aria.operator": "Operator",
  "match.requirements.cefr.A1": "A1 – Anfänger",
  "match.requirements.cefr.A2": "A2 – Grundlagen",
  "match.requirements.cefr.B1": "B1 – Mittelstufe",
  "match.requirements.cefr.B2": "B2 – Selbstständig",
  "match.requirements.cefr.C1": "C1 – Fortgeschritten",
  "match.requirements.cefr.C2": "C2 – Verhandlungssicher",
  "match.requirements.cefr.NATIVE": "Muttersprache",
  "match.requirements.condition.annualSalary": "Jahresgehalt",
  "match.requirements.otherUnchanged": "{count, plural, one {# weitere Anforderung bleibt} other {# weitere Anforderungen bleiben}} unverändert erhalten.",
  "match.requirements.personDetails": "Personen-Details",
  "match.result.adjustRequirements": "Anforderungen anpassen",
  "match.result.adjustTeamSize": "Team-Größe",
  "match.result.age": "Age",
  "match.result.agentsIntro": "Mit diesen KI-Agenten arbeitet das Projekt. Sie sind Kontext und kein Teammitglied: das Team oben besteht ausschließlich aus Personen.",
  "match.result.agentsTitle": "Agenten",
  "match.result.analysis.extraSkills": "Stark im Team, nicht angefordert: {skills}",
  "match.result.backToSelection": "← Schließen",
  "match.result.candidatesMeta": "{count, plural, one {# Kandidat} other {# Kandidaten}}",
  "match.result.condition.age": "Alter",
  "match.result.condition.annualSalary": "Gehalt",
  "match.result.condition.certificate": "Zertifikat",
  "match.result.condition.children": "Kinder",
  "match.result.condition.citizenship": "Staatsangehörigkeit",
  "match.result.condition.city": "Wohnort",
  "match.requirements.cityRadius": "Umkreis in Kilometern",
  "match.requirements.cityRadiusDial": "Umkreis wählen, von der Mitte nach außen ziehen",
  "match.requirements.cityRadiusHint": "Ziehen bis 100 km, größere Werte oben eintragen",
  "match.result.analysis.carriersClose": "Knapp: {names}",
  "match.result.analysis.carriersMet": "Erfüllt von: {names}",
  "match.result.analysis.carriersNone": "Niemand im Team erfüllt das.",
  "match.result.analysis.donutFulfilled": "erfüllt",
  "match.result.analysis.fulfilment": "Erfüllung",
  "match.result.analysis.gaps": "Lücken",
  "match.result.analysis.metOfTotal": "{met}/{total} erfüllt",
  "match.result.analysis.moreRows": "+{count} weitere",
  "match.result.analysis.noStrengths": "Noch nichts erfüllt.",
  "match.result.analysis.recAllMet": "Alle Anforderungen erfüllt.",
  "match.result.analysis.rowClose": "{n} knapp",
  "match.result.analysis.rowCompositionAll": "alle im Team",
  "match.result.analysis.rowCompositionExact": "genau {n} im Team",
  "match.result.analysis.rowCompositionMax": "max. {n} im Team",
  "match.result.analysis.rowCompositionMin": "min. {n} im Team",
  "match.result.analysis.rowToggleAria": "Träger von {label} anzeigen",
  "match.result.analysis.rowMetOf": "{met} von {total}",
  "match.result.analysis.soleCarrier": "nur {name}",
  "match.result.analysis.strengths": "Stärken",
  "match.result.condition.country": "Land",
  "match.result.condition.department": "Abteilung",
  "match.result.condition.driversLicense": "Führerschein",
  "match.result.condition.education": "Ausbildung",
  "match.result.condition.exact": "{label}: {value}",
  "match.result.condition.exactNot": "{label}: nicht {value}",
  "match.result.condition.experience": "Berufserfahrung",
  "match.result.condition.expertise": "Fachwissen",
  "match.result.condition.gender": "Geschlecht",
  "match.result.condition.industry": "Branche",
  "match.result.condition.language": "Sprache",
  "match.result.condition.location": "Arbeitsstandort",
  "match.result.condition.maritalStatus": "Familienstand",
  "match.result.condition.nationality": "Nationalität",
  "match.result.condition.present": "{label}: Vorhanden",
  "match.result.condition.presentActual": "Vorhanden",
  "match.result.condition.threshold": "{label}: {word} {value}",
  "match.result.condition.thresholdExact": "genau",
  "match.result.condition.thresholdMax": "max.",
  "match.result.condition.thresholdMin": "mind.",
  "match.result.condition.thresholdNot": "nicht",
  "match.result.dataHint": "Datenhinweis",
  "match.result.deleteAriaLabel": "Ergebnis „{name}“ löschen",
  "match.result.deleteConfirmBody": "Das gespeicherte Ergebnis <b>„{name}“</b> wird endgültig entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  "match.result.deleteConfirmTitle": "Ergebnis löschen?",
  "match.result.deleteFinal": "Endgültig löschen",
  "match.result.deleteTitle": "Löschen",
  "match.result.deleting": "Lösche…",
  "match.result.dept": "Dept",
  "match.result.detailsHeader": "Details",
  "match.result.discardUnsavedConfirm.confirm": "Verwerfen",
  "match.result.discardUnsavedConfirm.message": "Das berechnete Ergebnis wurde noch nicht gespeichert und geht beim Zurückgehen verloren.",
  "match.result.discardUnsavedConfirm.title": "Ungespeichertes Ergebnis verwerfen?",
  "match.result.dismissDataHint": "Datenhinweis schließen",
  "match.result.elementRequirementsFulfilled": "Element Requirements · {count} erfüllt",
  "match.result.emptyHint": "Keine Daten im Ergebnis vorhanden.",
  "match.result.facts.matchedBadge": "Trägt zu {met} von {total} Anforderungen bei",
  "match.result.facts.mustViolated": "{count, plural, one {# Muss-Kriterium ist nicht erfüllt} other {# Muss-Kriterien sind nicht erfüllt}}.",
  "match.result.factsAndSkills": "Anforderungs-Matrix",
  "match.result.gender": "Gender",
  "match.result.groupBasics": "Basics",
  "match.result.groupExpertise": "Expertise",
  "match.result.groupTotal": "Total",
  "match.result.hintNoConditionsBody": "Dieses Match hat keine Anforderungen im Challenge-Schritt – Match-Analyse und Anforderungs-Matrix bleiben darum leer. Definiere Bedingungen, um zu sehen, wie das Team sie erfüllt.",
  "match.result.hintNoConditionsLabel": "Keine Anforderungen definiert",
  "match.result.hintNoDemographicsBody": "Die Personen haben keine Geburtsdaten und kein Geschlecht hinterlegt. Abteilung, Geschlecht und Alter unter dem Team bleiben darum ausgeblendet.",
  "match.result.hintNoDemographicsLabel": "Keine demografischen Daten",
  "match.result.hintNoPowersBody": "Die ausgewählten Personen haben ihre Powers nicht selbst eingeschätzt. Alle Powers-Auswertungen bleiben darum bei Null. Sobald sie Powers im Profil pflegen, füllt sich das Ergebnis automatisch.",
  "match.result.hintNoPowersLabel": "Keine Power-Self-Assessments",
  "match.result.historyLoading": "Gespeicherte Ergebnisse laden …",
  "match.result.historyTitle": "Gespeicherte Ergebnisse",
  "match.result.infeasibleBody": "Die Bedingungen widersprechen sich oder dein Kandidatenpool ist zu klein. Entferne harte Filter oder vergrößere den Pool und starte den Solver erneut.",
  "match.result.infeasibleLockedTitle": "Fixierte Kandidaten blockieren die Berechnung",
  "match.result.infeasibleLockedHeading": "Die fixierten Mitglieder allein ergeben kein gültiges Team.",
  "match.result.infeasibleLockedBody": "Es sind zu viele Personen fixiert, oder die fixierten Mitglieder verletzen bereits eine Anforderung. Entsperre einige Mitglieder oder erhöhe die Team-Größe und starte den Solver erneut.",
  "match.result.infeasibleRelaxTitle": "{count, plural, one {Lockere dieses Muss-Kriterium} other {Kleinste Korrektur: lockere alle diese Muss-Kriterien}}",
  "match.result.infeasibleShortfall": "fehlt {shortfall}",
  "match.result.infeasibleMet": "{met} von {target} erfüllt",
  "match.result.infeasibleOvershoot": "{over} über dem Limit von {target}",
  "match.result.unlockMembers": "Mitglieder entsperren",
  "match.result.infeasibleHeading": "Der Solver konnte kein Team zusammenstellen, das alle Anforderungen erfüllt.",
  "match.result.infeasibleTitle": "Keine Lösung gefunden",
  "match.result.insights.aiCriterionCandidates": "{count} Kandidaten",
  "match.result.insights.aiMetShort": "davon {count} per KI erkannt",
  "match.result.insights.aiReasons": "{count} KI Begründungen",
  "match.result.insights.aiShare": "AI-Anteil",
  "match.result.insights.bottlenecks": "Top 3 Bottlenecks",
  "match.result.insights.radius": "Umkreis",
  "match.result.insights.radiusTitle": "{radius} km um {city}",
  "match.result.insights.radiusMapAria": "Umkreis-Karte: Kandidaten nach Distanz zu {city}",
  "match.result.insights.radiusInside": "{count} innerhalb",
  "match.result.insights.radiusOutside": "{count} außerhalb",
  "match.result.insights.radiusMissing": "{count} ohne Distanz",
  "match.result.insights.radiusHint": "Winkel schematisch, Distanzskala gestaucht",
  "match.result.insights.failCount": "{failed}/{total} ausgeschlossen",
  "match.result.insights.fulfilledShort": "{met}/{total} erfüllt",
  "match.result.insights.gapShort": "{value} Lücke",
  "match.result.insights.hardestMust": "K.O.-Kriterium",
  "match.result.insights.header": "Match-Analyse",
  "match.result.insights.koPassing": "erfüllen",
  "match.result.insights.noAiReasons": "Keine KI Begründungen.",
  "match.result.insights.noBottleneck": "Keine auffälligen Engpässe.",
  "match.result.insights.noExclusion": "Kein Muss-Kriterium schließt aus.",
  "match.result.insights.noFulfilled": "Kein Kriterium wird erfüllt.",
  "match.result.insights.averageShort": "Ø {value}",
  "match.result.insights.medianShort": "Median {value}",
  "match.result.insights.requiredShort": "Soll {value}",
  "match.result.insights.sdShort": "SD {value}",
  "match.result.insights.personDetailsInfoAria": "Hinweis zu Personen-Details anzeigen",
  "match.result.insights.personDetailsInfoBody": "Personen-Details werden nicht als Analyse-Verteilung dargestellt. Sie bleiben im Kandidaten-Detail sichtbar.",
  "match.result.insights.personDetailsInfoTitle": "Personen-Details",
  "match.result.insights.reasonsShort": "{count} Reasons",
  "match.result.insights.recommendAi": "{count} KI Begründungen bei {candidates} Kandidaten manuell prüfen.",
  "match.result.insights.recommendBottleneck": "{criterion} ist der stärkste Engpass; Ø Erfüllung {average}.",
  "match.result.insights.recommendData": "Profilwerte für {criterion} nachpflegen; {missing}/{total} Nachweise fehlen.",
  "match.result.insights.recommendMust": "{criterion} prüfen oder lockern; dieses Muss-Kriterium schließt {failed}/{total} Kandidaten aus.",
  "match.result.insights.recommendNone": "Keine unmittelbare Anpassung nötig.",
  "match.result.insights.recommendation": "Empfehlung",
  "match.result.insights.textDistribution": "häufigster Wert {value} ({count}/{present}) · {distinct} Varianten",
  "match.result.insights.topFulfilled": "Top 3 erfüllte Kriterien",
  "match.result.insights.unknownShort": "{count} nicht bewertbar",
  "match.result.loadFailed": "Ergebnis konnte nicht geladen werden (id {id}). Browser-Konsole prüfen.",
  "match.result.memberCharacter": "Charakter",
  "match.result.memberCriteriaLess": "weniger anzeigen",
  "match.result.memberCriteriaMore": "alle {n} anzeigen",
  "match.result.memberCoverage": "{met} von {total}",
  "match.result.memberCoverageVsMedian": "{met} von {total} · Team-Median {median, number}",
  "match.result.memberOpenProfile": "Profil",
  "match.result.memberNoPowers": "Keine Power-Einschätzung hinterlegt. Diese Person zählt in keinem Powers-Schnitt des Teams mit – ihr Beitrag oben steht allein auf den Anforderungen.",
  "match.result.memberPowerFit": "Power-Fit {n}",
  "match.result.memberPowerFitInfoAria": "Erklärung zum Power-Fit dieser Person anzeigen",
  "match.result.memberPowerFitInfoBody": "Eigene Powers (0–100), gewichtet mit der Powers Scorecard. Hoch heißt: die Person ist stark genau dort, wo Gewicht liegt – unabhängig davon, wie sie im Teamvergleich steht.",
  "match.result.memberPowersRelative": "Powers im Teamvergleich",
  "match.result.memberCriterionUnrated": "nicht bewertbar",
  "match.result.memberCriterionPartial": "teilweise erfüllt",
  "match.result.memberCriterionOpen": "nicht erfüllt",
  "match.result.memberCriterionMet": "erfüllt",
  "match.result.memberAnchorSole": "{name} (allein)",
  "match.result.memberAnchors": "Trägt: {list}",
  "match.result.memberRequirements": "Anforderungen",
  "match.result.memberCriticalTag": "kritisch",
  "match.result.memberSummaryCriticalMust": "Ohne diese Person {count, plural, one {fällt das Muss} other {fallen die Muss-Kriterien}} {list}.",
  "match.result.memberSummaryNoCoverage": "Erfüllt keine Anforderung – der Beitrag liegt in den Powers, nicht in den Fachkriterien.",
  "match.result.memberSummaryNoCoverageNoPowers": "Erfüllt keine Anforderung – und ohne Power-Einschätzung ist über den Beitrag sonst nichts bekannt.",
  "match.result.memberSummaryTopCoverage": "Deckt die meisten Anforderungen im Team.",
  "match.result.memberSummaryTopPowerFit": "Höchster Power-Fit im Team.",
  "match.result.memberSummaryCritical": "Kritisch für {list}.",
  "match.result.memberSummaryExclusiveSkills": "Einzige mit {list}{rest, plural, =0 {} other { und # weiteren}} auf starker Stufe.",
  "match.result.memberWhy": "Warum im Team",
  "match.result.memberWhySuited": "Warum geeignet",
  "match.result.noRequirementsEmpty": "Diese Match-Definition hat keine Anforderungen – die Anforderungs-Matrix bleibt leer.",
  "match.result.openFlag": "offen",
  "match.result.openProfileTitle": "{name} – Profil öffnen",
  "match.result.powers.reqBadge": "Trägt zu {met} von {total} Power-Anforderungen bei",
  "match.result.powers.memberBadge": "Mittel aller 30 Powers dieser Person (0–100)",
  "match.result.powers.memberBadgeUnmeasured": "Ohne Powers-Daten – zählt in keinem Schnitt mit",
  "match.result.powers.expandClusterAria": "{cluster} aufklappen – einzelne Powers anzeigen",
  "match.result.powers.collapseClusterAria": "{cluster} einklappen",
  "match.result.radarActual": "Team · Ist",
  "match.result.radarActualPerson": "Person · Ist",
  "match.result.radarScopeCluster": "Cluster",
  "match.result.radarScopeElement": "Alle {count} Powers",
  "match.result.radarTarget": "Powers Scorecard",
  "match.result.radarTitleActual": "Ist",
  "match.result.radarTitleUnmeasured": "{count, plural, =0 {niemand im Team eingeschätzt} one {nur # Person eingeschätzt} other {nur # Personen eingeschätzt}}",
  "match.result.radarTitleUnmeasuredPerson": "nicht bewertet",
  "match.result.radarTitleWish": "Gewichtung",
  "match.result.ranking.aiChip": "KI Begründung",
  "match.result.ranking.aiChipTitle": "Begründung aus der KI-Auswertung",
  "match.result.ranking.assessment.fazit": "Fazit",
  "match.result.ranking.assessment.negative": "Negativ",
  "match.result.ranking.assessment.positive": "Positiv",
  "match.result.ranking.assessment.title": "Smycles Einschätzung",
  "match.result.ranking.collapseAll": "Alle einklappen",
  "match.result.ranking.expandAll": "Alle aufklappen",
  "match.result.ranking.kindBasics": "Personen-Details",
  "match.result.ranking.kindCertificate": "Zertifikat",
  "match.result.ranking.kindEducation": "Ausbildung",
  "match.result.ranking.kindExperience": "Berufserfahrung",
  "match.result.ranking.kindExpertise": "Fachwissen",
  "match.result.ranking.kindLanguage": "Sprache",
  "match.result.ranking.kindPowers": "Powers",
  "match.result.ranking.lenientMatchHint": "Erfüllt per kulanter Anforderungsprüfung: Fachwissen vorhanden, geforderte Stufe nicht belegt.",
  "match.result.ranking.dotUnknown": "Zu prüfen",
  "match.result.ranking.dotFulfilled": "Erfüllt",
  "match.result.ranking.dotPartial": "Teilweise erfüllt",
  "match.result.ranking.dotUnfulfilled": "Nicht erfüllt",
  "match.result.ranking.emptyHintLabel": "Hinweis",
  "match.result.ranking.emptyFilteredTab": "Keine {requirement}-Kriterien unter „{tab}“.",
  "match.result.ranking.emptyShowAll": "Alle Kriterien zeigen",
  "match.result.ranking.emptySwitchTab": "Zu „{tab}“ wechseln",
  "match.result.ranking.emptyTab": "Unter „{tab}“ gibt es keine Kriterien.",
  "match.result.ranking.tabNameFulfilled": "Erfüllt",
  "match.result.ranking.tabNameLenient": "Kulant erfüllt",
  "match.result.ranking.tabNameUnknown": "Zu prüfen",
  "match.result.ranking.tabNameUnfulfilled": "Nicht erfüllt",
  "match.result.ranking.lenientTab": "Kulant erfüllt ({count})",
  "match.result.ranking.must": "Muss",
  "match.result.ranking.kpiSmycles": "Smycles Score",
  "match.result.ranking.kpiPowerFit": "Power-Fit",
  "match.result.ranking.mustTitle": "Muss-Kriterien",
  "match.result.ranking.mustNone": "Keine Muss-Kriterien",
  "match.result.ranking.mustInfoTitle": "Muss-Kriterien",
  "match.result.ranking.mustInfoAria": "Muss-Kriterien anzeigen",
  "match.result.ranking.mustFormula": "Muss-Kriterien sind harte Gates: jedes muss erfüllt sein.",
  "match.result.ranking.mustMetSummary": "Erfüllt: {met}/{total}",
  "match.result.ranking.criterionMet": "erfüllt",
  "match.result.ranking.criterionFailed": "nicht erfüllt",
  "match.result.ranking.kannTitle": "Kann-Kriterien",
  "match.result.ranking.scoreCriteriaValue": "Kann-Kriterien: {criteria}",
  "match.result.ranking.filterAll": "Alle",
  "match.result.ranking.filterMust": "Muss",
  "match.result.ranking.filterKann": "Kann",
  "match.result.ranking.sortSmycles": "Smycles",
  "match.result.ranking.powerFitClusterCompare": "Cluster im Vergleich",
  "match.result.ranking.powerFitClusterCompareExplainer": "Cluster-Werte dieser Person gegenüber dem Schnitt aller Kandidaten in dieser Rangliste.",
  "match.result.ranking.powerFitPoolCompareSummary": "{above} von {total} Clustern über dem Schnitt aller Kandidaten",
  "match.result.ranking.powerFitRadarExplainer": "Ist-Profil dieser Person gegenüber der Powers Scorecard des Matches.",
  "match.result.ranking.powerFitTiltsExplainer": "Wo diese Person zwischen den beiden Polen jeder Achse liegt.",
  "match.result.ranking.powerFitTiltsHeading": "Neigung",
  "match.result.ranking.noAssessment": "Keine Smycles-Einschätzung vorhanden.",
  "match.result.ranking.noCriteria": "Keine Kriterien definiert",
  "match.result.ranking.noMustHint": "Hier landen Bewerber, die ein Muss-Kriterium (Schloss) verfehlen oder deren Score unter der C-Schwelle liegt.",
  "match.result.ranking.notRated": "Vorhanden · Stufe nicht bewertet",
  "match.result.ranking.openProfile": "Profil öffnen",
  "match.result.ranking.optional": "Kann",
  "match.result.ranking.powerFitTooltip": "Power-Fit: gewichtetes Mittel der eigenen Power-Werte dieser Person.",
  "match.result.ranking.review": "Zu prüfen",
  "match.result.ranking.reviewHint": "Hier landen Bewerber, bei denen ein Kriterium nicht bewertet werden konnte, etwa ein Fachwissen ohne eingestufte Stufe. Sie sind nicht durchgefallen, sondern brauchen einen Blick.",
  "match.result.ranking.reviewReasonBoth": "Muss und Kann nicht bewertbar",
  "match.result.ranking.reviewReasonKann": "Kann-Kriterien nicht bewertbar",
  "match.result.ranking.reviewReasonMust": "Muss-Kriterium nicht bewertbar",
  "match.result.ranking.scoreCoverage": "{assessable} von {defined} Kriterien bewertbar",
  "match.result.ranking.scoreFormula": "Score = Durchschnitt der Kann-Kriterien.",
  "match.result.ranking.scoreInfoAria": "Rechenweg anzeigen",
  "match.result.ranking.scoreInfoTitle": "Rechenweg",
  "match.result.ranking.scoreMustGate": "Muss-Kriterien bleiben zusätzlich ein hartes Gate.",
  "match.result.ranking.scoreNotAssessable": "Kann-Kriterien: nicht bewertbar",
  "match.result.ranking.sortBy": "Sortieren nach",
  "match.result.ranking.sortPower": "Power-Fit",
  "match.result.ranking.sortRequirements": "Anforderungs-Fit",
  "match.result.ranking.thresholdAAria": "Schwelle zwischen A und B",
  "match.result.ranking.thresholdBAria": "Schwelle zwischen B und C",
  "match.result.ranking.thresholdCAria": "Untergrenze für C",
  "match.result.ranking.thresholdsLabel": "Schwellen",
  "match.result.ranking.unknownTab": "Zu prüfen ({count})",
  "match.result.ranking.unqualified": "Kriterien nicht erfüllt",
  "match.result.ranking.yearsValue": "{years, plural, one {# Jahr} other {# Jahre}}",
  "match.result.rankingHeader": "Ranking",
  "match.result.reviewSubtitle": "Optimiert auf dein Anforderungsprofil – transparent, erklärbar, exportierbar.",
  "match.result.saveResult": "Ergebnis speichern",
  "match.result.savedResultLabel": "Gespeichertes Ergebnis · {name}",
  "match.result.savedSubtitle": "Du siehst ein gespeichertes Ergebnis dieses Matches.",
  "match.result.skillMaxLevel": "bis {level}",
  "match.result.skillRequested": "Anforderung",
  "match.result.skillStrongOfTeam": "{n} von {total} stark",
  "match.result.skillTotalAtAll": "{n} überhaupt",
  "match.result.solverErrorBody": "Genesis hat die Berechnung abgelehnt. Das passiert aktuell, wenn das Match-Design Felder enthält, die das Backend (noch) nicht kennt. Probier es nach kurzer Zeit erneut oder melde den Fall mit der unten stehenden Korrelations-ID.",
  "match.validationRejected": "Genesis hat die Anfrage abgelehnt.",
  "match.result.solverErrorHeading": "Das Backend hat den Solver nicht beendet.",
  "match.result.solverErrorTitle": "Solver-Fehler",
  "match.result.solverNotRun": "Solver noch nicht gelaufen.",
  "match.result.skillMatrix": "Fachkompetenz-Matrix",
  "match.result.skillMatrixUnrated": "vorhanden, keine Stufe",
  "match.result.skillMatrixFocusSkill": "Skill Fokus",
  "match.result.skillMatrixFocusTeam": "Team Fokus",
  "match.result.skillStrongHint": "stark ab {level}",
  "match.result.skillStructureHeader": "Top Skills",
  "match.result.solverRunning": "Solver läuft …",
  "match.result.tilt.axis.DRIVE": "Antrieb ↔ Anziehung",
  "match.result.tilt.axis.MINDSET": "Exploit ↔ Explore",
  "match.result.tilt.balanced": "ausgeglichen",
  "match.result.tilt.bothWeak": "beidseitig schwach",
  "match.result.tilt.infoAria": "Erklärung zu den Team-Achsen anzeigen",
  "match.result.tilt.info.DRIVE": "Anteil der Powers über {threshold}: Antrieb {a}%, Anziehung {b}%. Antriebskräfte treiben von innen an, Anziehungskräfte schaffen die Bedingungen, unter denen Antrieb im Team ankommt. Verglichen werden Anteile, weil Antrieb vier Cluster umfasst und Anziehung zwei.",
  "match.result.tilt.info.MINDSET": "Anteil der Powers über {threshold}, innerhalb des Antriebs: Exploit {a}%, Explore {b}%. Exploit sichert und optimiert das Bestehende, Explore öffnet das Mögliche. Teams, die beides vereinen, sind leistungsfähiger als einseitige.",
  "match.result.tilt.grade.CLEAR": "klar {side}",
  "match.result.tilt.grade.LEANS": "eher {side}",
  "match.result.tilt.grade.STRONG": "deutlich {side}",
  "match.result.tilt.notSignificant": "Unterschied zu klein, um ihn zu deuten",
  "match.result.tilt.infoNoise": "Die Abstufung richtet sich danach, wie weit der Unterschied seinen eigenen Stichprobenfehler übersteigt: eher = darüber, klar = das Anderthalbfache, deutlich = das Doppelte. Mehr als diese drei Stufen wird nicht angegeben: bei dieser Teamgröße ist der genaue Unterschied nicht belastbar genug, um als Zahl zu gelten.",
  "match.result.tilt.side.EXPLOIT": "Exploit",
  "match.result.tilt.side.EXPLORE": "Explore",
  "match.result.tilt.side.PULL": "Anziehung",
  "match.result.tilt.side.PUSH": "Antrieb",
  "match.result.structureBoosters": "Booster-Deckung",
  "match.result.structureBoostersHint": "Booster sind die Powers mit der höchsten Innovationsrelevanz. Eine schwach gedeckte Zeile ist die konkrete Lücke des Teams.",
  "match.result.memberClusterCountInfoAria": "Erklärung zu Zählung und Abstand anzeigen",
  "match.result.memberClusterCountInfoBody": "Zählung: wie viele der 5 Cluster-Powers dieser Person über {threshold} liegen – ein Mittel von 68 kann fünfmal 68 sein oder eine starke Power neben vier schwachen. Balken: er steht auf dem Cluster-Mittel des Teams – nach rechts hebt die Person das Team hier, nach links liegt sie darunter. Am Ende ihr eigenes Cluster-Mittel.",
  "match.result.memberClusterCountInfoTitle": "Zählung und Abstand",
  "match.result.structureBoostersInfoAria": "Erklärung zur Booster-Deckung anzeigen",
  "match.result.structureBoostersInfoBody": "Gezeigt wird, wie viele der bewerteten Personen die Power stark mitbringen (über {threshold}). Eine solche Lücke lässt sich durch Umbesetzung schließen oder gezielt entwickeln.",
  "match.result.structureBoostersInfoTitle": "Booster und Lücken",
  "match.result.structureCarriersInfoAria": "Erklärung zur Zählung anzeigen",
  "match.result.structureCarriersInfoBody": "Gezählt werden die Personen mit Powers-Daten, nicht das ganze Team: „2 von 6“ heißt zwei Träger unter sechs bewerteten Personen.",
  "match.result.structureCarriersInfoTitle": "Was gezählt wird",
  "match.result.structureCarriers": "Cluster-Träger",
  "match.result.structureCarriersHint": "Träger = mindestens {min} von 5 Powers des Clusters über {threshold}; vollständig = alle 5 darüber.",
  "match.result.structureHeader": "Powers Profilstruktur",
  "match.result.structureOfTeam": "{n} von {total}",
  "match.result.structureSignature": "· {n} vollständig",
  "match.result.structureThresholdHint": "Powers über {threshold}",
  "match.result.teamHeader": "Team · {count, plural, one {# Person} other {# Personen}}",
  "match.result.teamPowers": "Power-Scorecard-Matrix",
  "match.result.teamSizeMeta": "Teamgröße {count}",
  "match.result.unnamed": "ohne Namen",
  "match.result.weightedPowersInfoAria": "Erklärung zu dieser Liste anzeigen",
  "match.result.weightedPowersInfoBody": "Alle 30 Powers des Teams, sortierbar nach Team-Score oder nach Gewichtung. Gewichtung: der Wert 0–10 aus der Powers Scorecard, mit dem die Auswahl gesteuert wurde. Ø: das Mittel des Teams bei dieser Power, 0–100.",
  "match.result.weightedPowersInfoTitle": "Was hier steht",
  "match.result.weightedPowersSoleHint": "„nur …“ heißt: einzige Person, die diese Power stark mitbringt.",
  "match.save.eyebrow": "Ergebnis speichern",
  "match.save.failed": "Speichern fehlgeschlagen",
  "match.save.modeAssess": "Bewerten",
  "match.save.modeOptimize": "Optimieren",
  "match.save.modeRank": "Rangliste",
  "match.save.note": "Notiz",
  "match.save.notePlaceholder": "Optional – Kontext, Annahmen, nächste Schritte …",
  "match.save.off": "aus",
  "match.save.on": "ein",
  "match.save.previewAndNote": "Vorschau & Notiz",
  "match.save.resultName": "Ergebnis-Name",
  "match.save.retry": "Erneut versuchen",
  "match.save.saved": "Gespeichert",
  "match.save.saving": "Speichert…",
  "match.save.statAgenticAi": "Agentic AI",
  "match.save.statConditions": "Bedingungen",
  "match.save.statMode": "Modus",
  "match.save.statPool": "Pool",
  "match.save.statTarget": "Soll",
  "match.save.teamCount": "Team · {count, plural, one {# Person} other {# Personen}}",
  "match.settingsEyebrow": "Match-Einstellungen",
  "match.shortDescPlaceholder": "In einem Satz: was, wofür?",
  "match.step.challenge": "Challenge",
  "match.step.people": "Teamplayer",
  "match.step.peopleRank": "Kandidaten",
  "match.step.result": "Result",
  "match.teamPowers": "Power-Scorecard",
  "match.teamProfile": "Auswahl",
  "match.teamProfileCustom": "Individuell",
  "match.teamProfileModifiedSuffix": " · geändert",
  "match.roleReqsSection": "Rollenanforderungen",
  "match.teamReqsSection": "Teamanforderungen",
  "match.teamSizeSection": "Größe des Teams",
  "match.titlePlaceholder": "z. B. Set-Crew BTL · Q2 2026",
  "match.tour.create.desc": "Dieser Button erstellt ein neues Match und öffnet den Editor. Dort beschreibst du, was du brauchst, und der Solver schlägt das Team vor.",
  "match.tour.create.title": "Neues Match erstellen",
  "match.tour.label": "Match",
  "match.tour.list.desc": "Alle deine Matches wohnen hier. Klicke eine Karte, um sie wieder zu öffnen und weiterzumachen.{names}",
  "match.tour.list.names": "Aktuell: {list}.",
  "match.tour.list.title": "Deine Matches",
  "match.tour.summary": "Das ist der Match-Bereich: Hier stellst du Teams aus Menschen und Anforderungen zusammen. Du hast bisher {count} Matches.",
  "match.unnamedMatch": "Unbenanntes Match",
  "match.unnamedProject": "Unbenanntes Projekt",
  "match.weightLevel.high": "Hoch",
  "match.weightLevel.low": "Niedrig",
  "match.weightLevel.medium": "Mittel",
  "match.weightLevel.none": "Nicht relevant",
  "match.workflow.challengeSubtitle": "Beschreibe oben dein Projekt – die KI leitet daraus Team-Größe, Anforderungen und Powers ab. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.challengeSubtitleNoTeamSize": "Beschreibe oben dein Projekt – die KI leitet daraus Anforderungen und Powers ab. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.challengeSubtitleRank": "Beschreibe oben die Rolle bzw. offene Stelle – die KI leitet daraus die Anforderungen ab, die ein:e Kandidat:in erfüllen soll. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.deleteConfirm.confirm": "Löschen",
  "match.workflow.deleteConfirm.message": "Das Match wird endgültig aus genesis entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  "match.workflow.deleteConfirm.title": "Match löschen?",
  "match.workflow.deleteTitle": "Match löschen",
  "match.workflow.modeAssess": "Bewerten",
  "match.workflow.modeIndicatorTitle": "Modus (bei Erstellung festgelegt)",
  "match.workflow.modeOptimize": "Optimieren",
  "match.workflow.modeRank": "Rangliste",
  "match.workflow.nextTo": "Weiter zu {label}",
  "match.workflow.prevTo": "Zurück zu {label}",
  "match.workflow.settingsTitle": "Match-Einstellungen",
  "matchDetail.tour.label": "Match Detail",
  "matchDetail.tour.summary": "Du bearbeitest das Match „{name}“, gerade im Workflow-Schritt „{step}“ mit {candidates} Kandidaten und {results} gespeicherten Ergebnissen. Arbeite die Schritte von den Anforderungen bis zum fertigen Team durch.",
  "matchDetail.tour.untitled": "unbenanntes Match",
  "model.connected": "Verbunden",
  "model.docs.title": "Wissensdokumente",
  "model.docs.sub": "Dokumente, die der Assistent durchsuchen kann. Uploads werden im Hintergrund verarbeitet.",
  "model.docs.dropLabel": "Dokument hierher ziehen oder zum Auswählen klicken",
  "model.docs.dropHint": "PDF, Word, PowerPoint und mehr, bis zu 50 MB",
  "model.docs.titlePlaceholder": "Titel (erforderlich)",
  "model.docs.titleLabel": "Dokumenttitel",
  "model.docs.descPlaceholder": "Worum es geht (optional)",
  "model.docs.descLabel": "Dokumentbeschreibung",
  "model.docs.upload": "Hochladen und verarbeiten ({provider})",
  "model.docs.duplicate": "Dieses Dokument wurde bereits hochgeladen.",
  "model.docs.uploadError": "Upload fehlgeschlagen – bitte erneut versuchen.",
  "model.docs.loadError": "Dokumente konnten nicht geladen werden.",
  "model.docs.empty": "Noch keine Dokumente.",
  "model.docs.unavailableHint": "Nicht für den aktuellen Anbieter eingebettet. Neu einbetten, um es durchsuchbar zu machen.",
  "model.docs.status.reembedRequired": "Neue Verarbeitung erforderlich ({provider})",
  "model.docs.status.processingFor": "In Bearbeitung ({provider})",
  "model.docs.worksWith": "Funktioniert mit diesem Anbieter",
  "model.docs.textOnly": "Nur Text",
  "model.docs.textOnlyHint": "Bilder überspringen für schnellere Verarbeitung; Text bleibt durchsuchbar.",
  "model.docs.textOnlyForced": "Aus diesem Dateityp können keine Bilder extrahiert werden; er wird als Text indexiert.",
  "model.docs.enabledLabel": "Aktiviert",
  "model.docs.download": "Herunterladen",
  "model.docs.reprocess": "Neu verarbeiten",
  "model.docs.delete": "Löschen",
  "model.docs.deleteTitle": "Dokument löschen?",
  "model.docs.deleteMessage": "„{title}“ und der extrahierte Inhalt werden entfernt.",
  "model.docs.sectionUploaded": "Hochgeladene Dokumente",
  "model.docs.sectionGlobal": "Globale Dokumente",
  "model.docs.uploadedAt": "Hochgeladen am {date}",
  "model.docs.failedHint": "Verarbeitung fehlgeschlagen. Erneut verarbeiten oder das Dokument neu hochladen.",
  "model.docs.cancel": "Abbrechen",
  "model.docs.cancelTitle": "Verarbeitung abbrechen?",
  "model.docs.cancelMessage": "„{title}“ wird nicht weiter verarbeitet und entfernt.",
  "model.docs.cancelKeep": "Weiter verarbeiten",
  "model.docs.cancelReprocessTitle": "Neuverarbeitung stoppen?",
  "model.docs.cancelReprocessMessage": "„{title}“ bleibt unverändert. Die laufende Verarbeitung wird verworfen.",
  "model.docs.cancelReprocessConfirm": "Neuverarbeitung stoppen",
  "model.docs.uploadBlocked": "Warten, bis der Anbieterwechsel wirksam ist… ({seconds}s)",
  "model.docs.needFile": "Zum Hochladen ein Dokument auswählen.",
  "model.docs.needTitle": "Titel angeben.",
  "model.docs.needSections": "Mindestens einen Bereich auswählen.",
  "model.docs.status.pending": "Ausstehend",
  "model.docs.status.processing": "In Bearbeitung",
  "model.docs.status.ready": "Bereit",
  "model.docs.status.failed": "Fehlgeschlagen",
  "model.keyAriaLabel": "{provider} API-Schlüssel",
  "model.providerSub": "Der zugrunde liegende Modell-Stack. Modellarten werden auf die konkreten Modelle dieses Anbieters aufgelöst.",
  "model.providerSwitchHint": "Der Wechsel zu {provider} ändert das Embedding-Modell ({from} → {to}). Möglicherweise müssen die Dokumente nach dem Speichern erneut verarbeitet werden, damit sie durchsuchbar bleiben.",
  "model.providerTitle": "Anbieter",
  "model.resolvedModels": "Aufgelöste Modelle",
  "model.saveError": "Modelleinstellungen konnten nicht gespeichert werden – bitte erneut versuchen.",
  "model.saveError.forbidden": "Für Änderungen an der Modellkonfiguration sind Administratorrechte erforderlich.",
  "model.saveError.notConfigured": "Die Modellkonfiguration ist auf diesem Server nicht aktiviert.",
  "model.saveError.unauthorized": "Ihre Sitzung ist abgelaufen – bitte erneut anmelden.",
  "model.saveError.upstream": "Der Konfigurationsspeicher ist nicht erreichbar – bitte erneut versuchen.",
  "model.saved": "Einstellungen gespeichert – die Änderung kann bis zu 30 Sekunden dauern.",
  "nav.community": "Community",
  "nav.inviteOutsider": "Externe Person einladen",
  "nav.logout": "Abmelden",
  "nav.mainLandmark": "Hauptnavigation",
  "nav.map": "Map",
  "nav.openMenu": "Menü öffnen",
  "nav.pins": "Pins",
  "nav.play": "Play",
  "nav.profile": "Profil",
  "nav.service": "Dokumente",
  "nav.settings": "Einstellungen",
  "nav.watch": "Watch",
  "personFilter.addFilter": "+ Filter hinzufügen",
  "personFilter.allFilters": "Alle Filter",
  "personFilter.frequent": "Häufig",
  "personFilter.heading": "Teamplayer-Filter{count, plural, =0 {} other { · # aktiv}}",
  "pinboard.tour.controls.desc": "Suche Pins nach Namen, ändere die Sortierung oder filtere auf Pins, die noch in keiner Gruppe sind.",
  "pinboard.tour.controls.title": "Suchen & Sortieren",
  "pinboard.tour.grid.desc": "{count} {typeLabel} in der aktuellen Ansicht. Klicke eine Karte, um sie zu öffnen, nutze „+ Hinzufügen“ für Gruppen oder das Papierkorb-Symbol zum Entpinnen.",
  "pinboard.tour.grid.title": "Deine gepinnten Einträge",
  "pinboard.tour.label": "Save Pins",
  "pinboard.tour.sidebar.desc": "Wechsle zwischen deinen gepinnten Personen ({people}), Beiträgen ({posts}) und Projekten ({projects}) und wähle darunter eine Pin-Gruppe. Ziehe eine Karte auf eine Gruppe, um sie dort abzulegen.",
  "pinboard.tour.sidebar.title": "Typen & Gruppen",
  "pinboard.tour.summary": "Das ist deine Pinnwand mit allem, was du gespeichert hast: {people} Personen, {posts} Beiträge und {projects} Projekte.",
  "power.name.Abs": "Abstraktion",
  "power.name.Ada": "Adaption",
  "power.name.Agg": "Aggression",
  "power.name.Aut": "Autonomie",
  "power.name.Awe": "Selbstwahrnehmung",
  "power.name.Cha": "Charisma",
  "power.name.Con": "Konzentration",
  "power.name.Cop": "Toleranz",
  "power.name.Cou": "Mut",
  "power.name.Cur": "Neugierde",
  "power.name.Dil": "Sorgfalt",
  "power.name.Emp": "Empathie",
  "power.name.Exp": "Expression",
  "power.name.Fai": "Glaube",
  "power.name.Fid": "Treue",
  "power.name.Fns": "Fairness",
  "power.name.Hum": "Humor",
  "power.name.Ima": "Imagination",
  "power.name.Imp": "Improvisation",
  "power.name.Ins": "Inspiration",
  "power.name.Int": "Intention",
  "power.name.Inu": "Intuition",
  "power.name.Joy": "Freude",
  "power.name.Lan": "Sprache",
  "power.name.Min": "Achtsamkeit",
  "power.name.Pas": "Passion",
  "power.name.Per": "Wahrnehmung",
  "power.name.Psc": "Ausdauer",
  "power.name.Rpy": "Verantwortung",
  "power.name.Str": "Strategie",
  "power.tag.Co": "Kommunikationsfähigkeit",
  "power.tag.Co.description": "Das Erfassen und Vermitteln. Diese Powers verwandeln inneres Erleben in geteilte Wahrnehmung, Sprache und Ausdruck.",
  "power.tag.Fo": "Zukunftsorientierung",
  "power.tag.Fo.description": "Richtung auf das Ungewisse. Diese Powers geben dem Team die Kraft, über das Bestehende hinauszudenken und ins Offene zu gehen.",
  "power.tag.In": "Erfindungsstärke",
  "power.tag.In.description": "Das Erschließen des Neuen. Diese Powers öffnen den Raum jenseits des Bekannten und halten das Team lernfähig.",
  "power.tag.Re": "Belastbarkeit",
  "power.tag.Re.description": "Stabilität unter Last. Diese Powers halten das Team handlungsfähig, wenn Druck, Dauer und Widerstand zunehmen.",
  "power.tag.Ro": "Ergebnisorientierung",
  "power.tag.Ro.description": "Verbindlichkeit im Ergebnis. Diese Powers verwandeln Absicht in verlässlich vollendete, wirksame Arbeit.",
  "power.tag.Ts": "Teamfähigkeit",
  "power.tag.Ts.description": "Der Kitt der Gemeinschaft. Diese Powers machen aus Einzelnen ein tragfähiges, vielfältiges und belastbares Miteinander.",
  "profile.fields.addCountry": "+ Land",
  "profile.fields.avatarAlt": "Avatar",
  "profile.fields.changePhoto": "Foto ändern",
  "profile.fields.removePhoto": "Foto entfernen",
  "profile.page.add.certificate": "Zertifikat hinzufügen",
  "profile.page.add.education": "Ausbildung hinzufügen",
  "profile.page.add.experience": "Berufserfahrung hinzufügen",
  "profile.page.add.expertise": "Skill hinzufügen",
  "profile.page.add.language": "Sprache hinzufügen",
  "profile.page.addToCommunity": "Community",
  "profile.page.addToPins": "Pins",
  "profile.page.ageSuffix": "{age} Jahre",
  "profile.page.avatar.tooLarge": "Wähle ein Bild mit maximal {max} MB.",
  "profile.page.avatar.notAnImage": "Wähle eine Bilddatei.",
  "profile.page.avatar.notReadable": "Diese Datei konnte nicht als Bild gelesen werden.",
  "profile.page.avatar.tooManyPixels": "Dieses Bild ist zu groß zum Zuschneiden. Nutze eines unter {max} Megapixel.",
  "profile.page.allLabel": "Alle:",
  "profile.page.businessCard": "Visitenkarte",
  "profile.page.businessCardRoleHint": "Übernommen aus Details › Unternehmen › Berufsbezeichnung",
  "profile.page.details": "Details",
  "profile.page.details.company": "Unternehmen",
  "profile.page.details.personal": "Persönlich",
  "profile.page.editVisibility": "Sichtbarkeiten bearbeiten",
  "profile.page.empty.certificates": "Keine Zertifikate",
  "profile.page.empty.education": "Keine Ausbildung",
  "profile.page.empty.experience": "Keine Berufserfahrung",
  "profile.page.empty.expertise": "Keine Skills",
  "profile.page.empty.languages": "Keine Sprachen",
  "profile.page.error.certificateNameRequired": "Name ist erforderlich.",
  "profile.page.error.fieldOfStudyRequired": "Fachrichtung ist erforderlich.",
  "profile.page.error.jobTitleRequired": "Stellenbezeichnung ist erforderlich.",
  "profile.page.error.languageLevelRequired": "Bitte ein Niveau für die Fremdsprache wählen.",
  "profile.page.error.nameRequired": "Vorname und Nachname sind erforderlich.",
  "profile.page.error.invalidFields": "{count, plural, one {Ein Feld muss noch korrigiert werden} other {# Felder müssen noch korrigiert werden}}, bevor gespeichert werden kann.",
  "profile.page.error.saveEntries": "Einträge konnten nicht gespeichert werden",
  "profile.page.error.saveEntriesFailedCount": "{count, plural, one {# Eintrag konnte nicht gespeichert werden.} other {# Einträge konnten nicht gespeichert werden.}}",
  "profile.page.error.saveFailed": "Speichern fehlgeschlagen.",
  "profile.page.error.saveCertificate": "Das Zertifikat konnte nicht gespeichert werden.",
  "profile.page.error.saveEducation": "Die Ausbildung konnte nicht gespeichert werden.",
  "profile.page.error.saveExperience": "Die Erfahrung konnte nicht gespeichert werden.",
  "profile.page.error.saveLanguage": "Die Sprache konnte nicht gespeichert werden.",
  "profile.page.error.saveSkill": "Das Fachwissen konnte nicht gespeichert werden.",
  "profile.page.error.savePerson": "Person konnte nicht gespeichert werden",
  "profile.page.error.skillNameRequired": "Ein Name ist erforderlich.",
  "profile.page.error.tooManyActivities": "Nicht mehr als {max} Einträge.",
  "profile.page.error.startDateRequired": "Startdatum ist erforderlich.",
  "profile.page.familyName.placeholder": "Nachname",
  "profile.page.field.activities.label": "Hauptaufgaben",
  "profile.page.field.activities.placeholder": "z. B. Code-Reviews",
  "profile.page.field.activities.counter": "{count} von {max}",
  "profile.page.field.cefr": "Niveau (CEFR)",
  "profile.page.field.certificateName.label": "Bezeichnung",
  "profile.page.field.certificateName.placeholder": "z. B. AWS Solutions Architect",
  "profile.page.field.country": "Land",
  "profile.page.field.degree.label": "Abschluss",
  "profile.page.field.degree.placeholder": "Abschluss auswählen",
  "profile.page.field.degree.search": "Abschluss suchen",
  "profile.page.field.degree.none": "Kein Abschluss ausgewählt",
  "profile.page.field.department": "Abteilung",
  "profile.page.field.employer.label": "Arbeitgeber",
  "profile.page.field.employer.placeholder": "z. B. Smycles GmbH",
  "profile.page.field.expertiseName.label": "Bezeichnung",
  "profile.page.field.expertiseName.placeholder": "z. B. Kubernetes",
  "profile.page.field.field.label": "Fachrichtung",
  "profile.page.field.field.placeholder": "z. B. Informatik",
  "profile.page.field.from": "Von",
  "profile.page.field.industry": "Branche",
  "profile.page.field.institution": "Bildungseinrichtung",
  "profile.page.field.issueDate": "Ausstellungsdatum",
  "profile.page.field.jobTitle.label": "Stellenbezeichnung",
  "profile.page.field.jobTitle.placeholder": "z. B. Softwareentwickler",
  "profile.page.field.language.label": "Sprache",
  "profile.page.field.language.placeholder": "Sprache wählen",
  "profile.page.field.level": "Stufe",
  "profile.page.field.location": "Ort",
  "profile.page.field.nativeSpeaker.label": "Muttersprache",
  "profile.page.field.nativeSpeaker.placeholder": "Muttersprache",
  "profile.page.field.to": "Bis",
  "profile.page.givenName.placeholder": "Vorname",
  "profile.page.hideVisibility": "Sichtbarkeiten ausblenden",
  "profile.page.inCommunity": "In Community",
  "profile.page.inPins": "In Pins",
  "profile.page.label.apartment": "Wohnung",
  "profile.page.label.birthday": "Geburtstag",
  "profile.page.label.childCount": "Anzahl Kinder",
  "profile.page.label.citizenship": "Staatsangehörigkeit",
  "profile.page.label.city": "Wohnort",
  "profile.page.label.contractType": "Vertragsart",
  "profile.page.label.country": "Land",
  "profile.page.label.countryState": "Bundesland / State",
  "profile.page.label.currentActivity": "Aktuelle Tätigkeit",
  "profile.page.label.currentEmployer": "Arbeitgeber",
  "profile.page.label.currentTasks": "Hauptaufgaben",
  "profile.page.label.drivingLicence": "Führerschein",
  "profile.page.label.email": "E-Mail",
  "profile.page.label.gender": "Geschlecht",
  "profile.page.label.houseNumber": "Hausnummer",
  "profile.page.label.jobDepartment": "Abteilung",
  "profile.page.label.jobLocation": "Arbeitsstandort",
  "profile.page.label.jobTitle": "Berufsbezeichnung",
  "profile.page.label.maritalStatus": "Familienstand",
  "profile.page.label.miscellaneous": "Sonstiges",
  "profile.page.label.nationality": "Nationalität",
  "profile.page.label.phone": "Telefon",
  "profile.page.label.profession": "Beruf",
  "profile.page.label.street": "Straße",
  "profile.page.label.website": "Website",
  "profile.page.label.workingTimeModel": "Arbeitszeitmodell",
  "profile.page.label.zipCode": "PLZ",
  "profile.page.loadFailed": "Profil konnte nicht geladen werden",
  "profile.page.loadFailedHint": "Bitte lade die Seite neu oder melde dich erneut an.",
  "profile.page.notFound": "Profil nicht gefunden",
  "profile.page.notFoundHint": "Dieses Profil existiert nicht oder ist nicht für dich freigegeben.",
  "profile.page.openChat": "Chat öffnen",
  "profile.page.section.certificates": "Zertifikate",
  "profile.page.section.education": "Ausbildung",
  "profile.page.section.experience": "Berufserfahrung",
  "profile.page.section.expertise": "Fachwissen",
  "profile.page.section.languages": "Sprachen",
  "profile.page.serviceMenu": "Service",
  "profile.page.startChat": "Nachricht schreiben",
  "profile.page.summary": "Summary",
  "profile.rows.done": "Fertig",
  "profile.rows.level": "Stufe: {level}",
  "profile.rows.nativeSpeaker": "Muttersprache",
  "profile.rows.noLevel": "Kein Niveau",
  "profile.rows.today": "heute",
  "profile.sidebars.closeCluster": "Schließen",
  "profile.sidebars.combined": "Kombiniert",
  "profile.sidebars.errorPrefix": "Fehler: {message}",
  "profile.sidebars.loading": "lädt…",
  "profile.sidebars.noEvaluation": "Noch nicht bewertet.",
  "profile.sidebars.openClusterFor": "Auswertung zu {power} anzeigen",
  "profile.sidebars.powerMap": "Power Map",
  "profile.sidebars.powersNotAssessed": "Diese Person wurde noch nicht bewertet.",
  "profile.sidebars.powersNotShared": "Diese Person hat ihre Powers nicht geteilt.",
  "profile.sidebars.powersTitle": "Powers",
  "profile.sidebars.selfAssessment": "Selbstbewertung",
  "profile.sidebars.smartAnalysis": "Smart Analyse",
  "profile.skills.addAtLevel": "Fachwissen auf dieser Stufe hinzufügen",
  "profile.skills.unrated": "Unbewertet",
  "profile.skills.viewDiagram": "Modern",
  "profile.skills.viewList": "Klassisch",
  "profile.tour.about.desc": "Dein Zusammenfassungstext, deine persönlichen und beruflichen Details und deine {languages} Sprachen. Klicke ein Feld an, um es direkt zu bearbeiten.",
  "profile.tour.about.title": "Zusammenfassung, Details und Sprachen",
  "profile.tour.card.desc": "Klicke ein beliebiges Feld (Name, Telefon, E-Mail, Land, Stadt) und bearbeite es direkt; Änderungen werden gesammelt und über die Speicherleiste gesichert.{missing}",
  "profile.tour.card.missingHint": "Einige deiner Kontaktfelder sind noch leer.",
  "profile.tour.card.title": "Deine Visitenkarte",
  "profile.tour.cv.desc": "{experiences} Berufserfahrungen, {educations} Ausbildungen, {skills} Skills und {certificates} Zertifikate. Lege hier neue Einträge an oder klicke einen bestehenden, um ihn zu bearbeiten.",
  "profile.tour.cv.title": "Deine Lebenslauf-Einträge",
  "profile.tour.label": "Save Profil",
  "profile.tour.powers.desc": "Deine stärksten Powers auf einen Blick. Klicke eine an für ihre Detailseite, oder schätze weitere drüben in Grow ein.",
  "profile.tour.powers.title": "Deine Powers",
  "profile.tour.service.desc": "KI-Helfer und Datenservices für dein Profil: Powers und Skills ermitteln, einen Lebenslauf oder dein LinkedIn-Profil importieren, einen Lebenslauf erzeugen und deine Daten exportieren.",
  "profile.tour.service.title": "Servicemenü",
  "profile.tour.summary": "Das ist dein eigenes Profil mit {count} Lebenslauf-Einträgen. Fast jedes Feld ist direkt auf der Seite bearbeitbar.",
  "profile.tour.visibility.desc": "Dieser Schalter blendet neben jedem Feld und Eintrag einen Freigabe-Schalter ein. So bestimmst du genau, was andere von deinem Profil sehen.",
  "profile.tour.visibility.title": "Sichtbarkeit bearbeiten",
  "profileExtraction.abort": "Extraktion abbrechen",
  "profileExtraction.abortTip": "Die Extraktion läuft noch - du kannst weiter warten oder abbrechen und es mit demselben Dokument erneut versuchen. Gespeichert wurde noch nichts.",
  "profileExtraction.analysing": "Profildaten werden aus deinem Dokument extrahiert - das kann bis zu zwei Minuten dauern...",
  "profileExtraction.dropZone": "Dokument hierher ziehen oder zum Hochladen klicken",
  "profileExtraction.dropZoneHint": "Lebenslauf, LinkedIn-Export, Bewerbung … · PDF, DOCX, Bild · max. 10 MB",
  "profileExtraction.elapsed": "Verstrichene Zeit: {time}",
  "profileExtraction.fileTooLarge": "Datei ist zu groß (max. 10 MB).",
  "profileExtraction.noResult": "Das Dokument konnte nicht analysiert werden.",
  "profileExtraction.timeout": "Die Analyse dauert zu lange. Bitte versuche es erneut.",
  "profileExtraction.nothingNew": "Nichts Neues gefunden – dein Profil deckt dieses Dokument bereits ab.",
  "profileExtraction.ready": "Wir haben Details zum Überprüfen in {file} gefunden.",
  "profileExtraction.review": "Änderungen prüfen",
  "profileExtraction.title": "CV Extractor",
  "profileExtraction.unsupportedType": "Nicht unterstützter Dateityp.",
  "referenceData.add": "Hinzufügen",
  "referenceData.cancel": "Abbrechen",
  "referenceData.confirmDelete.message": "Der Eintrag wird endgültig entfernt und steht in Profilen und Match-Anforderungen nicht mehr zur Auswahl.",
  "referenceData.confirmDelete.title": "„{label}“ löschen?",
  "referenceData.contractType.add": "Neue Vertragsart",
  "referenceData.contractType.empty": "Noch keine Vertragsarten angelegt.",
  "referenceData.contractType.sub": "Verwaltete Liste der Vertragsarten.",
  "referenceData.contractType.title": "Vertragsarten",
  "referenceData.degree.add": "Neuer Abschluss",
  "referenceData.degree.empty": "Noch keine Abschlüsse angelegt.",
  "referenceData.degree.sub": "Verwaltete Liste der Abschlüsse für Ausbildungseinträge.",
  "referenceData.degree.title": "Abschlüsse",
  "referenceData.delete": "Löschen",
  "referenceData.duplicate": "Diesen Eintrag gibt es bereits.",
  "referenceData.edit": "Bearbeiten",
  "referenceData.gender.add": "Neues Geschlecht",
  "referenceData.gender.empty": "Keine Einträge.",
  "referenceData.gender.sub": "Verwaltete Liste der Geschlechter.",
  "referenceData.gender.title": "Geschlechter",
  "referenceData.industry.add": "Neue Branche",
  "referenceData.industry.empty": "Noch keine Branchen angelegt.",
  "referenceData.industry.sub": "Verwaltete Liste der Branchen für Profile und Match-Anforderungen.",
  "referenceData.industry.title": "Branchen",
  "referenceData.jobDepartment.add": "Neue Abteilung",
  "referenceData.jobDepartment.empty": "Noch keine Abteilungen angelegt.",
  "referenceData.jobDepartment.sub": "Verwaltete Liste der Abteilungen für Profile und Match-Anforderungen.",
  "referenceData.jobDepartment.title": "Abteilungen",
  "referenceData.jobLocation.add": "Neuer Arbeitsstandort",
  "referenceData.jobLocation.empty": "Noch keine Arbeitsstandorte angelegt.",
  "referenceData.jobLocation.sub": "Verwaltete Liste der Arbeitsstandorte für Profile und Match-Anforderungen.",
  "referenceData.jobLocation.title": "Arbeitsstandorte",
  "referenceData.loading": "Lädt…",
  "referenceData.maritalStatus.add": "Neuer Familienstand",
  "referenceData.maritalStatus.empty": "Keine Einträge.",
  "referenceData.maritalStatus.sub": "Verwaltete Liste der Familienstände.",
  "referenceData.maritalStatus.title": "Familienstände",
  "referenceData.save": "Speichern",
  "referenceData.workingTimeModel.add": "Neues Arbeitszeitmodell",
  "referenceData.workingTimeModel.empty": "Noch keine Arbeitszeitmodelle angelegt.",
  "referenceData.workingTimeModel.sub": "Verwaltete Liste der Arbeitszeitmodelle.",
  "referenceData.workingTimeModel.title": "Arbeitszeitmodelle",
  "save.addToCollection.adding": "Fügt hinzu…",
  "save.addToCollection.doneInGroup": "<nm>{name}</nm> wurde zu <b>{target}</b> in <b>{group}</b> hinzugefügt.",
  "save.addToCollection.doneNoGroup": "<nm>{name}</nm> wurde zu <b>{target}</b> (ohne Gruppe) hinzugefügt.",
  "save.addToCollection.error": "Konnte nicht hinzufügen. Bitte erneut versuchen.",
  "save.addToCollection.goToTarget": "Zu {target}",
  "save.addToCollection.groupLabel": "Gruppe",
  "save.addToCollection.noGroupPlaceholder": "Ohne Gruppe",
  "save.addToCollection.personFallback": "Person",
  "save.addToCollection.title": "{name} zu {target} hinzufügen",
  "save.careerGraph.active": "Aktiv",
  "save.careerGraph.done": "Fertig",
  "save.careerGraph.emptyLabel": "Keine Karriere-/Bildungseinträge",
  "save.careerGraph.mainTasks": "Hauptaufgaben",
  "save.careerGraph.modeGraph": "Modern",
  "save.careerGraph.modeList": "Klassisch",
  "save.careerGraph.showMainTasks": "Hauptaufgaben anzeigen",
  "save.careerGraph.title": "Career & Education",
  "save.careerGraph.today": "heute",
  "save.careerGraph.todayMarker": "HEUTE",
  "save.careerGraph.visibilityPrivate": "Privat",
  "save.careerGraph.visibilityPublic": "Öffentlich",
  "save.careerGraph.visibilityShared": "Geteilt",
  "save.collection.addToGroup": "Zu „{name}\" hinzufügen",
  "save.collection.allGroups": "Alle",
  "save.collection.allLabel": "Alle",
  "save.collection.deleteGroup": "Gruppe löschen",
  "save.collection.errorPrefix": "Fehler: {message}",
  "save.collection.nameLabel": "Name",
  "save.collection.openItem": "{title} öffnen",
  "save.collection.removeFromGroup": "Aus „{name}\" entfernen",
  "save.collection.rename": "Umbenennen",
  "save.collection.renameGroup": "Gruppe umbenennen",
  "save.collection.searchPlaceholder": "Suchen…",
  "save.community.addCommunity": "+ Community",
  "save.community.addTrigger": "+ Hinzufügen",
  "save.community.createError": "Community konnte nicht angelegt werden.",
  "save.community.dailyQuotaExceeded": "Tageslimit erreicht. Bitte später erneut versuchen.",
  "save.community.deleteCommunity": "Community löschen",
  "save.community.deleteCompletely": "Komplett löschen",
  "save.community.deleteConfirm": "„{name}\" löschen? Die Kontakte bleiben erhalten, nur die Gruppierung wird entfernt.",
  "save.community.deleteContactPrompt": "„{name}\" aus deinen Kontakten und allen Communities löschen?",
  "save.community.deleteError": "Community konnte nicht gelöscht werden.",
  "save.community.description": "Gruppiere deine Kontakte. Wähle links eine Community und ziehe Kontakte hinein oder füge sie per „Hinzufügen\" zu einer oder mehreren Communities hinzu.",
  "save.community.emptyAllGrouped": "Alle Kontakte sind in Communities.",
  "save.community.emptyCommunity": "Noch niemand in dieser Community. Zieh Kontakte hierher oder nutze „Hinzufügen“.",
  "save.community.emptyNoContacts": "Noch keine Kontakte.",
  "save.community.headerCount": "{count, plural, one {# Kontakt} other {# Kontakte}}",
  "save.community.limitReached": "Sie haben die maximale Anzahl von {limit} Communitys erreicht.",
  "save.community.moveFailed": "Verschieben fehlgeschlagen.",
  "save.community.namePlaceholder": "Community-Name …",
  "save.community.newCommunity": "Neue Community",
  "save.community.removeContact": "Kontakt entfernen",
  "save.community.removeContactError": "Kontakt konnte nicht entfernt werden.",
  "save.community.removeFromCommunityFailed": "Aus der Community entfernen fehlgeschlagen.",
  "save.community.removeFromCommunityPrompt": "„{name}\" aus „{community}\" entfernen (bleibt dein Kontakt und in anderen Communities) oder komplett aus deinen Kontakten und allen Communities löschen?",
  "save.community.removeFromGroup": "Aus Gruppe entfernen",
  "save.community.renameCommunity": "Community umbenennen",
  "save.community.renameError": "Community konnte nicht umbenannt werden.",
  "save.community.saveError": "Community konnte nicht gespeichert werden.",
  "save.community.title": "Community",
  "save.community.ungroupedLabel": "Kontakte ohne Community",
  "save.extraction.analysing": "Analysiert …",
  "save.extraction.analysisComplete": "Analyse abgeschlossen.",
  "save.extraction.analysisFailed": "Analyse fehlgeschlagen.",
  "save.extraction.analysisFailedWithReason": "Analyse fehlgeschlagen ({reason}).",
  "save.extraction.done": "Fertig",
  "save.extraction.dropZone": "Datei hierher ziehen oder klicken zum Hochladen",
  "save.extraction.dropZoneHint": "PDF, Word, Excel, Bilder · max. 10 MB pro Datei",
  "save.extraction.duplicateWarning": "Existiert bereits in Documents - das gespeicherte Dokument wird analysiert, kein erneuter Upload.",
  "save.extraction.expertiseFallback": "Fachwissen",
  "save.extraction.fileTooLarge": "„{name}\" ist zu groß (max. 10 MB pro Datei).",
  "save.extraction.fromDocuments": "Aus Documents",
  "save.extraction.newFile": "Neue Datei",
  "save.extraction.newPowersHeading": "Neu erkannte Powers{count, plural, =0 {} other { (#)}}",
  "save.extraction.newSkillsHeading": "Neu erkanntes Fachwissen{count, plural, =0 {} other { (#)}}",
  "save.extraction.loadingDocuments": "Dokumente werden geladen …",
  "save.extraction.noAnalyzableDocuments": "Keines deiner Dokumente lässt sich analysieren.",
  "save.extraction.noDocuments": "Keine Dokumente vorhanden.",
  "save.extraction.noFolder": "Ohne Ordner",
  "save.extraction.noMatches": "Keine Treffer",
  "save.extraction.noNewPowers": "Keine Änderungen - die Analyse hat keine neuen Power-Werte ergeben.",
  "save.extraction.noNewSkills": "Keine neuen Einträge - vermutlich war alles bereits in deinem Fachwissen vorhanden.",
  "save.extraction.notSignedIn": "Nicht angemeldet - Upload nicht möglich.",
  "save.extraction.nothingSelected": "Nichts ausgewählt",
  "save.extraction.persistUploads": "Hochgeladene Dateien in Documents speichern",
  "save.extraction.pipelineCounts": "{processed} verarbeitet · {skipped} übersprungen · {errored} Fehler",
  "save.extraction.poweredBy": "Powered by smycles AI",
  "save.extraction.powers": "Powers",
  "save.extraction.runningInBackground": "Läuft im Hintergrund - du kannst dies schließen und weiterarbeiten. Du wirst benachrichtigt, sobald es fertig ist.",
  "save.extraction.searchDocuments": "Dokumente durchsuchen",
  "save.extraction.selectAllInGroup": "Alle in {group} auswählen",
  "save.extraction.selectedCount": "{total, plural, one {# Dokument ausgewählt} other {# Dokumente ausgewählt}}",
  "save.extraction.skills": "Skills",
  "save.extraction.startAnalysis": "Analyse starten",
  "save.extraction.statusLine": "Status: {status}",
  "save.extraction.stillRunning": "Die Analyse dauert etwas länger und läuft im Hintergrund weiter. Du erhältst eine Benachrichtigung, sobald sie fertig ist.",
  "save.extraction.toggleCollapse": "Auf-/Zuklappen",
  "save.extraction.unsupportedType": "„{name}“ wird nicht analysiert. Unterstützt: PDF, Word, Excel und Bilder.",
  "save.extraction.uploadFailedDuplicate": "Upload fehlgeschlagen. Vermutlich existiert bereits ein Dokument mit diesem Namen.",
  "save.pinGroupDialog.createFailed": "Gruppe konnte nicht angelegt werden.",
  "save.pinGroupDialog.invalidName": "Ungültiger Name.",
  "save.pinGroupDialog.limitReached": "Sie haben die maximale Anzahl von {limit} Gruppen erreicht.",
  "save.pinGroupDialog.placeholder": "z. B. Mentoren",
  "save.pinGroupDialog.renameFailed": "Gruppe konnte nicht umbenannt werden.",
  "save.pinGroupDialog.submitCreate": "Anlegen",
  "save.pinGroupDialog.titleCreate": "Neue Gruppe",
  "save.pinGroupDialog.titleRename": "Gruppe umbenennen",
  "save.pinGroupDialog.tryAgain": "Bitte erneut versuchen.",
  "save.pinGroupSidebar.addGroup": "+ Gruppe",
  "save.pinGroupSidebar.deleteMessage": "„{name}\" löschen? Die Pins bleiben erhalten, nur die Gruppierung wird entfernt.",
  "save.pinGroupSidebar.deleteTitle": "Gruppe löschen",
  "save.pinGroupSidebar.tabPerson": "Personen",
  "save.pinGroupSidebar.tabPost": "Posts",
  "save.pinGroupSidebar.tabProject": "Projekte",
  "save.pinboardPage.description": "Ziehe eine Karte auf eine Gruppe links oder füge sie per „Hinzufügen\" zu einer oder mehreren Gruppen hinzu. Ziehen auf „Alle\" entfernt sie aus der aktuellen Gruppe.",
  "save.pinboardPage.emptyAllGrouped": "Alle gepinnten {typeLabel} sind in Gruppen.",
  "save.pinboardPage.emptyNoneInView": "Keine gepinnten {typeLabel} in dieser Ansicht.",
  "save.pinboardPage.itemFallback": "Eintrag",
  "save.pinboardPage.openItem": "{name} öffnen",
  "save.pinboardPage.removeFromGroup": "Aus Gruppe entfernen",
  "save.pinboardPage.removeFromGroupMessage": "„{title}\" aus „{group}\" entfernen (bleibt gepinnt und in anderen Gruppen) oder komplett entpinnen?",
  "save.pinboardPage.removePin": "Pin entfernen",
  "save.pinboardPage.title": "Pins",
  "save.pinboardPage.typePersons": "Personen",
  "save.pinboardPage.typePosts": "Posts",
  "save.pinboardPage.typeProjects": "Projekte",
  "save.pinboardPage.ungroupedLabel": "Pins ohne Gruppe",
  "save.pinboardPage.unpin": "Entpinnen",
  "save.pinboardPage.unpinCompletely": "Komplett entpinnen",
  "save.pinboardPage.unpinMessage": "„{title}\" entpinnen?",
  "search.activeCount": "{count} aktiv",
  "search.allFiltersAdded": "Alle Filter hinzugefügt",
  "search.any": "Beliebig",
  "search.chipType": "Typ",
  "search.clear": "Suche löschen",
  "search.confirmRemoveFromGroup": "Entfernen?",
  "search.discoverHeading": "Discover",
  "search.done": "Fertig",
  "search.either": "Egal",
  "search.errorPrefix": "Fehler: {message}",
  "search.extended": "Erweiterte Suche",
  "search.eyebrow": "Suche",
  "search.fieldAge": "Alter",
  "search.fieldChildren": "Anzahl Kinder",
  "search.fieldCitizenship": "Staatsangehörigkeit",
  "search.fieldCity": "Wohnort",
  "search.fieldCountry": "Land",
  "search.fieldDepartment": "Abteilung",
  "search.fieldExpertise": "Expertise",
  "search.fieldFirstName": "Vorname",
  "search.fieldGender": "Geschlecht",
  "search.fieldIndustry": "Branche",
  "search.fieldJobTitle": "Stellenbezeichnung",
  "search.fieldLanguages": "Sprachen",
  "search.fieldLastName": "Nachname",
  "search.fieldLocation": "Arbeitsstandort",
  "search.fieldMaritalStatus": "Familienstand",
  "search.fieldNationality": "Nationalität",
  "search.fieldCompanySize": "Größe (Mitarbeitende)",
  "companyFilter.heading": "Unternehmens-Filter{count, plural, =0 {} other { · # aktiv}}",
  "search.filterHeading": "{type}-Filter",
  "search.flagCommented": "Kommentiert",
  "search.flagOwner": "Eigentümer",
  "search.flagPinned": "Gepinnt",
  "search.flagRated": "Bewertet",
  "search.flagSignedUp": "Interessiert",
  "search.groupPosts": "Posts",
  "search.groupCompanies": "Unternehmen",
  "search.groupProjects": "Projekte",
  "search.groupTeamplayers": "Teamplayer",
  "search.hide": "Ausblenden ▴",
  "search.no": "Nein",
  "search.noFilters": "Keine Filter gesetzt.",
  "search.noResults": "Keine Treffer",
  "search.openChat": "Chat öffnen",
  "search.pin": "Pinnen",
  "search.pinInto": "In „{name}“ pinnen",
  "search.pinNoGroup": "Pinnen (ohne Gruppe)",
  "search.placeholder": "Suche nach Teamplayern, Projekten, Posts …",
  "search.placeholderPerson": "Name, Jobtitel …",
  "search.placeholderShared": "Titel, Beschreibung …",
  "search.placeholderCompany": "Unternehmensname, Fachwissen, Branche …",
  "search.publisher": "Veröffentlicht von",
  "search.publisherCompany": "Unternehmen",
  "search.publisherPerson": "Personen",
  "search.queryLabel": "Suchbegriff",
  "search.rangeTo": "bis",
  "search.removeFieldLabel": "{field} entfernen",
  "search.removeFromGroup": "Aus „{name}“ entfernen",
  "search.reset": "Zurücksetzen",
  "search.resultCount": "{count} {type}",
  "search.resultCountMore": "{count}+ {type}",
  "search.resultCountOf": "{count} von {total} {type}",
  "search.search": "Suchen",
  "search.searching": "Suche läuft …",
  "search.show": "Anzeigen ▾",
  "search.tabShare": "Share",
  "search.tabTeamplayer": "Teamplayer",
  "search.tabCompany": "Unternehmen",
  "search.tour.filters.desc": "Baue hier strukturierte Filter und kombiniere sie mit dem Freitext-Suchbegriff oben, dann drücke Suchen. Gerade sind {count} Filter aktiv.",
  "search.tour.filters.emptyDesc": "Baue hier strukturierte Filter und kombiniere sie mit dem Freitext-Suchbegriff oben, dann drücke Suchen. Gerade ist kein Filter gesetzt.",
  "search.tour.filters.title": "Filter",
  "search.tour.label": "Suche",
  "search.tour.results.desc": "Hier erscheinen die Treffer, aktuell {summary}. Klicke ein Ergebnis, um es zu öffnen; beim Scrollen lädt mehr nach.",
  "search.tour.results.title": "Ergebnisse",
  "search.tour.summary": "Das ist die erweiterte Suche. Finde Menschen, Unternehmen oder geteilte Projekte und Beiträge. Du suchst gerade nach {type}.",
  "search.tour.typeToggle.desc": "Wechsle die Suchkategorie: Teamplayer findet Menschen, Unternehmen findet Unternehmen über Name, Fachwissen oder Branche, und Share findet Projekte und Beiträge.",
  "search.tour.typeToggle.title": "Was suchen",
  "search.typeAll": "Alle",
  "search.typePosts": "Posts",
  "search.typeProjects": "Projekte",
  "search.unpin": "Entpinnen",
  "search.useExtended": "Erweiterte Suche verwenden",
  "search.writeMessage": "Nachricht schreiben",
  "search.yes": "Ja",
  "search.removeTermLabel": "{term} entfernen",
  "search.addTermPlaceholder": "Begriff eingeben, dann Enter",
  "secretInput.hide": "Wert verbergen",
  "secretInput.show": "Wert anzeigen",
  "service.docItemRow.download": "Herunterladen",
  "service.docItemRow.newBadge": "Neu",
  "service.docItemRow.open": "Öffnen",
  "service.docItemRow.rename": "Zum Umbenennen klicken",
  "service.docItemRow.selectAriaLabel": "{name} auswählen",
  "service.docItemRow.sourceLabel": "Quelle: {source}",
  "service.docPreviewCard.cvGeneratorDraft": "CV-Generator Entwurf",
  "service.docPreviewCard.download": "Herunterladen",
  "service.docPreviewCard.newBadge": "Neu",
  "service.docPreviewCard.open": "Öffnen",
  "service.docPreviewCard.rename": "Zum Umbenennen klicken",
  "service.docPreviewCard.selectAriaLabel": "{name} auswählen",
  "service.error.nameRequired": "Ein Name ist erforderlich.",
  "service.extRename.ariaLabel": "Umbenennen",
  "service.filterBuilder.addFilter": "+ Filter hinzufügen",
  "service.filterBuilder.all": "Alle",
  "service.filterBuilder.allFiltersAdded": "Alle Filter hinzugefügt",
  "service.filterBuilder.clear": "Leeren",
  "service.filterBuilder.done": "Fertig",
  "service.filterBuilder.removeFilterLabel": "{label} entfernen",
  "service.folderRow.deleteFolder": "Ordner löschen",
  "service.folderRow.deleteFolderAria": "Ordner {name} löschen",
  "service.folderRow.deleteFolderOnlyHint": "Nur den Ordner löschen: {count} Datei(en) wandern zu „Unsortiert\"",
  "service.folderRow.deleteLabel": "Löschen:",
  "service.folderRow.deleteWithFilesHint": "Ordner samt {count} Datei(en) endgültig löschen",
  "service.folderRow.folderNamePlaceholder": "Ordnername …",
  "service.folderRow.folderOnly": "Nur Ordner",
  "service.folderRow.newFolder": "Neuer Ordner",
  "service.folderRow.renameFolder": "Ordner umbenennen",
  "service.folderRow.toggleHint": "Auf-/Zuklappen (Doppelklick: umbenennen)",
  "service.folderRow.withFiles": "Mit Dateien",
  "service.page.allInFolders": "Alles in Ordnern abgelegt",
  "service.page.bulkCv.addMore": "Dateien hinzufügen",
  "service.page.bulkCv.addToCommunity": "Community",
  "service.page.bulkCv.addedToCommunity": "{n} zu {names} hinzugefügt",
  "service.page.bulkCv.communitySubject": "{n} importierte Personen",
  "service.page.bulkCv.desc": "Mehrere Lebensläufe ablegen, um die zugehörigen Profile anzulegen oder zu aktualisieren. Bestehende Profile werden nur dort ergänzt, wo Felder leer sind – nichts wird überschrieben.",
  "service.page.bulkCv.dupWarning": "Lebensläufe ohne E-Mail-Adresse erzeugen bei jedem Lauf ein neues Profil. Dieselben Dateien nicht erneut importieren.",
  "service.page.bulkCv.hint": "PDF, DOCX, Bilder … · max. 10 MB pro Datei · bis zu 25 Dateien",
  "service.page.bulkCv.importBtn": "{n, plural, one {# Lebenslauf} other {# Lebensläufe}} importieren",
  "service.page.bulkCv.importPhoto": "Foto importieren",
  "service.page.bulkCv.importing": "Importiere {done}/{total} …",
  "service.page.bulkCv.openProfile": "Profil",
  "service.page.bulkCv.outcomeCreated": "Neu",
  "service.page.bulkCv.outcomeFailed": "Import fehlgeschlagen",
  "service.page.bulkCv.outcomeUpdated": "Aktualisiert",
  "service.page.bulkCv.rejected": "Einige Dateien wurden übersprungen (zu groß oder nicht unterstützter Typ).",
  "service.page.bulkCv.summary": "{created} angelegt, {updated} aktualisiert, {failed} fehlgeschlagen",
  "service.page.bulkCv.title": "Profile importieren",
  "service.page.bulkCv.tooMany": "Es können höchstens {max} Dateien auf einmal importiert werden.",
  "service.page.bulkCv.willAddToCommunity": "Neue Importe werden hinzugefügt zu: {names}",
  "service.page.bulkCv.zone": "Lebensläufe hierher ziehen oder klicken zum Hinzufügen",
  "service.page.cardCvExtractorDesc": "Parst PDF/DOCX-Lebensläufe und übernimmt Stationen, Skills und Daten strukturiert.",
  "service.page.cardCvExtractorTitle": "CV-Extractor",
  "service.page.cardCvGeneratorDesc": "Erzeugt aus Profil-Daten einen Lebenslauf - landet rechts in DOCUMENTS.",
  "service.page.cardCvGeneratorTitle": "CV-Generator",
  "service.page.cardDatatransferDesc": "Exportiert deine Profil- und Grow-Daten als JSON-Datei (DSGVO Art. 20) - landet in DOCUMENTS und wird sofort heruntergeladen.",
  "service.page.cardDatatransferTitle": "Datentransfer",
  "service.page.cardHardskillDesc": "Erkennt fachliche Hard Skills und Tools aus deinem Profil und bewertet ihr Niveau.",
  "service.page.cardHardskillTitle": "Hardskill-Analyse",
  "service.page.cardLinkedinDesc": "Übernimmt Profil, Stationen und Skills direkt aus deinem LinkedIn-Account.",
  "service.page.cardLinkedinTitle": "LinkedIn-Import",
  "service.page.cardPowerDesc": "Identifiziert Powers, Skills und Erfahrung aus Free-Text und Selbstbeschreibung.",
  "service.page.cardPowerTitle": "Power-Analyse",
  "service.page.clearSelection": "Auswahl aufheben",
  "service.page.confirmDelete": "Wirklich löschen?",
  "service.page.cvFallbackName": "Lebenslauf",
  "service.page.cvNotMovable": "CV-Entwürfe können nicht in Ordner verschoben werden",
  "service.page.docOpening": "Dokument lädt …",
  "service.page.documentDeleteBlocked": "Dieses Dokument wird noch in geteilten Beiträgen verwendet. Entferne es zuerst dort:",
  "service.page.documentsCount": "{total} Dokumenten",
  "service.page.documentsHint": "Alle Dateien, die du hochgeladen oder über die Profil-Services erzeugt hast.",
  "service.page.documentsTitle": "Dokumente",
  "service.page.dropIntoFolder": "Hier ablegen, in diesen Ordner hochladen",
  "service.page.errDownload": "Download fehlgeschlagen.",
  "service.page.errExport": "Datenexport fehlgeschlagen.",
  "service.page.errExportSave": "Export konnte nicht gespeichert werden.",
  "service.page.errFolderCreate": "Ordner konnte nicht angelegt werden.",
  "service.page.errFolderLimit": "Du hast die maximale Anzahl von {limit} Ordnern erreicht.",
  "service.page.errFolderDelete": "Ordner konnte nicht gelöscht werden.",
  "service.page.errFolderRename": "Ordner konnte nicht umbenannt werden.",
  "service.page.errMove": "Verschieben fehlgeschlagen.",
  "service.page.errNoContent": "Kein Inhalt vorhanden.",
  "service.page.errNotSignedInExport": "Nicht angemeldet - Export nicht möglich.",
  "service.page.errNotSignedInUpload": "Nicht angemeldet - Upload nicht möglich.",
  "service.page.errOpen": "Öffnen fehlgeschlagen.",
  "service.page.errPopupBlocked": "Der Browser hat das Öffnen in einem neuen Tab blockiert - bitte Pop-ups für diese Seite erlauben und erneut auf Öffnen klicken.",
  "service.page.errProfileLoad": "Profildaten konnten nicht geladen werden.",
  "service.page.errRename": "Umbenennen fehlgeschlagen.",
  "service.page.errUploadDuplicate": "Upload fehlgeschlagen. Vermutlich existiert bereits ein Dokument mit diesem Namen.",
  "service.page.errUploadNameTaken": "Schon in Dokumente vorhanden, nicht erneut hochgeladen: {names}.",
  "service.page.error": "Fehler: {message}",
  "service.page.exporting": "Exportiert …",
  "service.page.filterFileType": "Filetype",
  "service.page.filterPlaceholder": "Filtere deine verfügbaren Dokumente …",
  "service.page.filterSource": "Quelle",
  "service.page.folderEmpty": "Ordner ist leer - zieh Dokumente auf die Ordnerkachel.",
  "service.page.hardskillAnalysisTitle": "Hardskill-Analyse",
  "service.page.inputTitle": "Profil aufbauen",
  "service.page.maxPerFile": "max. 10 MB pro Datei",
  "service.page.moveToFolder": "In Ordner verschieben",
  "service.page.noDocuments": "Keine Dokumente",
  "service.page.noFolders": "Keine Ordner vorhanden",
  "service.page.noMatches": "Keine Treffer",
  "service.page.noMatchesInFolder": "Keine Treffer in diesem Ordner",
  "service.page.onlyRealFilesMovable": "Nur echte Dateien lassen sich in Ordner verschieben, keine CV-Generator-Einträge.",
  "service.page.openBlockingSharedItem": "Geteilten Beitrag {number} öffnen",
  "service.page.orDragAndDrop": "Oder per Drag & Drop",
  "service.page.outputTitle": "Profil exportieren",
  "service.page.powerAnalysisTitle": "Power-Analyse",
  "service.page.removeBlockingSelection": "Verhindernde Auswahl entfernen",
  "service.page.reset": "Zurücksetzen",
  "service.page.selectedCount": "{count} ausgewählt",
  "service.page.sourceCvGenerator": "CV Generator",
  "service.page.sourceUpload": "Dateiupload",
  "service.page.unsorted": "Unsortiert",
  "service.page.uploadFile": "Datei hochladen",
  "service.page.uploading": "Lädt hoch …",
  "service.page.viewCompact": "Kompakt",
  "service.page.viewPreview": "Vorschau",
  "service.tour.filters.desc": "Filtere deine Dokumente nach Name, Quelle oder Dateityp und wechsle zwischen Vorschau- und Kompaktansicht.",
  "service.tour.filters.title": "Suchen & Filtern",
  "service.tour.label": "Save Dokumente",
  "service.tour.list.desc": "{count} Dokumente in {folders} Ordnern. Öffne einen Ordner für seine Dateien, ziehe Dokumente zwischen Ordnern und fahre über eine Zeile, um sie umzubenennen, auszuwählen oder zu löschen.",
  "service.tour.list.title": "Deine Dokumente",
  "service.tour.summary": "Das ist deine Dokumenten-Seite: {count} Dokumente in {folders} Ordnern, von manuellen Uploads bis zu generierten Lebensläufen.",
  "service.tour.upload.desc": "Lade hier Dateien hoch (max. 10 MB pro Datei), oder ziehe sie einfach per Drag & Drop auf einen Ordner oder die Liste darunter.",
  "service.tour.upload.title": "Dateien hochladen",
  "settings.account.delete.button": "Konto löschen",
  "settings.account.delete.confirm": "Endgültig löschen",
  "settings.account.delete.desc": "Dein Konto und alle zugehörigen Daten werden dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.",
  "settings.account.delete.dialogTitle": "Konto endgültig löschen?",
  "settings.account.delete.error": "Löschen fehlgeschlagen. Bitte erneut versuchen.",
  "settings.account.delete.placeholder": "Vollständiger Name",
  "settings.account.delete.prompt": "Gib zur Bestätigung deinen vollständigen Namen ein:",
  "settings.account.delete.title": "Konto löschen",
  "settings.account.delete.zone": "Gefahrenzone",
  "settings.eyebrow": "Plattform-Konfiguration",
  "settings.heading": "Admin",
  "settings.intro": "Branding, verwaltete Stammdaten, Fragebögen und Darstellung.",
  "settings.sectionAI": "KI",
  "settings.sectionAccessConfig": "Feature-Freigabeliste",
  "settings.sectionBranding": "Branding",
  "settings.sectionEmailTemplates": "E-Mail-Vorlagen",
  "settings.sectionFragebogen": "Fragebögen",
  "settings.sectionHrPrompt": "HR-Prompt",
  "settings.sectionRoster": "Import",
  "settings.sectionStammdaten": "Stammdaten",
  "settings.sectionStyleguide": "Styleguide",
  "settings.styleguide.buttons.specimen.combined": "Kombiniert",
  "settings.upload.appearance.area": "Einstellungen",
  "settings.upload.appearance.limit": "bis 16 MB",
  "settings.upload.appearance.note": "base64-inline, BFF-Limit",
  "settings.upload.appearance.what": "Logo & Hintergrundbild",
  "settings.upload.docs.area": "Save · Dokumente",
  "settings.upload.docs.limit": "10 MB pro Datei",
  "settings.upload.docs.what": "Datei-Upload (PDF, DOCX, …)",
  "settings.upload.generalNote": "Alle Uploads laufen base64-kodiert über das BFF, das pro Anfrage max. 16 MB erlaubt. Da base64 die Größe um rund 33 % erhöht, liegen die tatsächlichen Dateigrenzen etwas darunter.",
  "settings.upload.profile.area": "Profil",
  "settings.upload.profile.limit": "5 MB",
  "settings.upload.profile.what": "Profilbild / Avatar",
  "settings.upload.shareAttach.area": "Share · Anhänge",
  "settings.upload.shareAttach.limit": "bis 16 MB",
  "settings.upload.shareAttach.note": "technische Obergrenze (BFF)",
  "settings.upload.shareAttach.what": "Datei-Anhänge an Projekte",
  "settings.upload.shareImage.area": "Share · Projekte",
  "settings.upload.shareImage.limit": "5 MB pro Bild",
  "settings.upload.shareImage.what": "Titelbild",
  "share.comment.saveFailed": "Der Kommentar konnte nicht gespeichert werden.",
  "share.create.actingAsCompany": "Du postest als {company}. Verlasse den Unternehmenskontext, um als du selbst zu posten.",
  "share.create.attachmentsLabel": "Anhänge",
  "share.create.authorLabel": "Autor",
  "share.create.commentsAfterPublish": "Nach dem Veröffentlichen verfügbar.",
  "share.create.commentsLabel": "Kommentare",
  "share.create.createHeading": "{type, select, POST {Neuer Post} other {Neues Projekt}}",
  "share.create.descriptionLabel": "Beschreibung",
  "share.create.descriptionPlaceholder": "{type, select, POST {Beschreibe deinen Post …} other {Beschreibe dein Projekt …}}",
  "share.create.editHeading": "{type, select, POST {Post bearbeiten} other {Projekt bearbeiten}}",
  "share.create.existingAttachment": "Anhang {n}",
  "share.create.existingImage": "Bild {n}",
  "share.create.eyebrowCreate": "Erstellen",
  "share.create.eyebrowEdit": "Bearbeiten",
  "share.create.eyebrowPreview": "Vorschau",
  "share.create.fromDocuments": "Aus meinen Dokumenten",
  "share.create.imagesLabel": "Bilder",
  "share.create.loadingFiles": "lädt…",
  "share.create.mainImageBadge": "Vorschau",
  "share.create.mainImageHint": "Als Vorschaubild festlegen",
  "share.create.noDescription": "Keine Beschreibung.",
  "share.create.previewButton": "Vorschau",
  "share.create.previewHeading": "So sieht's aus",
  "share.create.publish": "Veröffentlichen",
  "share.create.publishedAtLabel": "Veröffentlicht am",
  "share.create.ratingLabel": "Bewertung",
  "share.create.shortDescriptionLabel": "Kurzbeschreibung",
  "share.create.shortDescriptionPlaceholder": "In einem Satz: worum geht's?",
  "share.create.statComments": "Kommentare",
  "share.create.statInterested": "Interessenten",
  "share.create.statPins": "Pins",
  "share.create.statRatings": "Bewertungen",
  "share.create.statViews": "Views",
  "share.create.titleLabel": "Titel",
  "share.create.titlePlaceholder": "{type, select, POST {Titel des Posts} other {Titel des Projekts}}",
  "share.create.tooLarge": "Zu groß (max. {max} MB pro Datei): {names}",
  "share.create.typeLabel": "Typ",
  "share.create.typePost": "Post",
  "share.create.typeProject": "Projekt",
  "share.create.unsupportedType": "Nicht unterstützter Dateityp: {names}",
  "share.create.untitled": "Unbenannt",
  "share.docPicker.confirm": "{count} übernehmen",
  "share.docPicker.empty": "Noch keine Dokumente in deinem Vault.",
  "share.docPicker.emptyImages": "Noch keine Bilder in deinen Dokumenten.",
  "share.docPicker.hint": "Ausgewählte Dokumente werden dem Beitrag als Kopie angehängt.",
  "share.docPicker.loadFailed": "Dokumente konnten nicht geladen werden.",
  "share.docPicker.noMatches": "Keine Treffer",
  "share.docPicker.search": "Dokumente durchsuchen",
  "share.docPicker.title": "Aus meinen Dokumenten hinzufügen",
  "share.docPicker.unnamedDocument": "Unbenanntes Dokument",
  "share.itemDetail.alreadyRated": "Du hast bereits bewertet, erneut tippen zum Ändern.",
  "share.itemDetail.attachmentDownloadFailed": "Download fehlgeschlagen.",
  "share.itemDetail.attachmentOpenFailed": "Öffnen fehlgeschlagen.",
  "share.itemDetail.attachmentUnnamed": "Anhang",
  "share.itemDetail.attachments": "Anhänge",
  "share.itemDetail.commentAsCompanyBlocked": "Du trittst gerade als {company} auf. Verlasse den Unternehmenskontext, um als du selbst zu kommentieren.",
  "share.itemDetail.downloadAttachment": "{name} herunterladen",
  "share.itemDetail.openAttachment": "{name} öffnen",
  "share.itemDetail.author": "Autor",
  "share.itemDetail.commentPlaceholder": "Kommentar schreiben…",
  "share.itemDetail.comments": "Kommentare",
  "share.itemDetail.deleteConfirm": "Löschen?",
  "share.itemDetail.error": "Fehler: {message}",
  "share.itemDetail.expressInterest": "Interesse zeigen",
  "share.itemDetail.imageN": "Bild {n}",
  "share.itemDetail.linkedMatchTitle": "Neues Match starten und mit diesem Share-Item verknüpfen",
  "share.itemDetail.loading": "lädt…",
  "share.itemDetail.more": "Mehr",
  "share.itemDetail.newMatch": "Neues Match ↗",
  "share.itemDetail.no": "Nein",
  "share.itemDetail.noComments": "Noch keine Kommentare, sei der/die Erste.",
  "share.itemDetail.noDescription": "Keine Beschreibung",
  "share.itemDetail.noDescriptionHint": "kein Inhalt hinterlegt",
  "share.itemDetail.notFound": "Beitrag nicht gefunden",
  "share.itemDetail.postedByOperator": "Gepostet von {name}",
  "share.itemDetail.publishedBy": "Veröffentlicht von",
  "share.itemDetail.publishedOn": "Veröffentlicht am",
  "share.itemDetail.rateYourselfTitle": "Klicken, um selbst zu bewerten",
  "share.itemDetail.rating": "Bewertung",
  "share.itemDetail.ratingClose": "schließen",
  "share.itemDetail.ratingOpen": "bewerten ›",
  "share.itemDetail.ratingsCount": "({count} Bewertungen)",
  "share.itemDetail.send": "Senden",
  "share.itemDetail.share": "Teilen",
  "share.itemDetail.shareWithIcon": "↗ Teilen",
  "share.itemDetail.signedUpWithdraw": "✓ Interesse gezeigt - zurückziehen",
  "share.itemDetail.starsAriaLabel": "{n} von 5 Sternen",
  "share.itemDetail.starsTitle": "{n, plural, one {# Stern} other {# Sterne}}",
  "share.itemDetail.statInterested": "Interessenten",
  "share.itemDetail.statPins": "Pins",
  "share.itemDetail.statViews": "Views",
  "share.itemDetail.thanks": "Danke!",
  "share.itemDetail.tour.actions.desc": "Beobachte den Eintrag, um ihm zu folgen, oder starte ein neues Match, das damit verknüpft ist.",
  "share.itemDetail.tour.actions.projectDesc": "Beobachte den Eintrag, um ihm zu folgen, bekunde Interesse, um dich als Teilnehmer einzutragen, oder starte ein neues Match zu diesem Projekt.",
  "share.itemDetail.tour.actions.title": "Mitmachen",
  "share.itemDetail.tour.content.desc": "Titel, Bildergalerie und vollständige Beschreibung von „{name}“. Klicke die Vorschaubilder, um durch die Galerie zu blättern.",
  "share.itemDetail.tour.content.title": "Der Inhalt",
  "share.itemDetail.tour.label": "Share Beitrag",
  "share.itemDetail.tour.stats.desc": "Die bisherige Reichweite: {views} Aufrufe, {pins} Pins und {signUps} Interessierte.",
  "share.itemDetail.tour.stats.title": "So läuft es",
  "share.itemDetail.tour.summary": "Du schaust dir „{name}“ an, ein {type} aus der Share-Community.",
  "share.itemDetail.unwatch": "✓ Beobachtet - entfernen",
  "share.itemDetail.watch": "Beobachten",
  "share.itemDetail.yes": "Ja",
  "share.landing.carouselDiscussed": "Meiste Kommentare",
  "share.landing.carouselInterest": "Meiste Interessenten",
  "share.landing.carouselNew": "Neueste",
  "share.landing.carouselTop": "Top bewertet",
  "share.landing.discoverAllPosts": "Alle Beiträge entdecken ↗",
  "share.landing.discoverEyebrow": "Entdecken",
  "share.landing.error": "Fehler: {message}",
  "share.landing.heroBody": "Veröffentliche Projekte und Posts, sammle Interessenten, Feedback und Reichweite. Und entdecke, woran die Community gerade baut.",
  "share.landing.heroCta": "Create ↗",
  "share.landing.heroSubtitleLine1": "Zeig, woran du arbeitest.",
  "share.landing.heroSubtitleLine2": "Finde, wer mitmacht.",
  "share.landing.loading": "lädt…",
  "share.landing.myActivity": "Meine Aktivität",
  "share.landing.myProjectsSection": "Meine Projekte & Posts",
  "share.landing.next": "Nächstes",
  "share.landing.noOwnPosts": "Noch keine eigenen Beiträge",
  "share.landing.noOwnPostsHint": "erstelle ein Projekt oder einen Post",
  "share.landing.noSharedItems": "Keine geteilten Items vorhanden.",
  "share.landing.noShortDescription": "Keine Kurzbeschreibung.",
  "share.landing.nothingWatched": "Noch nichts beobachtet oder beteiligt",
  "share.landing.nothingWatchedHint": "Beobachte Projekte & Posts oder beteilige dich.",
  "share.landing.open": "Öffnen ↗",
  "share.landing.previous": "Vorheriges",
  "share.landing.share": "↗ Teilen",
  "share.landing.slide": "Slide {number}",
  "share.landing.statComments": "Kommentare",
  "share.landing.statInterested": "Interessenten",
  "share.landing.statRatings": "Ratings",
  "share.landing.statViews": "Views",
  "share.landing.tour.activity.desc": "Die {count} Einträge, die du beobachtest oder für die du dich eingetragen hast. So kommst du schnell wieder dorthin zurück.",
  "share.landing.tour.activity.emptyDesc": "Einträge, die du beobachtest oder für die du dich einträgst, sammeln sich hier; noch ist nichts da. Öffne einen Eintrag und drücke Beobachten oder Interesse bekunden.",
  "share.landing.tour.activity.title": "Beobachtet & Beteiligt",
  "share.landing.tour.carousel.desc": "Vier kuratierte Top-5-Listen: am besten bewertet, am neuesten, meiste Interessenten, meiste Kommentare. Wechsle die Listen über die Tabs; gerade läuft „{featured}“. Klicke Öffnen, um in einen Eintrag zu springen.",
  "share.landing.tour.carousel.title": "Entdecken",
  "share.landing.tour.create.desc": "Veröffentliche hier dein eigenes Projekt oder deinen Beitrag. Beschreibe es, füge Bilder hinzu und sammle Interessierte.",
  "share.landing.tour.create.title": "Etwas erstellen",
  "share.landing.tour.emptySummary": "Das ist Share, der Community-Feed, in dem Menschen Projekte und Beiträge veröffentlichen, Interessierte gewinnen und Feedback sammeln.",
  "share.landing.tour.label": "Share",
  "share.landing.tour.mine.desc": "Deine eigenen {count} veröffentlichten Einträge. „Alle ansehen“ öffnet die vollständige Liste, in der du sie verwaltest.",
  "share.landing.tour.mine.emptyDesc": "Deine eigenen veröffentlichten Einträge erscheinen hier. Du hast noch keine erstellt.",
  "share.landing.tour.mine.title": "Meine Projekte & Beiträge",
  "share.landing.tour.summary": "Das ist Share, der Community-Feed, in dem Menschen Projekte und Beiträge veröffentlichen, Interessierte gewinnen und Feedback sammeln. Gerade steht „{name}“ im Rampenlicht.",
  "share.landing.viewAll": "Alle ansehen ↗",
  "share.landing.watchedSection": "Beobachtet & Beteiligt",
  "share.mine.emptyHint": "erstelle ein Projekt oder einen Post",
  "share.mine.emptyLabel": "Noch keine eigenen Beiträge",
  "share.mine.error": "Fehler: {message}",
  "share.mine.eyebrow": "SHARE · Meine Beiträge",
  "share.mine.filterAll": "Alle",
  "share.mine.filterPosts": "Posts",
  "share.mine.filterProjects": "Projekte",
  "share.mine.subtitle": "Alle deine Projekte und Posts.",
  "share.mine.title": "Meine Beiträge",
  "share.mine.tour.filters.desc": "Grenze die Liste auf Projekte oder Beiträge ein und ändere rechts die Sortierung.",
  "share.mine.tour.filters.title": "Filtern & Sortieren",
  "share.mine.tour.items.desc": "{count} Einträge. Klicke einen an, um ihn zu öffnen; als Besitzer kannst du ihn auf der Detailseite bearbeiten oder löschen.",
  "share.mine.tour.items.emptyDesc": "Noch nichts hier. Erstelle ein Projekt oder einen Beitrag, dann taucht er in diesem Raster auf.",
  "share.mine.tour.items.title": "Deine Einträge",
  "share.mine.tour.label": "Share Meine",
  "share.mine.tour.summary": "Das sind deine eigenen Beiträge: alles, was du auf Share veröffentlicht hast. Gerade sind es {count} Einträge.",
  "skill.catAwareness": "Bewusstsein & Lernen",
  "skill.catImpact": "Wirkung & Einfluss gestalten",
  "skill.catPractical": "Praktische Anwendung & Kompetenzsicherheit",
  "skill.desc.1": "Du kennst grundlegende Konzepte dieser Kompetenz und hast erste Berührungspunkte damit, nutzt sie aber noch nicht praktisch.",
  "skill.desc.2": "Du baust aktiv Grundlagen in dieser Kompetenz auf und kannst erste einfache Aufgaben mit Unterstützung und Vorgaben bearbeiten.",
  "skill.desc.3": "Du nutzt die Kompetenz bereits in ersten praktischen Situationen und kannst einfache Aufgaben selbstständig umsetzen.",
  "skill.desc.4": "Du setzt die Kompetenz regelmäßig ein und kannst typische Aufgaben zuverlässig und selbstständig lösen.",
  "skill.desc.5": "Du verfügst über tiefgehende praktische Erfahrung und setzt die Kompetenz souverän in unterschiedlichen komplexen und anspruchsvollen Situationen ein.",
  "skill.desc.6": "Du bist eine anerkannte Referenz für diese Kompetenz und stärkst andere in der Anwendung, indem du wirksam Best Practices im Team oder in der Organisation etablierst.",
  "skill.desc.7": "Du entwickelst zukunftsweisende Ansätze für diese Kompetenz und gibst richtungsweisende Impulse, die zu neuen Standards führen.",
  "skill.infoLabel": "Levelbeschreibung",
  "skill.levelName.1": "Explorer",
  "skill.levelName.2": "Builder",
  "skill.levelName.3": "Contributor",
  "skill.levelName.4": "Practitioner",
  "skill.levelName.5": "Specialist",
  "skill.levelName.6": "Multiplier",
  "skill.levelName.7": "Pioneer",
  "skill.levelTitle.1": "Kennenlernen & erste Berührungspunkte",
  "skill.levelTitle.2": "Gezieltes Entwickeln",
  "skill.levelTitle.3": "Erste Praxisanwendungen",
  "skill.levelTitle.4": "Regelmäßige & sichere Praxisanwendungen",
  "skill.levelTitle.5": "Souveräner Einsatz in anspruchsvollen Kontexten",
  "skill.levelTitle.6": "Andere befähigen & entwickeln",
  "skill.levelTitle.7": "Neues prägen & Innovation vorantreiben",
  "sort.az": "A–Z",
  "sort.label": "Sortieren",
  "sort.nameAz": "Name A–Z",
  "sort.nameZa": "Name Z–A",
  "sort.new": "Neueste",
  "sort.old": "Älteste",
  "sort.top": "Top bewertet",
  "stammdaten.details": "Details",
  "stammdaten.experience": "Berufserfahrung",
  "stammdaten.organisation": "Organisation",
  "stammdaten.teamprofil": "Power-Scorecards",
  "suggestions.activities": "Aufgaben vorschlagen",
  "suggestions.add": "Tippen zum Hinzufügen",
  "suggestions.addTask": "+ Aufgabe",
  "suggestions.empty": "Keine Vorschläge gefunden",
  "suggestions.loading": "Vorschläge werden geladen…",
  "suggestions.needJobTitle": "Erst Stellenbezeichnung eingeben",
  "suggestions.retry": "Erneut versuchen",
  "suggestions.unavailable": "Vorschläge derzeit nicht verfügbar",
  "teamProfile.confirmDelete.message": "Das Profil wird endgültig entfernt und steht beim Entwerfen eines Matches nicht mehr zur Auswahl.",
  "teamProfile.confirmDelete.title": "„{label}“ löschen?",
  "teamProfile.create.sub": "Startet mit gleich gewichteten Powers. Öffne das Profil danach, um Gewichte zu justieren.",
  "teamProfile.create.submit": "Profil anlegen",
  "teamProfile.create.title": "Neues Profil",
  "teamProfile.delete": "Profil löschen",
  "teamProfile.duplicate": "Ein Profil mit diesem Namen gibt es bereits.",
  "teamProfile.truncated": "Es werden die ersten {shown} von {total} Profilen angezeigt. Lösche oder benenne Profile um, die du nicht mehr brauchst.",
  "teamProfile.empty": "Noch keine Profile.",
  "teamProfile.loading": "Lädt…",
  "teamProfile.nameDe": "Name (Deutsch)",
  "teamProfile.nameEn": "Name (Englisch)",
  "teamProfile.presetBadge": "Vorlage",
  "teamProfile.presetHint": "Name und Gewichte dieser Vorlage sind von Smycles vorgegeben und nicht änderbar. Leg ein eigenes Profil an, wenn du andere Gewichte brauchst.",
  "teamProfile.reset": "Änderungen verwerfen",
  "teamProfile.save": "Speichern",
  "teamProfile.saveFailed": "Das Profil konnte nicht gespeichert werden.",
  "teamProfile.sub": "Benannte Gewichtungen über die 30 Powers, auswählbar beim Entwerfen eines Matches. Explore, Exploit und Ausgewogen sind Vorlagen von Smycles: Name und Gewichte liegen fest.",
  "teamProfile.title": "Power-Scorecards",
  "teamProfile.weights": "Gewichtung",
  "topbar.help.choiceNews": "Zeig mir was neu ist",
  "topbar.help.choiceTour": "Starte die Tour",
  "topbar.help.hint": "Neu hier? Starte mit diesem Button die geführte Tour durch die App.",
  "topbar.help.hintDismiss": "Ausblenden",
  "topbar.help.hintNews": "Seit deiner Tour hat sich etwas getan. Dieser Button zeigt dir, was neu ist.",
  "topbar.help.label": "Starte die geführte Tour",
  "unsavedGuard.body": "Du hast Änderungen, die noch nicht gespeichert wurden. Wenn du die Seite verlässt, gehen sie verloren.",
  "unsavedGuard.discard": "Verwerfen",
  "unsavedGuard.save": "Speichern",
  "unsavedGuard.stay": "Hier bleiben",
  "unsavedGuard.title": "Ungespeicherte Änderungen",
  "userSettings.claude.adminInstallLink": "Vorausgef\u00fcllten Dialog f\u00fcr Organisations-Owner \u00f6ffnen",
  "userSettings.claude.appDesc": "Füge Smycles einmal als Connector in deinem Claude-Konto hinzu, dann funktioniert es in der Claude-Desktop-App, der Web-App und mobil.",
  "userSettings.claude.appInternalHint": "Hinweis: Claude verbindet sich aus der eigenen Cloud, daher funktioniert das vorerst nicht auf internen Systemen. Der Smycles-Server muss aus dem öffentlichen Internet erreichbar sein. Claude Code (unten) funktioniert heute schon auf internen Systemen.",
  "userSettings.claude.appStep1": "Öffne in Claude die Einstellungen und dann Connectors.",
  "userSettings.claude.appStep2": "Wähle „Add custom connector“ und füge die obige Server-URL ein.",
  "userSettings.claude.appStep3": "Öffne die erweiterten Einstellungen, trage die obige Client-ID ein und lass das Client-Secret leer.",
  "userSettings.claude.appStep4": "Füge den Connector hinzu, klicke dann auf Connect und melde dich mit deinem Smycles-Konto an.",
  "userSettings.claude.appTeamNote": "In Team- und Enterprise-Plänen fügt ein Organisations-Owner den Connector einmalig hinzu; alle anderen klicken nur auf Connect und melden sich an.",
  "userSettings.claude.appTitle": "Claude-App (Desktop, Web und Mobil)",
  "userSettings.claude.clientIdLabel": "Client-ID",
  "userSettings.claude.codeDesc": "Führe diesen Befehl aus, starte dann Claude Code, führe /mcp aus, wähle smycles und dann Authentifizieren. Ein Browserfenster öffnet sich für die Smycles-Anmeldung.",
  "userSettings.claude.codeTitle": "Claude Code (für Entwickler)",
  "userSettings.claude.commandLabel": "Befehl",
  "userSettings.claude.detailsTitle": "Verbindungsdaten",
  "userSettings.claude.eyebrow": "Claude",
  "userSettings.claude.installAudience": "Der Button ist f\u00fcr pers\u00f6nliche Claude-Konten (Free, Pro und Max) und f\u00fcr Organisations-Owner in Team- und Enterprise-Pl\u00e4nen. In einem Team- oder Enterprise-Plan ohne Owner-Rechte brauchst du ihn nicht: Der Owner f\u00fcgt den Connector einmalig hinzu, danach erscheint Smycles in Claude unter Einstellungen \u2192 Connectors \u2013 dort einfach auf Connect klicken.",
  "userSettings.claude.installButton": "Zu Claude hinzuf\u00fcgen",
  "userSettings.claude.installHint": "Der Button \u00f6ffnet Claude mit bereits ausgef\u00fclltem Namen und Server-URL \u2013 einfach best\u00e4tigen. Danach mit Schritt 3 unten fortfahren: die Client-ID in den erweiterten Einstellungen eintragen.",
  "userSettings.claude.intro": "Nutze deine Smycles-Daten und -Werkzeuge direkt in Claude. Claude sieht genau das, was du sehen kannst; du meldest dich mit deinem gewohnten Smycles-Konto an. Das ist unabhängig vom Assistenten in Smycles.",
  "userSettings.claude.noSecret": "Es wird kein Client-Secret benötigt. Lass das Secret-Feld leer.",
  "userSettings.claude.title": "Claude verbinden",
  "userSettings.claude.urlLabel": "Server-URL",
  "userSettings.mcpApp.appsTitle": "Apps",
  "userSettings.mcpApp.callbackHostLabel": "Callback-Host",
  "userSettings.mcpApp.callbackPortLabel": "Callback-Port",
  "userSettings.mcpApp.desktopStep1": "Verbinde dich mit dem Unternehmens-VPN. Aktiviere in Claude Desktop Help → Troubleshooting → Enable Developer Mode und öffne dann Developer → Configure Third-Party Inference.",
  "userSettings.mcpApp.desktopStep2": "Wähle im Abschnitt Connection „Anthropic API“ als Inference-Provider und hinterlege deinen Anthropic-API-Key. Überspringe den Schritt, wenn Claude Desktop bereits im Third-Party-Modus läuft.",
  "userSettings.mcpApp.desktopStep3": "Füge unter Connectors einen Server hinzu: Transport Streamable HTTP, URL aus der Liste oben.",
  "userSettings.mcpApp.desktopStep4": "Wähle unter OAuth „Bring your own client“ und trage die Client ID von oben sowie Callback-Host und Callback-Port von unten ein. Das Client-Secret bleibt leer.",
  "userSettings.mcpApp.desktopStep5": "Übernimm die Änderungen und starte Claude Desktop neu. Öffne dann Settings → Connectors, verbinde dich und melde dich im Browserfenster mit deinem Smycles-Konto an.",
  "userSettings.mcpApp.externalDesc": "Ist die Umgebung aus dem Internet erreichbar, wird jede App in Claude als eigener Custom Connector hinzugefügt, getrennt vom eigentlichen Smycles-Connector; verwende ihre URL aus der Liste oben.",
  "userSettings.mcpApp.externalTitle": "Externe Umgebungen – Claude-App (Desktop, Web und Mobile)",
  "userSettings.mcpApp.internalDesc": "In Intranet-Umgebungen (z. B. trunk) können claude.ai und die normalen Claude-Apps keine Verbindung aufbauen: Sie verbinden sich aus Anthropics Cloud, nicht von deinem Gerät. Nutze stattdessen Claude Desktop im Third-Party-Inference-Modus im VPN. Jede App ist ihr eigener Connector; verwende ihre URL aus der Liste oben.",
  "userSettings.mcpApp.internalTitle": "Interne Umgebungen – Claude Desktop im VPN",
  "userSettings.mcpApp.intro": "Interaktive Smycles-Apps direkt in deinen Claude-Unterhaltungen. Du meldest dich mit deinem gewohnten Smycles-Konto an; jede App sieht genau das, was du sehen kannst.",
  "userSettings.mcpApp.oauthDesc": "Connectoren authentifizieren sich per OAuth: Beim Verbinden öffnet Claude die Smycles-Anmeldung, und die App agiert danach mit genau deinen Berechtigungen. Alle Apps nutzen den öffentlichen Client unten.",
  "userSettings.mcpApp.oauthTitle": "Anmeldung (OAuth)",
  "userSettings.mcpApp.title": "Apps in Claude",
  "userSettings.data.desc": "Exportiere deine Profil- und Grow-Daten als JSON-Datei (DSGVO Art. 20). Den Datentransfer findest du im Profil unter „Service\".",
  "userSettings.data.link": "Zum Datentransfer ↗",
  "userSettings.data.title": "Datenexport",
  "userSettings.email": "E-Mail",
  "userSettings.eyebrow": "Konto · Präferenzen",
  "userSettings.heading": "Einstellungen",
  "userSettings.identityTitle": "Identität",
  "userSettings.intro": "Verwalte dein Konto, Benachrichtigungen und Datenschutz.",
  "userSettings.language": "Sprache",
  "userSettings.languageHint": "Auch für die AI-Generierung.",
  "userSettings.name": "Name",
  "userSettings.sectionAccount": "Konto",
  "userSettings.sectionConnections": "Verknüpfungen",
  "userSettings.sectionData": "Daten & Export",
  "userSettings.tour.content.accountDesc": "Deine Identität (Name und E-Mail), die Oberflächensprache (auch für KI-Generierung genutzt) und ganz unten die Kontolöschung.",
  "userSettings.tour.content.dataDesc": "Exportiere dein Profil und deine Grow-Daten als JSON-Datei (DSGVO Art. 20). Der Button übergibt dich an den Datentransfer.",
  "userSettings.tour.content.title": "Der aktive Bereich",
  "userSettings.tour.label": "Einstellungen",
  "userSettings.tour.nav.desc": "Wechsle zwischen Konto (Identität, Sprache, Löschung) und Daten & Export (dein DSGVO-Datenexport).",
  "userSettings.tour.nav.title": "Die Bereiche",
  "userSettings.tour.summary": "Das sind deine Kontoeinstellungen: Identität, Oberflächensprache, Datenexport und Kontolöschung.",
  "whatsNew.v0_1": "Neu in Smycles: Verbinde die Claude Apps mit deinen Daten. Diese Einstellungsseite zeigt dir wie, mit MCP Endpoint, Client-ID und einer Schritt-für-Schritt-Anleitung.",
  "match.result.facts.leniencyDependent": "{count, plural, one {# Anforderung gilt nur kulant als erfüllt} other {# Anforderungen gelten nur kulant als erfüllt}}: Fachwissen vorhanden, geforderte Stufe nicht belegt.",
  "match.result.facts.lenientMark": "Kulant",
  "match.result.memberLenientTag": "kulant",
  "match.result.riskEmptyCluster": "{count, plural, one {# Cluster ohne Träger} other {# Cluster ohne Träger}}",
  "match.result.riskSoleRequirement": "{count, plural, one {# Anforderung hängt an einer Person} other {# Anforderungen hängen an einer Person}}",
  "match.result.riskViolatedMust": "{count, plural, one {# Muss verletzt} other {# Muss verletzt}}",
  "match.result.wishFitInfoAria": "Erklärung zur Gewichtung anzeigen",
  "match.result.wishFitInfoBody": "In der Powers Scorecard legst du fest, welche Powers dir wichtig sind (0–10). Die Zahl sagt, ob das Team genau dort über oder unter seinem eigenen Schnitt über alle 30 Powers liegt; Powers mit Gewichtung 0 zählen nicht mit. Eine Gewichtung ist keine Anforderung: sie lenkt die Auswahl, setzt aber keine Schwelle – deshalb gibt es hier kein Erfüllt und keine Lücke. Wer welche Power stark mitbringt, steht in „Top Powers“.",
  "match.result.wishFitInfoTitle": "Was hier verglichen wird",
  "match.result.wishFitPoolNote": "mehr gab der Kandidatenpool nicht her",
  "match.result.wishFitDelta": "{delta} gegenüber dem Schnitt über alle 30 Powers",
  "match.result.powersScorecardInTeam": "Team vs Powers Scorecard",
  "match.result.powersBasis": "Basis: {measured} von {total} Personen",
  "match.result.powersCoverageInfo": "Für {missing, plural, one {# Person} other {# Personen}} im Team liegt keine Power-Einschätzung vor. Alle Powers-Schnitte und -Zählungen laufen nur über die übrigen {measured}; wer fehlt, steht am Ende der Power-Scorecard-Matrix.",
  "match.result.powersCoverageInfoAria": "Erklärung zur Powers-Abdeckung anzeigen",
  "match.result.powersInTeam": "Powers im Team",
  "common.forbidden": "Dir fehlen die erforderlichen Berechtigungen für diese Aktion.",
  "common.forbiddenWithCode": "Dir fehlen die erforderlichen Berechtigungen für diese Aktion. (Fehlercode {code})",
  "service.page.imports.accountProvisioningHint": "Hinweis: Diese Importe erstellen oder aktualisieren Profile. Es werden keine Zugangsdaten angelegt – importierte Personen können sich danach nicht direkt anmelden.",
  "service.page.bulkYaml.actionDry": "Validieren",
  "service.page.bulkYaml.actionLabel": "Modus",
  "service.page.bulkYaml.actionReal": "Import",
  "service.page.bulkYaml.background": "Läuft im Hintergrund",
  "service.page.bulkYaml.batchDone": "Alle {n, number} Dateien sind hochgeladen. Die Verarbeitung läuft im Hintergrund - du kannst die Seite verlassen.",
  "service.page.bulkYaml.batchFailed": "Fehlgeschlagen",
  "service.page.bulkYaml.batchLimit": "Pro Stapel können höchstens {max, number} Dateien gestartet werden. Teile größere Auswahlen auf mehrere Stapel auf.",
  "service.page.bulkYaml.batchMixed": "Teilweise erfolgreich",
  "service.page.bulkYaml.batchPending": "Ausstehend",
  "service.page.bulkYaml.batchSuccess": "Erfolgreich",
  "service.page.bulkYaml.batchUploading": "Datei {n, number} wird hochgeladen … ({done, number} gestartet)",
  "service.page.bulkYaml.capacityRejected": "Die Datei konnte nicht gestartet werden, weil alle Importplätze belegt waren. Sie wurde noch nicht geprüft.",
  "service.page.bulkYaml.batchOpen": "Ergebnis anzeigen",
  "service.page.bulkYaml.batchHide": "Ergebnis ausblenden",
  "service.page.bulkYaml.hideYaml": "YAML ausblenden",
  "service.page.bulkYaml.showYaml": "YAML anzeigen",
  "service.page.bulkYaml.importBtnMany": "Import für {n, number} Dateien starten",
  "service.page.bulkYaml.startDryMany": "Validierung für {n, number} Dateien starten",
  "service.page.bulkYaml.completedAt": "Abgeschlossen am {date}",
  "service.page.bulkYaml.desc": "Importiere eine YAML-Datei mit mehreren Dokumenten oder lege ein PDF bzw. einen Lebenslauf zur Profil-Extraktion ab. Der Job läuft weiter, wenn du die Seite verlässt.",
  "service.page.bulkYaml.documentsFound": "{n, plural, one {# Dokument} other {# Dokumente}} gefunden",
  "service.page.bulkYaml.downloadSchema": "JSON-Schema herunterladen",
  "service.page.bulkYaml.downloadYaml": "YAML-Beispiel herunterladen",
  "service.page.bulkYaml.dryRunAtomicNote": "Eine Validierung erfasst immer die ganze Datei auf einmal. Einzelne Einheiten werden dabei nicht isoliert.",
  "service.page.bulkYaml.dryRunNoSave": "Es wurden keine Daten gespeichert. Die Transaktion wurde bewusst zurückgerollt.",
  "service.page.bulkYaml.dryRunSuccessTitle": "Validierung erfolgreich",
  "service.page.bulkYaml.dryRunSummary": "{n, plural, one {# Zeile} other {# Zeilen}} wären betroffen",
  "service.page.bulkYaml.extractionDone": "Extraktion abgeschlossen",
  "service.page.bulkYaml.extractionFailed": "Extraktion fehlgeschlagen.",
  "service.page.bulkYaml.extractionOpen": "Ergebnis öffnen",
  "service.page.bulkYaml.extractionResultHint": "Die extrahierten Powers und Skills stehen in deinem eigenen Profil.",
  "service.page.bulkYaml.extractionRunning": "Powers und Skills werden extrahiert …",
  "service.page.bulkYaml.failedPartial": "Import fehlgeschlagen. Bereits übernommene Einheiten wurden behalten.",
  "service.page.bulkYaml.forbidden": "Dir fehlen die Berechtigungen für den Import von Personendaten. Dafür brauchst du read:person und write:person zusätzlich zu write:reference-data.",
  "service.page.bulkYaml.formatKindLabel": "Dokumentart",
  "service.page.bulkYaml.formatLimits": "Format {version} · höchstens {docs, number} Dokumente pro Datei · Genesis-Formatlimit {size}.",
  "service.page.bulkYaml.formatLoadFailed": "Die Formatbeschreibung konnte nicht geladen werden.",
  "service.page.bulkYaml.formatLoading": "Format wird geladen …",
  "service.page.bulkYaml.formatTitle": "Format und Beispiele",
  "service.page.bulkYaml.formatUnavailable": "Der eingesetzte Importer beschreibt diese Art nicht.",
  "service.page.bulkYaml.formatUploadLimit": "Spark-Uploadlimit: {size} pro Datei. Größere Dateien werden vor dem Import abgewiesen.",
  "service.page.bulkYaml.hint": "YAML, PDF oder DOCX · jede Datei wird ein eigener Import-Job",
  "service.page.bulkYaml.importBtn": "Import starten",
  "service.page.bulkYaml.indexing": "Datei wird geprüft …",
  "service.page.bulkYaml.jobIdHint": "Job-ID, für den Support",
  "service.page.bulkYaml.leaveHint": "Du kannst diese Seite verlassen. Eine Benachrichtigung führt zurück zu diesem Ergebnis.",
  "service.page.bulkYaml.limitsNote": "Maximal {docs, number} Datensätze pro Import · bis zu {files, number} Dateien pro Stapel · höchstens {size} pro Datei.",
  "service.page.bulkYaml.limitsNoteSizeOnly": "Bis zu {files, number} Dateien pro Stapel · höchstens {size} pro Datei.",
  "service.page.bulkYaml.modeAllOrNothing": "Vollständig abbrechen",
  "service.page.bulkYaml.modeKeepSuccessful": "Erfolgreiche übernehmen",
  "service.page.bulkYaml.modeLabel": "Bei Fehlern",
  "service.page.bulkYaml.newRun": "Neue Datei auswählen",
  "service.page.bulkYaml.personActionsTitle": "Personen-Änderungen",
  "service.page.bulkYaml.personCreate": "Anlegen",
  "service.page.bulkYaml.personCreated": "Neues Profil angelegt",
  "service.page.bulkYaml.personWillBeCreated": "Neues Profil wird angelegt",
  "service.page.bulkYaml.personDelete": "Löschen",
  "service.page.bulkYaml.personExisting": "Bestehend",
  "service.page.bulkYaml.personIdGenerated": "Die UUID wird beim Import erzeugt.",
  "service.page.bulkYaml.personIdWasGenerated": "Die UUID wurde beim Import erzeugt.",
  "service.page.bulkYaml.personIncoming": "Import",
  "service.page.bulkYaml.personMismatchTitle": "Möglicherweise falsche Person-ID",
  "service.page.bulkYaml.personRestore": "Wiederherstellen",
  "service.page.bulkYaml.personRestoreResultText": "Das Profil wurde mit den in der YAML enthaltenen Daten wiederhergestellt. Nicht in der YAML enthaltene Daten wurden nicht wiederhergestellt.",
  "service.page.bulkYaml.personRestoreResultTitle": "Gelöschtes Profil wurde wiederhergestellt",
  "service.page.bulkYaml.personRestoreValidationText": "Diese UUID gehört zu einer gelöschten Person. Beim Import werden die in der YAML enthaltenen Profildaten wiederhergestellt. Nicht in der YAML enthaltene Daten werden nicht wiederhergestellt.",
  "service.page.bulkYaml.personRestoreValidationTitle": "Gelöschtes Profil wird wiederhergestellt",
  "service.page.bulkYaml.personRowLabel": "Person {n}: {action}",
  "service.page.bulkYaml.personUpdate": "Aktualisieren",
  "service.page.bulkYaml.personUpdated": "Bestehendes Profil aktualisiert",
  "service.page.bulkYaml.personWillBeUpdated": "Bestehendes Profil wird aktualisiert",
  "service.page.bulkYaml.personRestored": "Gelöschtes Profil wiederhergestellt",
  "service.page.bulkYaml.personDeleted": "Profil gelöscht",
  "service.page.bulkYaml.pipelineLabel": "Import-Schritte",
  "service.page.bulkYaml.progress": "{done} von {total} Dokumenten verarbeitet{kind, select, none {} other { · {kind}}}",
  "service.page.bulkYaml.queued": "Wartet auf Verarbeitung",
  "service.page.bulkYaml.rejectedTooLarge": "Zu groß (über {max} pro Datei): {names}",
  "service.page.bulkYaml.rejectedType": "Nicht unterstützter Dateityp ({names}). Nutze .yaml oder .yml.",
  "service.page.bulkYaml.retryBtn": "Datei korrigieren und erneut versuchen",
  "service.page.bulkYaml.retryFile": "Erneut versuchen",
  "service.page.bulkYaml.retrying": "Wird erneut versucht …",
  "service.page.bulkYaml.problemDependency": "Dieses Dokument wurde übersprungen, weil ein referenziertes Dokument fehlgeschlagen ist.",
  "service.page.bulkYaml.problemDependencyFix": "Behebe das zuerst fehlgeschlagene Dokument. Danach kann dieses abhängige Dokument automatisch importiert werden.",
  "service.page.bulkYaml.problemDocumentation": "Format- und Beispieldokumentation öffnen ↓",
  "service.page.bulkYaml.problemDuplicate": "Die ID oder ein anderer eindeutiger Wert existiert bereits.",
  "service.page.bulkYaml.problemDuplicateFix": "Nutze merge, um den Eintrag zu aktualisieren. Für einen neuen Eintrag lässt du die content.id des Dokuments weg oder vergibst eine neue.",
  "service.page.bulkYaml.problemFix": "So behebst du es",
  "service.page.bulkYaml.problemInvalidFormat": "Die YAML-Syntax oder Dokumentstruktur ist ungültig.",
  "service.page.bulkYaml.problemInvalidFormatFix": "Prüfe Einrückung, Dokumenthülle, Werttypen und Pflichtblöcke anhand eines Beispiels.",
  "service.page.bulkYaml.problemInvalidReference": "Ein referenzierter Eintrag wurde nicht gefunden.",
  "service.page.bulkYaml.problemInvalidReferenceValue": "Der referenzierte Eintrag „{value}“ wurde nicht gefunden.",
  "service.page.bulkYaml.problemInvalidReferenceFix": "Nutze die UUID eines vorhandenen Eintrags oder referenziere ein Dokument dieser Datei über dessen metadata.name.",
  "service.page.bulkYaml.problemInvalidValue": "Der Wert „{value}“ ist ungültig.",
  "service.page.bulkYaml.problemInvalidValueFix": "Nutze den dokumentierten Typ, die richtige Schreibweise und den erlaubten Wertebereich.",
  "service.page.bulkYaml.problemInvalidValueGeneric": "Ein Wert fehlt, ist ungültig oder liegt außerhalb des erlaubten Bereichs.",
  "service.page.bulkYaml.problemInvalidValueSuggestion": "Nutze stattdessen „{value}“.",
  "service.page.bulkYaml.problemLocation": "Im Dokument nahe Zeile {line}",
  "service.page.bulkYaml.problemLocationColumn": "Im Dokument nahe Zeile {line}, Spalte {column}",
  "service.page.bulkYaml.problemMissing": "Das Pflichtfeld „{field}“ fehlt.",
  "service.page.bulkYaml.problemMissingAlternative": "Mindestens eines dieser Felder ist erforderlich: {expected}.",
  "service.page.bulkYaml.problemMissingAlternativeFix": "Ergänze mindestens eines der aufgeführten Felder mit einem nicht leeren Wert.",
  "service.page.bulkYaml.problemMissingFix": "Ergänze das Feld mit einem Wert des in der Formatdokumentation angegebenen Typs.",
  "service.page.bulkYaml.problemPersistence": "Die Datenbank konnte dieses ansonsten gültige Dokument nicht speichern.",
  "service.page.bulkYaml.problemPersistenceFix": "Versuche es einmal erneut. Schlägt es wieder fehl, gib dem Support die oben angezeigte Job-ID.",
  "service.page.bulkYaml.problemUnexpected": "Der Import ist aus einem unerwarteten technischen Grund fehlgeschlagen.",
  "service.page.bulkYaml.problemUnexpectedFix": "Versuche es einmal erneut. Schlägt es wieder fehl, gib dem Support die oben angezeigte Job-ID.",
  "service.page.bulkYaml.problemUnknown": "Das Feld „{field}“ wird hier nicht unterstützt.",
  "service.page.bulkYaml.problemUnknownField": "ein Pflichtfeld",
  "service.page.bulkYaml.problemUnknownFix": "Benenne das Feld um oder entferne es und vergleiche das Dokument mit dem Formatbeispiel.",
  "service.page.bulkYaml.problemUnknownFixExpected": "Benenne es um oder entferne es. Unterstützte Felder sind unter anderem: {expected}.",
  "service.page.bulkYaml.problemUnsupported": "Diese Operation oder Feldänderung wird für diesen Dokumenttyp nicht unterstützt.",
  "service.page.bulkYaml.problemUnsupportedFix": "Nutze eine der für diesen Typ aufgeführten Operationen und lasse unveränderliche Felder unverändert.",
  "service.page.bulkYaml.problemWhat": "Was fehlt oder nicht stimmt",
  "service.page.bulkYaml.rolledBack": "Import fehlgeschlagen; alle Datenbankänderungen wurden zurückgerollt.",
  "service.page.bulkYaml.routeExtraction": "CV- und PDF-Extraktion",
  "service.page.bulkYaml.routeYaml": "YAML-Import",
  "service.page.bulkYaml.routingHint": "PDF- und DOCX-Dateien gehen an die Lebenslauf-Extraktion. Validierung und Teilimport gibt es nur für YAML.",
  "service.page.bulkYaml.runBadgeDry": "Validierung · {mode}",
  "service.page.bulkYaml.runBadgeReal": "Import · {mode}",
  "service.page.bulkYaml.stageFile": "Datei",
  "service.page.bulkYaml.stageImport": "Import",
  "service.page.bulkYaml.stageQueue": "Warteschlange",
  "service.page.bulkYaml.stageResult": "Ergebnis",
  "service.page.bulkYaml.startDry": "Validierung starten",
  "service.page.bulkYaml.starting": "Wird gestartet …",
  "service.page.bulkYaml.stepStateActive": "in Bearbeitung",
  "service.page.bulkYaml.stepStateDone": "abgeschlossen",
  "service.page.bulkYaml.stepStateFailed": "fehlgeschlagen",
  "service.page.bulkYaml.stepStatePending": "noch nicht gestartet",
  "service.page.bulkYaml.successTitle": "Import erfolgreich",
  "service.page.bulkYaml.summary": "{n, plural, one {# Zeile} other {# Zeilen}} betroffen",
  "service.page.bulkYaml.title": "Datei-Import",
  "service.page.bulkYaml.unitDeleteAria": "{id} löschen",
  "service.page.bulkYaml.unitDeletePersonMessage": "„{id}“ wird endgültig gelöscht, mit allen Profildaten. Das entfernt die ganze Person, nicht nur die importierten Änderungen.",
  "service.page.bulkYaml.unitDeletePersonTitle": "Person löschen?",
  "service.page.bulkYaml.unitDeleteSharedItemMessage": "„{id}“ wird endgültig gelöscht, mit allen Kommentaren. Das entfernt den ganzen Beitrag, nicht nur die importierten Änderungen.",
  "service.page.bulkYaml.unitDeleteSharedItemTitle": "Beitrag löschen?",
  "service.page.bulkYaml.unitDeleted": "Gelöscht",
  "service.page.bulkYaml.unitTechnicalId": "Technische ID",
  "service.page.bulkYaml.unitTechnicalIdAria": "Technische ID für {label} anzeigen",
  "service.page.bulkYaml.unitDependencyFailed": "Nicht versucht, weil eine benötigte Einheit nicht erfolgreich war.",
  "service.page.bulkYaml.unitDuplicate": "Dieser Eintrag existiert bereits. Nutze „merge“ statt „insert“, um ihn zu aktualisieren, oder lösche ihn vorher.",
  "service.page.bulkYaml.unitInvalidInput": "Das Dokument wurde abgelehnt: ungültige oder fehlende Werte.",
  "service.page.bulkYaml.unitInvalidReference": "Eine Referenz im Dokument existiert nicht.",
  "service.page.bulkYaml.unitPersistenceError": "Die Datenbank hat diesen Schreibvorgang abgelehnt.",
  "service.page.bulkYaml.unitUnexpectedError": "Unerwarteter Fehler beim Import dieser Einheit.",
  "service.page.bulkYaml.unitsFailed": "{n} fehlgeschlagen",
  "service.page.bulkYaml.unitsFailedGroup": "Fehlgeschlagene Einheiten",
  "service.page.bulkYaml.unitsSkipped": "{n} übersprungen",
  "service.page.bulkYaml.unitsSkippedGroup": "Übersprungene Einheiten",
  "service.page.bulkYaml.unitsSucceeded": "{n} erfolgreich",
  "service.page.bulkYaml.unitsSucceededGroup": "Erfolgreiche Einheiten",
  "service.page.bulkYaml.warningBlobCleanup": "{n, plural, one {# hochgeladene Datei konnte nicht wieder entfernt werden und bleibt gespeichert.} other {# hochgeladene Dateien konnten nicht wieder entfernt werden und bleiben gespeichert.}}",
  "service.page.bulkYaml.warningBlobCleanupHint": "Ein Operator kann sie anhand dieser Storage-IDs von Hand entfernen.",
  "service.page.bulkYaml.zone": "Ziehe YAML-, PDF- oder Lebenslauf-Dateien hierher oder klicke zum Hinzufügen",
  "service.page.cardYamlExportDesc": "Exportiert dein komplettes Profil inkl. Fotos und Dokumenten als YAML-Datei, die sich wieder importieren lässt.",
  "service.page.cardYamlExportTitle": "Profil-Export",
  "service.yamlExport.documents": "Documents",
  "service.yamlExport.documentsDesc": "Dokumentenordner und Dateien mit Metadaten, Tags und Dateiinhalten. Ohne Profil muss die Person beim Import bereits existieren.",
  "service.yamlExport.download": "YAML herunterladen",
  "service.yamlExport.exporting": "Export wird erstellt…",
  "service.yamlExport.intro": "Wähle aus, welche Bereiche der Export enthalten soll. Die heruntergeladene Datei kannst du mit dem YAML-Importer wieder importieren.",
  "service.yamlExport.profile": "Profil",
  "service.yamlExport.profileDesc": "Persönliche Daten, Profilbilder, Berufserfahrung, Ausbildung, Fachwissen, Sprachen und Zertifikate",
  "service.yamlExport.selectionRequired": "Wähle mindestens einen Bereich aus.",
  "service.yamlExport.title": "YAML-Export",
  "admin.groupLimitReached": "Sie haben die maximale Anzahl von {limit} Gruppen erreicht.",
  "admin.groupSaveFailed": "Die Gruppe konnte nicht gespeichert werden.",
  "service.page.bulkYaml.personMismatchText": "Name und primäre E-Mail unterscheiden sich beide von der gespeicherten Person. Der Import aktualisiert die bestehende Person mit dieser UUID.",
  "service.page.bulkYaml.personMismatchNotice": "{n, plural, one {Beim Import wird die bestehende Person mit dieser UUID aktualisiert. Falls das nicht gewollt ist, korrigiere vorher die UUID in der Datei.} other {Beim Import werden die bestehenden Personen mit diesen UUIDs aktualisiert. Falls das nicht gewollt ist, korrigiere vorher die UUIDs in der Datei.}}",
  "service.page.bulkYaml.personRestoreNotice": "{n, plural, one {Beim Import wird dieses gelöschte Profil wiederhergestellt. Falls das nicht gewollt ist, entferne vorher die UUID aus der Datei.} other {Beim Import werden diese gelöschten Profile wiederhergestellt. Falls das nicht gewollt ist, entferne vorher die UUIDs aus der Datei.}}",
  "service.page.bulkYaml.personRiskNotice": "Beim Import werden die gezeigten Aktualisierungen angewendet und die gelöschten Profile wiederhergestellt. Falls das nicht gewollt ist, korrigiere vorher die UUIDs in der Datei.",
  "match.result.requirementDiagram.axisFulfilled": "Erfüllt ↑",
  "match.result.requirementDiagram.axisUnfulfilled": "Nicht erfüllt ↓",
  "match.result.requirementDiagram.ruleAll": "alle",
  "match.result.requirementDiagram.ruleAny": "mind. 1",
  "match.result.requirementDiagram.ruleMin": "mind. {n}",
  "match.result.requirementDiagram.ruleMinUnknown": "mind. ?",
  "match.result.requirementDiagram.ruleMax": "höchstens {n}",
  "match.result.requirementDiagram.ruleMaxUnknown": "höchstens ?",
  "match.result.requirementDiagram.ruleExact": "genau {n}",
  "match.result.requirementDiagram.ruleExactUnknown": "genau ?",
  "match.result.requirementDiagram.personLevel": "Stufe: {level}",
  "match.result.requirementDiagram.closeLabel": "Knapp",
  "match.result.requirementDiagram.noContributors": "Niemand im Team trägt das bei.",
  "company.admin.logo.changeHover": "Logo ändern",
  "organizationalRecord.heading": "Organisationsakte",
  "organizationalRecord.description": "Interne Dokumente und Diskussionen der Organisation zu dieser Person.",
  "organizationalRecord.documents": "Dokumente",
  "organizationalRecord.entries": "Notizen & Berichte",
  "organizationalRecord.discussion": "Allgemeine Diskussion",
  "organizationalRecord.noAccess": "Für diesen Bereich benötigst du die Organisationsrolle Manager/HR.",
  "organizationalRecord.backToProfile": "Zum Profil",
  "organizationalRecord.empty": "Für diese Person wurde noch keine Organisationsakte angelegt.",
  "organizationalRecord.create": "Organisationsakte anlegen",
  "organizationalRecord.newEntry": "Notiz / Bericht anlegen",
  "organizationalRecord.editEntry": "Eintrag bearbeiten",
  "organizationalRecord.note": "Notiz",
  "organizationalRecord.report": "Bericht",
  "organizationalRecord.kind": "Art",
  "organizationalRecord.titleField": "Titel",
  "organizationalRecord.contentField": "Inhalt",
  "organizationalRecord.noEntries": "Noch keine Notizen oder Berichte.",
  "organizationalRecord.updated": "Bearbeitet von {name} am {date}",
  "organizationalRecord.deleteEntry": "Eintrag löschen?",
  "organizationalRecord.deleteEntryHelp": "Die Kommentare zu diesem Eintrag werden ebenfalls gelöscht.",
  "organizationalRecord.upload": "Dokument hochladen",
  "organizationalRecord.uploadHelp": "PDF, Office, Text oder Bilder · maximal 10 MB pro Datei",
  "organizationalRecord.uploadRejected": "Bitte wähle eine unterstützte, nicht leere Datei mit maximal 10 MB.",
  "organizationalRecord.noDocuments": "Noch keine Dokumente.",
  "organizationalRecord.preview": "Vorschau",
  "organizationalRecord.download": "Herunterladen",
  "organizationalRecord.rename": "Umbenennen",
  "organizationalRecord.deleteDocument": "Dokument löschen?",
  "organizationalRecord.documentsHint": "Dokumente in der Organisationsakte dieser Person.",
  "organizationalRecord.links.label": "Verknüpft",
  "organizationalRecord.links.add": "{title} verknüpfen ({kind})",
  "organizationalRecord.links.select": "Dokument oder Eintrag verknüpfen",
  "organizationalRecord.links.remove": "Verknüpfung zu {title} entfernen",
  "organizationalRecord.links.search": "Dokumente und Einträge dieser Organisationsakte suchen …",
  "organizationalRecord.links.noMatches": "Keine passenden Dokumente oder Einträge.",
  "organizationalRecord.links.usedIn": "Verwendet in",
  "organizationalRecord.links.comment": "Diskussionskommentar",
  "organizationalRecord.links.unused": "Noch keine Verweise auf diesen Inhalt.",
  "organizationalRecord.links.details": "Details & Verknüpfungen",
  "organizationalRecord.links.unavailable": "Dieser Inhalt ist in dieser Organisationsakte nicht mehr verfügbar.",
  "organizationalRecord.links.downloaded": "Die Datei wurde heruntergeladen, da dieses Format keine Vorschau unterstützt.",
  "organizationalRecord.drafts.invalid": "Vervollständige Titel und Inhalt deiner Notizen oder Berichte und prüfe die Textlänge. Kommentare benötigen Text (bis zu 4.096 Zeichen); Notizen und Berichte erlauben 255 Zeichen im Titel und 65.535 im Inhalt.",
  "organizationalRecord.drafts.discardEntry": "Die ungespeicherten Änderungen an dieser Notiz oder diesem Bericht einschließlich der Verlinkungen verwerfen?",
  "organizationalRecord.comments.newest": "Neueste zuerst",
  "organizationalRecord.comments.oldest": "Älteste zuerst"
}
